/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.0.11.0 (NJsonSchema v9.13.13.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class HealthCheckClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    healthCheck(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck(_response);
        });
    }

    protected processHealthCheck(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb(_response);
        });
    }

    protected processHealthCheckDb(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck2(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/authentication/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck2(_response);
        });
    }

    protected processHealthCheck2(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb2(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/authentication/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb2(_response);
        });
    }

    protected processHealthCheckDb2(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck3(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/cartography/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck3(_response);
        });
    }

    protected processHealthCheck3(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb3(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/cartography/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb3(_response);
        });
    }

    protected processHealthCheckDb3(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck4(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/geolocation/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck4(_response);
        });
    }

    protected processHealthCheck4(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb4(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/geolocation/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb4(_response);
        });
    }

    protected processHealthCheckDb4(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck5(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/resources/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck5(_response);
        });
    }

    protected processHealthCheck5(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb5(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/resources/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb5(_response);
        });
    }

    protected processHealthCheckDb5(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck6(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/navigation/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck6(_response);
        });
    }

    protected processHealthCheck6(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb6(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/navigation/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb6(_response);
        });
    }

    protected processHealthCheckDb6(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck7(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/missions/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck7(_response);
        });
    }

    protected processHealthCheck7(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb7(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/missions/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb7(_response);
        });
    }

    protected processHealthCheckDb7(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck8(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/units/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck8(_response);
        });
    }

    protected processHealthCheck8(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb8(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/units/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb8(_response);
        });
    }

    protected processHealthCheckDb8(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck9(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/videomanager/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck9(_response);
        });
    }

    protected processHealthCheck9(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb9(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/videomanager/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb9(_response);
        });
    }

    protected processHealthCheckDb9(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck10(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/alarms/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck10(_response);
        });
    }

    protected processHealthCheck10(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb10(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/alarms/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb10(_response);
        });
    }

    protected processHealthCheckDb10(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck11(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/voip/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck11(_response);
        });
    }

    protected processHealthCheck11(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb11(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/voip/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb11(_response);
        });
    }

    protected processHealthCheckDb11(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck12(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/accesscontrol/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck12(_response);
        });
    }

    protected processHealthCheck12(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb12(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/accesscontrol/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb12(_response);
        });
    }

    protected processHealthCheckDb12(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck13(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/flow/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck13(_response);
        });
    }

    protected processHealthCheck13(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb13(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/flow/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb13(_response);
        });
    }

    protected processHealthCheckDb13(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck14(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/tasks/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck14(_response);
        });
    }

    protected processHealthCheck14(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb14(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/tasks/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb14(_response);
        });
    }

    protected processHealthCheckDb14(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck15(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/license/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck15(_response);
        });
    }

    protected processHealthCheck15(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb15(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/license/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb15(_response);
        });
    }

    protected processHealthCheckDb15(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck16(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/variablemessagesigns/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck16(_response);
        });
    }

    protected processHealthCheck16(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb16(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/variablemessagesigns/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb16(_response);
        });
    }

    protected processHealthCheckDb16(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck17(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/sip/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck17(_response);
        });
    }

    protected processHealthCheck17(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb17(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/sip/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb17(_response);
        });
    }

    protected processHealthCheckDb17(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck18(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/notifications/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck18(_response);
        });
    }

    protected processHealthCheck18(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb18(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/notifications/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb18(_response);
        });
    }

    protected processHealthCheckDb18(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheck19(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/connectors/api/HealthCheck/healthcheck?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck19(_response);
        });
    }

    protected processHealthCheck19(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    healthCheckDb19(sizeMb: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/connectors/api/HealthCheck/healthcheckdb?";
        if (sizeMb !== undefined)
            url_ += "sizeMb=" + encodeURIComponent("" + sizeMb) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckDb19(_response);
        });
    }

    protected processHealthCheckDb19(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class AuthorizationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all authorizations that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Authorizations successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Authorization[]> {
        let url_ = this.baseUrl + "/authentication/api/Authorization?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Authorization[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Authorization.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Authorization[]>(<any>null);
    }

    /**
     * Allow you to delete all authorizations that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Authorizations are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/authentication/api/Authorization?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the authorization that match the id you have specified
     * @param authorization (optional) 
     * @return Authorization successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Authorization> {
        let url_ = this.baseUrl + "/authentication/api/Authorization/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Authorization> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Authorization.fromJS(resultData200) : new Authorization();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Authorization>(<any>null);
    }

    /**
     * Allow you to update an authorization.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Authorization successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/authentication/api/Authorization/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an authorization.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/authentication/api/Authorization/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/authentication/api/Authorization/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class GroupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all groups that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Groups successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Group[]> {
        let url_ = this.baseUrl + "/authentication/api/Group?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Group[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Group.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group[]>(<any>null);
    }

    /**
     * Allow you to create an new group entity
     * @param authorization (optional) 
     * @param entity Group entity to be added to the database
     * @return Group successfully created.
     */
    post(authorization: string | null | undefined, entity: Group): Promise<Group> {
        let url_ = this.baseUrl + "/authentication/api/Group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Group> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Group.fromJS(resultData201) : new Group();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group>(<any>null);
    }

    /**
     * Allow you to delete all groups that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Groups are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/authentication/api/Group?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the group that match the id you have specified
     * @param authorization (optional) 
     * @return Group successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Group> {
        let url_ = this.baseUrl + "/authentication/api/Group/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Group> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Group.fromJS(resultData200) : new Group();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group>(<any>null);
    }

    /**
     * Allow you to create or replace a group, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Group entity to be added to the database
     * @return Group successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Group): Promise<Group> {
        let url_ = this.baseUrl + "/authentication/api/Group/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Group> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Group.fromJS(resultData201) : new Group();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group>(<any>null);
    }

    /**
     * Allow you to update a group.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Group successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/authentication/api/Group/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete a group.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/authentication/api/Group/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/authentication/api/Group/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class PassportConfigurationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<PassportConfiguration[]> {
        let url_ = this.baseUrl + "/authentication/api/PassportConfiguration?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<PassportConfiguration[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PassportConfiguration.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassportConfiguration[]>(<any>null);
    }

    post(authorization: string | null | undefined, entity: PassportConfiguration): Promise<PassportConfiguration> {
        let url_ = this.baseUrl + "/authentication/api/PassportConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<PassportConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? PassportConfiguration.fromJS(resultData201) : new PassportConfiguration();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassportConfiguration>(<any>null);
    }

    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/authentication/api/PassportConfiguration?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    get(id: string | null, authorization: string | null | undefined): Promise<PassportConfiguration> {
        let url_ = this.baseUrl + "/authentication/api/PassportConfiguration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PassportConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PassportConfiguration.fromJS(resultData200) : new PassportConfiguration();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassportConfiguration>(<any>null);
    }

    put(id: string | null, authorization: string | null | undefined, entity: PassportConfiguration): Promise<PassportConfiguration> {
        let url_ = this.baseUrl + "/authentication/api/PassportConfiguration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<PassportConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? PassportConfiguration.fromJS(resultData201) : new PassportConfiguration();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassportConfiguration>(<any>null);
    }

    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/authentication/api/PassportConfiguration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/authentication/api/PassportConfiguration/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/authentication/api/PassportConfiguration/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class PassportClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve the passport that is associated with the token you have provided.
     * @param authorization (optional) 
     * @return Passport successfully retrieved.
     */
    getMine(authorization: string | null | undefined): Promise<Passport> {
        let url_ = this.baseUrl + "/authentication/api/Passport/myself";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMine(_response);
        });
    }

    protected processGetMine(response: Response): Promise<Passport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Passport.fromJS(resultData200) : new Passport();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Passport>(<any>null);
    }

    /**
     * Retrieve all passports that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Passports successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Passport[]> {
        let url_ = this.baseUrl + "/authentication/api/Passport?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Passport[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Passport.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Passport[]>(<any>null);
    }

    /**
     * Allow you to create a new passport entity
     * @param authorization (optional) 
     * @param entity Passport entity to be added to the database
     * @return Passport successfully created.
     */
    post(authorization: string | null | undefined, entity: Passport): Promise<Passport> {
        let url_ = this.baseUrl + "/authentication/api/Passport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Passport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Passport.fromJS(resultData201) : new Passport();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Passport>(<any>null);
    }

    /**
     * Allow you to delete all passports that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Passports are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/authentication/api/Passport?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the passport that match the id you have specified
     * @param authorization (optional) 
     * @return Passport successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Passport> {
        let url_ = this.baseUrl + "/authentication/api/Passport/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Passport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Passport.fromJS(resultData200) : new Passport();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Passport>(<any>null);
    }

    /**
     * Allow you to create or replace a passport, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Passport entity to be added to the database
     * @return Passport successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Passport): Promise<Passport> {
        let url_ = this.baseUrl + "/authentication/api/Passport/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Passport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Passport.fromJS(resultData201) : new Passport();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Passport>(<any>null);
    }

    /**
     * Allow you to update a passport.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Passport successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/authentication/api/Passport/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete a passport.
     * @param authorization (optional) 
     * @param reason (optional) 
     * @return Passport sucesfully deleted or no content exist at this id.
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/authentication/api/Passport/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Allow you to add authorizations to a passport.
     * @param authorization (optional) 
     * @param passportId The identifier of the passport in which this authorization must be displayed.
     * @param entity Authorization entity to be added to the database
     * @return Authorization was succesfully added to passport.
     */
    postAuthorization(authorization: string | null | undefined, passportId: string | null, entity: Authorization): Promise<Authorization> {
        let url_ = this.baseUrl + "/authentication/api/Passport/{passportId}/Authorization";
        if (passportId === undefined || passportId === null)
            throw new Error("The parameter 'passportId' must be defined.");
        url_ = url_.replace("{passportId}", encodeURIComponent("" + passportId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostAuthorization(_response);
        });
    }

    protected processPostAuthorization(response: Response): Promise<Authorization> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Authorization.fromJS(resultData201) : new Authorization();
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Authorization>(<any>null);
    }

    /**
     * Retrieve the authorizations from the specified passport.
     * @param passportId the identifier of the passport from which you want to retrieve the authorizations.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Authorizations succesfully retrieved.
     */
    getAuthorizations(passportId: string | null, authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Authorization[]> {
        let url_ = this.baseUrl + "/authentication/api/Passport/{passportId}/Authorization?";
        if (passportId === undefined || passportId === null)
            throw new Error("The parameter 'passportId' must be defined.");
        url_ = url_.replace("{passportId}", encodeURIComponent("" + passportId)); 
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuthorizations(_response);
        });
    }

    protected processGetAuthorizations(response: Response): Promise<Authorization[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Authorization.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Authorization[]>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/authentication/api/Passport/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class RoleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all roles that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Roles successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Role[]> {
        let url_ = this.baseUrl + "/authentication/api/Role?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Role[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Role.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role[]>(<any>null);
    }

    /**
     * Allow you to create a new role entity
     * @param authorization (optional) 
     * @param entity Role entity to be added to the database
     * @return Role successfully created.
     */
    post(authorization: string | null | undefined, entity: Role): Promise<Role> {
        let url_ = this.baseUrl + "/authentication/api/Role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Role> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Role.fromJS(resultData201) : new Role();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role>(<any>null);
    }

    /**
     * Allow you to delete all roles that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Roles are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/authentication/api/Role?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the role that match the id you have specified
     * @param authorization (optional) 
     * @return Role successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Role> {
        let url_ = this.baseUrl + "/authentication/api/Role/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Role> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Role.fromJS(resultData200) : new Role();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role>(<any>null);
    }

    /**
     * Allow you to create or replace a role, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Role entity to be added to the database
     * @return Role successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Role): Promise<Role> {
        let url_ = this.baseUrl + "/authentication/api/Role/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Role> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Role.fromJS(resultData201) : new Role();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role>(<any>null);
    }

    /**
     * Allow you to update a role.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Role successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/authentication/api/Role/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete a role.
     * @param authorization (optional) 
     * @param reason (optional) 
     * @return Role sucesfully deleted or no content exist at this id.
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/authentication/api/Role/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Allow you to add authorizations to a role.
     * @param authorization (optional) 
     * @param roleId The identifier of the role in which this authorization must be displayed.
     * @param entity Authorization entity to be added to the database
     * @return Authorization was succesfully added to role.
     */
    postAuthorization(authorization: string | null | undefined, roleId: string | null, entity: Authorization): Promise<Authorization> {
        let url_ = this.baseUrl + "/authentication/api/Role/{roleId}/Authorization";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostAuthorization(_response);
        });
    }

    protected processPostAuthorization(response: Response): Promise<Authorization> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Authorization.fromJS(resultData201) : new Authorization();
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Authorization>(<any>null);
    }

    /**
     * Retrieve the authorizations from the specified role.
     * @param roleId the identifier of the role from which you want to retrieve the authorizations.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Authorizations succesfully retrieved.
     */
    getAuthorizations(roleId: string | null, authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Authorization[]> {
        let url_ = this.baseUrl + "/authentication/api/Role/{roleId}/Authorization?";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId)); 
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuthorizations(_response);
        });
    }

    protected processGetAuthorizations(response: Response): Promise<Authorization[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Authorization.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Authorization[]>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/authentication/api/Role/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class RoleTemplateClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all role templates that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return RoleTemplates successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<RoleTemplate[]> {
        let url_ = this.baseUrl + "/authentication/api/RoleTemplate?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<RoleTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RoleTemplate.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleTemplate[]>(<any>null);
    }

    /**
     * Allow you to create a new role template entity
     * @param authorization (optional) 
     * @param entity RoleTemplate entity to be added to the database
     * @return RoleTemplate successfully created.
     */
    post(authorization: string | null | undefined, entity: RoleTemplate): Promise<RoleTemplate> {
        let url_ = this.baseUrl + "/authentication/api/RoleTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<RoleTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? RoleTemplate.fromJS(resultData201) : new RoleTemplate();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleTemplate>(<any>null);
    }

    /**
     * Allow you to delete all role templates that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return RoleTemplates are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/authentication/api/RoleTemplate?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the role template that match the id you have specified
     * @param authorization (optional) 
     * @return RoleTemplate successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<RoleTemplate> {
        let url_ = this.baseUrl + "/authentication/api/RoleTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<RoleTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RoleTemplate.fromJS(resultData200) : new RoleTemplate();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleTemplate>(<any>null);
    }

    /**
     * Allow you to create or replace a role template, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity RoleTemplate entity to be added to the database
     * @return RoleTemplate successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: RoleTemplate): Promise<RoleTemplate> {
        let url_ = this.baseUrl + "/authentication/api/RoleTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<RoleTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? RoleTemplate.fromJS(resultData201) : new RoleTemplate();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleTemplate>(<any>null);
    }

    /**
     * Allow you to update a role template.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return RoleTemplate successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/authentication/api/RoleTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete a role template.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/authentication/api/RoleTemplate/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Allow you to create a new role entity from a specified template.
     * @param authorization (optional) 
     * @param roleTemplateId Role template to be used to create the new role
     * @param group (optional) Group that this new role will have access to
     * @param entity RoleTemplate entity to be added to the database
     * @return Role successfully created.
     */
    post2(authorization: string | null | undefined, roleTemplateId: string | null, group: string | null | undefined, entity: Role): Promise<Role> {
        let url_ = this.baseUrl + "/authentication/api/RoleTemplate/{roleTemplateId}/Role?";
        if (roleTemplateId === undefined || roleTemplateId === null)
            throw new Error("The parameter 'roleTemplateId' must be defined.");
        url_ = url_.replace("{roleTemplateId}", encodeURIComponent("" + roleTemplateId)); 
        if (group !== undefined)
            url_ += "group=" + encodeURIComponent("" + group) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost2(_response);
        });
    }

    protected processPost2(response: Response): Promise<Role> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Role.fromJS(resultData201) : new Role();
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/authentication/api/RoleTemplate/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class SaltClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve the current salt used to create and validate authentication tokens.
     * @param authorization (optional) 
     * @return Salt succesfully retrieved
     */
    get(authorization: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/authentication/api/Salt";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * Modify the currently used salt, will invalidate all existing authentication tokens.
     * @param authorization (optional) 
     * @return Salt succesfully updated.
     */
    patch(authorization: string | null | undefined, patch: string): Promise<SaltChanged> {
        let url_ = this.baseUrl + "/authentication/api/Salt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<SaltChanged> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaltChanged.fromJS(resultData200) : new SaltChanged();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaltChanged>(<any>null);
    }
}

export class SigninClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Use this route to signin with credentials and retrieve your session token that is required to do API calls
     * @param username (optional) 
     * @param password (optional) 
     * @return Signin success.
     */
    signin(username: string | null | undefined, password: string | null | undefined): Promise<SigninResponse> {
        let url_ = this.baseUrl + "/authentication/api/signin?";
        if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&"; 
        if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignin(_response);
        });
    }

    protected processSignin(response: Response): Promise<SigninResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SigninResponse.fromJS(resultData200) : new SigninResponse();
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SigninResponse>(<any>null);
    }

    /**
     * Use this route to signin with an access key and retrieve your session token that is required to do API calls
     * @param accessKey (optional) 
     * @return Signin success.
     */
    signinFromAccessKey(accessKey: string | null | undefined): Promise<SigninResponse> {
        let url_ = this.baseUrl + "/authentication/api/signinFromAccessKey?";
        if (accessKey !== undefined)
            url_ += "accessKey=" + encodeURIComponent("" + accessKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSigninFromAccessKey(_response);
        });
    }

    protected processSigninFromAccessKey(response: Response): Promise<SigninResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SigninResponse.fromJS(resultData200) : new SigninResponse();
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SigninResponse>(<any>null);
    }
}

export class MapClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve and download the binary data associated to a map.
     * @param authorization (optional) 
     * @return Binary data of the map succesfully retrieved
     */
    download(authorization: string | null | undefined, id: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/cartography/api/Map/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Allow you to add a new map and upload it's unity package as binary data.
     * @param authorization (optional) 
     * @param name (optional) Name of the map.
     * @param manifest_Origin_Latitude (optional) Represents the latitude part of the coordinate in decimal degrees WGS84.
     * @param manifest_Origin_Longitude (optional) Represents the longitude part of the coordinate in decimal degrees WGS84.
     * @param manifest_Origin_Altitude (optional) Represents the altitude part of the coordinate, as meters above ground.
     * @param manifest_Scale (optional) Scale ratio of the map, scale of 1 means 1 unity unit equals to 1 meters.
     * @param manifest_BoundingBox_North (optional) North latitude coordinate.
     * @param manifest_BoundingBox_West (optional) West longitude coordinate.
     * @param manifest_BoundingBox_South (optional) South latitude coordinate.
     * @param manifest_BoundingBox_East (optional) East longitude coordinate.
     * @param manifest_ZoomLevel (optional) Zoom level at which this map should be displayed.
     * @param file (optional) Unity package to be uploaded
     * @return Map succesfully created.
     */
    upload(authorization: string | null | undefined, name: string | null | undefined, manifest_Origin_Latitude: number | undefined, manifest_Origin_Longitude: number | undefined, manifest_Origin_Altitude: number | undefined, manifest_Scale: number | undefined, manifest_BoundingBox_North: number | undefined, manifest_BoundingBox_West: number | undefined, manifest_BoundingBox_South: number | undefined, manifest_BoundingBox_East: number | undefined, manifest_ZoomLevel: number | undefined, file: FileParameter | null | undefined): Promise<Map> {
        let url_ = this.baseUrl + "/cartography/api/Map";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (manifest_Origin_Latitude === null || manifest_Origin_Latitude === undefined)
            throw new Error("The parameter 'manifest_Origin_Latitude' cannot be null.");
        else
            content_.append("Manifest.Origin.Latitude", manifest_Origin_Latitude.toString());
        if (manifest_Origin_Longitude === null || manifest_Origin_Longitude === undefined)
            throw new Error("The parameter 'manifest_Origin_Longitude' cannot be null.");
        else
            content_.append("Manifest.Origin.Longitude", manifest_Origin_Longitude.toString());
        if (manifest_Origin_Altitude === null || manifest_Origin_Altitude === undefined)
            throw new Error("The parameter 'manifest_Origin_Altitude' cannot be null.");
        else
            content_.append("Manifest.Origin.Altitude", manifest_Origin_Altitude.toString());
        if (manifest_Scale === null || manifest_Scale === undefined)
            throw new Error("The parameter 'manifest_Scale' cannot be null.");
        else
            content_.append("Manifest.Scale", manifest_Scale.toString());
        if (manifest_BoundingBox_North === null || manifest_BoundingBox_North === undefined)
            throw new Error("The parameter 'manifest_BoundingBox_North' cannot be null.");
        else
            content_.append("Manifest.BoundingBox.North", manifest_BoundingBox_North.toString());
        if (manifest_BoundingBox_West === null || manifest_BoundingBox_West === undefined)
            throw new Error("The parameter 'manifest_BoundingBox_West' cannot be null.");
        else
            content_.append("Manifest.BoundingBox.West", manifest_BoundingBox_West.toString());
        if (manifest_BoundingBox_South === null || manifest_BoundingBox_South === undefined)
            throw new Error("The parameter 'manifest_BoundingBox_South' cannot be null.");
        else
            content_.append("Manifest.BoundingBox.South", manifest_BoundingBox_South.toString());
        if (manifest_BoundingBox_East === null || manifest_BoundingBox_East === undefined)
            throw new Error("The parameter 'manifest_BoundingBox_East' cannot be null.");
        else
            content_.append("Manifest.BoundingBox.East", manifest_BoundingBox_East.toString());
        if (manifest_ZoomLevel === null || manifest_ZoomLevel === undefined)
            throw new Error("The parameter 'manifest_ZoomLevel' cannot be null.");
        else
            content_.append("Manifest.ZoomLevel", manifest_ZoomLevel.toString());
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<Map> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Map.fromJS(resultData201) : new Map();
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Map>(<any>null);
    }

    /**
     * Retrieve all maps that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Maps successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Map[]> {
        let url_ = this.baseUrl + "/cartography/api/Map?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Map[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Map.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Map[]>(<any>null);
    }

    /**
     * Allow you to delete all maps that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Maps are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/cartography/api/Map?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the map that match the id you have specified
     * @param authorization (optional) 
     * @return Map successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Map> {
        let url_ = this.baseUrl + "/cartography/api/Map/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Map> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Map.fromJS(resultData200) : new Map();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Map>(<any>null);
    }

    /**
     * Allow you to create or replace a map, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Map entity to be added to the database
     * @return Map successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Map): Promise<Map> {
        let url_ = this.baseUrl + "/cartography/api/Map/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Map> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Map.fromJS(resultData201) : new Map();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Map>(<any>null);
    }

    /**
     * Allow you to update an map.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Map successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/cartography/api/Map/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an map.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/cartography/api/Map/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/cartography/api/Map/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class PointOfViewClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all pointOfViews that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return PointOfViews successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<PointOfView[]> {
        let url_ = this.baseUrl + "/cartography/api/PointOfView?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<PointOfView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PointOfView.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PointOfView[]>(<any>null);
    }

    /**
     * Allow you to create an new pointOfView entity
     * @param authorization (optional) 
     * @param entity PointOfView entity to be added to the database
     * @return PointOfView successfully created.
     */
    post(authorization: string | null | undefined, entity: PointOfView): Promise<PointOfView> {
        let url_ = this.baseUrl + "/cartography/api/PointOfView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<PointOfView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? PointOfView.fromJS(resultData201) : new PointOfView();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PointOfView>(<any>null);
    }

    /**
     * Allow you to delete all pointOfViews that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return PointOfViews are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/cartography/api/PointOfView?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the pointOfView that match the id you have specified
     * @param authorization (optional) 
     * @return PointOfView successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<PointOfView> {
        let url_ = this.baseUrl + "/cartography/api/PointOfView/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PointOfView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PointOfView.fromJS(resultData200) : new PointOfView();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PointOfView>(<any>null);
    }

    /**
     * Allow you to create or replace a pointOfView, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity PointOfView entity to be added to the database
     * @return PointOfView successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: PointOfView): Promise<PointOfView> {
        let url_ = this.baseUrl + "/cartography/api/PointOfView/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<PointOfView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? PointOfView.fromJS(resultData201) : new PointOfView();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PointOfView>(<any>null);
    }

    /**
     * Allow you to update an pointOfView.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return PointOfView successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/cartography/api/PointOfView/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an pointOfView.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/cartography/api/PointOfView/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/cartography/api/PointOfView/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class MarkerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all markers that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Markers successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Marker[]> {
        let url_ = this.baseUrl + "/geolocation/api/Marker?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Marker[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Marker.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Marker[]>(<any>null);
    }

    /**
     * Allow you to create an new marker entity
     * @param authorization (optional) 
     * @param entity Marker entity to be added to the database
     * @return Marker successfully created.
     */
    post(authorization: string | null | undefined, entity: Marker): Promise<Marker> {
        let url_ = this.baseUrl + "/geolocation/api/Marker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Marker> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Marker.fromJS(resultData201) : new Marker();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Marker>(<any>null);
    }

    /**
     * Allow you to delete all markers that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Markers are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/Marker?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the marker that match the id you have specified
     * @param authorization (optional) 
     * @return Marker successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Marker> {
        let url_ = this.baseUrl + "/geolocation/api/Marker/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Marker> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Marker.fromJS(resultData200) : new Marker();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Marker>(<any>null);
    }

    /**
     * Allow you to create or replace a marker, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Marker entity to be added to the database
     * @return Marker successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Marker): Promise<Marker> {
        let url_ = this.baseUrl + "/geolocation/api/Marker/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Marker> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Marker.fromJS(resultData201) : new Marker();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Marker>(<any>null);
    }

    /**
     * Allow you to update an marker.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Marker successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/geolocation/api/Marker/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an marker.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/Marker/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/geolocation/api/Marker/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class DrawingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all drawings that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Drawings successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Drawing[]> {
        let url_ = this.baseUrl + "/geolocation/api/Drawing?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Drawing[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Drawing.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Drawing[]>(<any>null);
    }

    /**
     * Allow you to create an new drawing entity
     * @param authorization (optional) 
     * @param entity Drawing entity to be added to the database
     * @return Drawing successfully created.
     */
    post(authorization: string | null | undefined, entity: Drawing): Promise<Drawing> {
        let url_ = this.baseUrl + "/geolocation/api/Drawing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Drawing> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Drawing.fromJS(resultData201) : new Drawing();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Drawing>(<any>null);
    }

    /**
     * Allow you to delete all drawings that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Drawings are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/Drawing?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the drawing that match the id you have specified
     * @param authorization (optional) 
     * @return Drawing successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Drawing> {
        let url_ = this.baseUrl + "/geolocation/api/Drawing/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Drawing> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Drawing.fromJS(resultData200) : new Drawing();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Drawing>(<any>null);
    }

    /**
     * Allow you to create or replace a drawing, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Drawing entity to be added to the database
     * @return Drawing successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Drawing): Promise<Drawing> {
        let url_ = this.baseUrl + "/geolocation/api/Drawing/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Drawing> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Drawing.fromJS(resultData201) : new Drawing();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Drawing>(<any>null);
    }

    /**
     * Allow you to update an drawing.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Drawing successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/geolocation/api/Drawing/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an drawing.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/Drawing/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve and download the binary data associated to a drawing.
     * @param authorization (optional) 
     * @return Binary data of the drawing succesfully retrieved
     */
    downloadDrawing(id: string | null, authorization: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/geolocation/api/Drawing/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadDrawing(_response);
        });
    }

    protected processDownloadDrawing(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Upload binary data to the specified drawing.
     * @param authorization (optional) 
     * @param file (optional) File to be added to the attachment.
     * @return Binary data sucessfully uploaded to the attachment.
     */
    uploadDrawing(authorization: string | null | undefined, id: string | null, file: FileParameter | null | undefined): Promise<Drawing> {
        let url_ = this.baseUrl + "/geolocation/api/Drawing/{id}/upload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadDrawing(_response);
        });
    }

    protected processUploadDrawing(response: Response): Promise<Drawing> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Drawing.fromJS(resultData201) : new Drawing();
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Drawing>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/geolocation/api/Drawing/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class GridClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Grid[]> {
        let url_ = this.baseUrl + "/geolocation/api/Grid?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Grid[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Grid.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Grid[]>(<any>null);
    }

    post(authorization: string | null | undefined, entity: Grid): Promise<Grid> {
        let url_ = this.baseUrl + "/geolocation/api/Grid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Grid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Grid.fromJS(resultData201) : new Grid();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Grid>(<any>null);
    }

    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/Grid?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    get(id: string | null, authorization: string | null | undefined): Promise<Grid> {
        let url_ = this.baseUrl + "/geolocation/api/Grid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Grid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Grid.fromJS(resultData200) : new Grid();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Grid>(<any>null);
    }

    put(id: string | null, authorization: string | null | undefined, entity: Grid): Promise<Grid> {
        let url_ = this.baseUrl + "/geolocation/api/Grid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Grid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Grid.fromJS(resultData201) : new Grid();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Grid>(<any>null);
    }

    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/geolocation/api/Grid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/Grid/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/geolocation/api/Grid/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class LayerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Layer[]> {
        let url_ = this.baseUrl + "/geolocation/api/Layer?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Layer[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Layer.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Layer[]>(<any>null);
    }

    post(authorization: string | null | undefined, entity: Layer): Promise<Layer> {
        let url_ = this.baseUrl + "/geolocation/api/Layer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Layer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Layer.fromJS(resultData201) : new Layer();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Layer>(<any>null);
    }

    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/Layer?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    get(id: string | null, authorization: string | null | undefined): Promise<Layer> {
        let url_ = this.baseUrl + "/geolocation/api/Layer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Layer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Layer.fromJS(resultData200) : new Layer();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Layer>(<any>null);
    }

    put(id: string | null, authorization: string | null | undefined, entity: Layer): Promise<Layer> {
        let url_ = this.baseUrl + "/geolocation/api/Layer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Layer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Layer.fromJS(resultData201) : new Layer();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Layer>(<any>null);
    }

    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/geolocation/api/Layer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/Layer/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/geolocation/api/Layer/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class LayerInteractionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<LayerInteractions[]> {
        let url_ = this.baseUrl + "/geolocation/api/LayerInteractions?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<LayerInteractions[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LayerInteractions.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LayerInteractions[]>(<any>null);
    }

    post(authorization: string | null | undefined, entity: LayerInteractions): Promise<LayerInteractions> {
        let url_ = this.baseUrl + "/geolocation/api/LayerInteractions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<LayerInteractions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? LayerInteractions.fromJS(resultData201) : new LayerInteractions();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LayerInteractions>(<any>null);
    }

    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/LayerInteractions?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    get(id: string | null, authorization: string | null | undefined): Promise<LayerInteractions> {
        let url_ = this.baseUrl + "/geolocation/api/LayerInteractions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<LayerInteractions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LayerInteractions.fromJS(resultData200) : new LayerInteractions();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LayerInteractions>(<any>null);
    }

    put(id: string | null, authorization: string | null | undefined, entity: LayerInteractions): Promise<LayerInteractions> {
        let url_ = this.baseUrl + "/geolocation/api/LayerInteractions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<LayerInteractions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? LayerInteractions.fromJS(resultData201) : new LayerInteractions();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LayerInteractions>(<any>null);
    }

    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/geolocation/api/LayerInteractions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/LayerInteractions/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/geolocation/api/LayerInteractions/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class MarkerAttachmentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all markerAttachments that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return MarkerAttachments successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<MarkerAttachment[]> {
        let url_ = this.baseUrl + "/geolocation/api/MarkerAttachment?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<MarkerAttachment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MarkerAttachment.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarkerAttachment[]>(<any>null);
    }

    /**
     * Allow you to create an new markerAttachment entity
     * @param authorization (optional) 
     * @param entity MarkerAttachment entity to be added to the database
     * @return MarkerAttachment successfully created.
     */
    post(authorization: string | null | undefined, entity: MarkerAttachment): Promise<MarkerAttachment> {
        let url_ = this.baseUrl + "/geolocation/api/MarkerAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<MarkerAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? MarkerAttachment.fromJS(resultData201) : new MarkerAttachment();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarkerAttachment>(<any>null);
    }

    /**
     * Allow you to delete all markerAttachments that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Attachments are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/MarkerAttachment?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the markerAttachment that match the id you have specified
     * @param authorization (optional) 
     * @return MarkerAttachment successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<MarkerAttachment> {
        let url_ = this.baseUrl + "/geolocation/api/MarkerAttachment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<MarkerAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MarkerAttachment.fromJS(resultData200) : new MarkerAttachment();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarkerAttachment>(<any>null);
    }

    /**
     * Allow you to create or replace a markerAttachment, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity MarkerAttachment entity to be added to the database
     * @return MarkerAttachment successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: MarkerAttachment): Promise<MarkerAttachment> {
        let url_ = this.baseUrl + "/geolocation/api/MarkerAttachment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<MarkerAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? MarkerAttachment.fromJS(resultData201) : new MarkerAttachment();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarkerAttachment>(<any>null);
    }

    /**
     * Allow you to update an markerAttachment.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return MarkerAttachment successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/geolocation/api/MarkerAttachment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an markerAttachment.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/MarkerAttachment/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve and download the binary data associated to an markerAttachment.
     * @param authorization (optional) 
     * @return Binary data of the attachment succesfully retrieved
     */
    downloadMarkerAttachment(id: string | null, authorization: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/geolocation/api/MarkerAttachment/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadMarkerAttachment(_response);
        });
    }

    protected processDownloadMarkerAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Upload binary data to the specified markerAttachment.
     * @param authorization (optional) 
     * @param file (optional) File to be added to the attachment.
     * @return Binary data sucessfully uploaded to the attachment.
     */
    uploadMarkerAttachment(authorization: string | null | undefined, id: string | null, file: FileParameter | null | undefined): Promise<MarkerAttachment> {
        let url_ = this.baseUrl + "/geolocation/api/MarkerAttachment/{id}/upload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadMarkerAttachment(_response);
        });
    }

    protected processUploadMarkerAttachment(response: Response): Promise<MarkerAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? MarkerAttachment.fromJS(resultData201) : new MarkerAttachment();
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarkerAttachment>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/geolocation/api/MarkerAttachment/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class TrackClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all tracks that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Tracks successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Track[]> {
        let url_ = this.baseUrl + "/geolocation/api/Track?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Track[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Track.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Track[]>(<any>null);
    }

    /**
     * Allow you to create an new track entity
     * @param authorization (optional) 
     * @param entity Track entity to be added to the database
     * @return Track successfully created.
     */
    post(authorization: string | null | undefined, entity: Track): Promise<Track> {
        let url_ = this.baseUrl + "/geolocation/api/Track";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Track> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Track.fromJS(resultData201) : new Track();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Track>(<any>null);
    }

    /**
     * Allow you to delete all tracks that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Tracks are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/Track?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the track that match the id you have specified
     * @param authorization (optional) 
     * @return Track successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Track> {
        let url_ = this.baseUrl + "/geolocation/api/Track/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Track> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Track.fromJS(resultData200) : new Track();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Track>(<any>null);
    }

    /**
     * Allow you to create or replace a track, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Track entity to be added to the database
     * @return Track successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Track): Promise<Track> {
        let url_ = this.baseUrl + "/geolocation/api/Track/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Track> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Track.fromJS(resultData201) : new Track();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Track>(<any>null);
    }

    /**
     * Allow you to update an track.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Track successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/geolocation/api/Track/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an track.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/Track/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/geolocation/api/Track/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class ZoneClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all zones that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Zones successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Zone[]> {
        let url_ = this.baseUrl + "/geolocation/api/Zone?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Zone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Zone.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Zone[]>(<any>null);
    }

    /**
     * Allow you to create an new zone entity
     * @param authorization (optional) 
     * @param entity Zone entity to be added to the database
     * @return Zone successfully created.
     */
    post(authorization: string | null | undefined, entity: Zone): Promise<Zone> {
        let url_ = this.baseUrl + "/geolocation/api/Zone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Zone> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Zone.fromJS(resultData201) : new Zone();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Zone>(<any>null);
    }

    /**
     * Allow you to delete all zones that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Zones are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/Zone?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the zone that match the id you have specified
     * @param authorization (optional) 
     * @return Zone successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Zone> {
        let url_ = this.baseUrl + "/geolocation/api/Zone/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Zone> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Zone.fromJS(resultData200) : new Zone();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Zone>(<any>null);
    }

    /**
     * Allow you to create or replace a zone, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Zone entity to be added to the database
     * @return Zone successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Zone): Promise<Zone> {
        let url_ = this.baseUrl + "/geolocation/api/Zone/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Zone> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Zone.fromJS(resultData201) : new Zone();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Zone>(<any>null);
    }

    /**
     * Allow you to update an zone.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Zone successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/geolocation/api/Zone/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an zone.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/geolocation/api/Zone/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/geolocation/api/Zone/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class ImageClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Allow you to specify an URL for Constellation to search for an image binary data.
     * @param authorization (optional) 
     * @param url (optional) 
     * @param name (optional) 
     */
    postFromUrl(authorization: string | null | undefined, url: string | null | undefined, name: string | null | undefined): Promise<Image> {
        let url_ = this.baseUrl + "/resources/api/Image/FromUrl?";
        if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFromUrl(_response);
        });
    }

    protected processPostFromUrl(response: Response): Promise<Image> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Image.fromJS(resultData201) : new Image();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Image>(<any>null);
    }

    /**
     * Allow you to upload binary data to the specified image.
     * @param authorization (optional) 
     * @param imageName (optional) 
     * @param file (optional) 
     */
    upload(authorization: string | null | undefined, imageName: string | null | undefined, file: FileParameter | null | undefined): Promise<Image> {
        let url_ = this.baseUrl + "/resources/api/Image/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageName !== null && imageName !== undefined)
            content_.append("imageName", imageName.toString());
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<Image> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Image.fromJS(resultData201) : new Image();
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Image>(<any>null);
    }

    /**
     * Allow you to retrieve binary data associated to an image.
     * @param authorization (optional) 
     * @param id (optional) 
     */
    getRawImage(authorization: string | null | undefined, id: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/resources/api/Image/RawImage?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "image/png"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRawImage(_response);
        });
    }

    protected processGetRawImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Retrieve all images that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Images successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Image[]> {
        let url_ = this.baseUrl + "/resources/api/Image?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Image[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Image.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Image[]>(<any>null);
    }

    /**
     * Allow you to create an new image entity
     * @param authorization (optional) 
     * @param entity Image entity to be added to the database
     * @return Image successfully created.
     */
    post(authorization: string | null | undefined, entity: Image): Promise<Image> {
        let url_ = this.baseUrl + "/resources/api/Image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Image> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Image.fromJS(resultData201) : new Image();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Image>(<any>null);
    }

    /**
     * Allow you to delete all images that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Images are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/resources/api/Image?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the image that match the id you have specified
     * @param authorization (optional) 
     * @return Image successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Image> {
        let url_ = this.baseUrl + "/resources/api/Image/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Image> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Image.fromJS(resultData200) : new Image();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Image>(<any>null);
    }

    /**
     * Allow you to create or replace a image, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Image entity to be added to the database
     * @return Image successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Image): Promise<Image> {
        let url_ = this.baseUrl + "/resources/api/Image/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Image> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Image.fromJS(resultData201) : new Image();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Image>(<any>null);
    }

    /**
     * Allow you to update an image.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Image successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/resources/api/Image/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an image.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/resources/api/Image/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/resources/api/Image/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class PathClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Allow you to get the duration in seconds between two WGS84 coordinates
     * @param authorization (optional) 
     * @param sourceLatitude (optional) 
     * @param sourceLongitude (optional) 
     * @param destinationLatitude (optional) 
     * @param destinationLongitude (optional) 
     * @param sourceId (optional) 
     * @param destinationId (optional) 
     * @return Duration sucessfully retrieved.
     */
    getDuration(authorization: string | null | undefined, sourceLatitude: number | undefined, sourceLongitude: number | undefined, destinationLatitude: number | undefined, destinationLongitude: number | undefined, sourceId: string | null | undefined, destinationId: string | null | undefined): Promise<SourceToDestinationDuration> {
        let url_ = this.baseUrl + "/navigation/api/Path/duration?";
        if (sourceLatitude === null)
            throw new Error("The parameter 'sourceLatitude' cannot be null.");
        else if (sourceLatitude !== undefined)
            url_ += "sourceLatitude=" + encodeURIComponent("" + sourceLatitude) + "&"; 
        if (sourceLongitude === null)
            throw new Error("The parameter 'sourceLongitude' cannot be null.");
        else if (sourceLongitude !== undefined)
            url_ += "sourceLongitude=" + encodeURIComponent("" + sourceLongitude) + "&"; 
        if (destinationLatitude === null)
            throw new Error("The parameter 'destinationLatitude' cannot be null.");
        else if (destinationLatitude !== undefined)
            url_ += "destinationLatitude=" + encodeURIComponent("" + destinationLatitude) + "&"; 
        if (destinationLongitude === null)
            throw new Error("The parameter 'destinationLongitude' cannot be null.");
        else if (destinationLongitude !== undefined)
            url_ += "destinationLongitude=" + encodeURIComponent("" + destinationLongitude) + "&"; 
        if (sourceId !== undefined)
            url_ += "sourceId=" + encodeURIComponent("" + sourceId) + "&"; 
        if (destinationId !== undefined)
            url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDuration(_response);
        });
    }

    protected processGetDuration(response: Response): Promise<SourceToDestinationDuration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SourceToDestinationDuration.fromJS(resultData200) : new SourceToDestinationDuration();
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SourceToDestinationDuration>(<any>null);
    }

    /**
     * Allow you to get the path between two WGS84 coordinates for a specific transportation mode.
     * @param authorization (optional) 
     * @param pathInformations (optional) 
     * @param transportMode (optional) 
     * @return Duration sucessfully retrieved.
     * @deprecated
     */
    getPathBetweenPoints(authorization: string | null | undefined, pathInformations: string | null | undefined, transportMode: string | null | undefined): Promise<Path> {
        let url_ = this.baseUrl + "/navigation/api/Path/PathBetweenPoints?";
        if (pathInformations !== undefined)
            url_ += "pathInformations=" + encodeURIComponent("" + pathInformations) + "&"; 
        if (transportMode !== undefined)
            url_ += "transportMode=" + encodeURIComponent("" + transportMode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPathBetweenPoints(_response);
        });
    }

    protected processGetPathBetweenPoints(response: Response): Promise<Path> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Path.fromJS(resultData200) : new Path();
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Path>(<any>null);
    }

    /**
     * Allow you to get the path between two WGS84 coordinates for a specific transportation mode.
     * @param authorization (optional) 
     * @param transportMode (optional) 
     * @return Duration sucessfully retrieved.
     */
    between(authorization: string | null | undefined, coords: PathBetweenRequest, transportMode: string | null | undefined): Promise<Path> {
        let url_ = this.baseUrl + "/navigation/api/Path/between?";
        if (transportMode !== undefined)
            url_ += "transportMode=" + encodeURIComponent("" + transportMode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(coords);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBetween(_response);
        });
    }

    protected processBetween(response: Response): Promise<Path> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Path.fromJS(resultData200) : new Path();
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Path>(<any>null);
    }

    /**
     * Retrieve all paths that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Paths successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Path[]> {
        let url_ = this.baseUrl + "/navigation/api/Path?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Path[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Path.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Path[]>(<any>null);
    }

    /**
     * Allow you to create an new path entity
     * @param authorization (optional) 
     * @param entity Path entity to be added to the database
     * @return Path successfully created.
     */
    post(authorization: string | null | undefined, entity: Path): Promise<Path> {
        let url_ = this.baseUrl + "/navigation/api/Path";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Path> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Path.fromJS(resultData201) : new Path();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Path>(<any>null);
    }

    /**
     * Allow you to delete all paths that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Paths are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/navigation/api/Path?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the path that match the id you have specified
     * @param authorization (optional) 
     * @return Path successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Path> {
        let url_ = this.baseUrl + "/navigation/api/Path/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Path> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Path.fromJS(resultData200) : new Path();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Path>(<any>null);
    }

    /**
     * Allow you to create or replace a path, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Path entity to be added to the database
     * @return Path successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Path): Promise<Path> {
        let url_ = this.baseUrl + "/navigation/api/Path/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Path> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Path.fromJS(resultData201) : new Path();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Path>(<any>null);
    }

    /**
     * Allow you to update an path.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Path successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/navigation/api/Path/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an path.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/navigation/api/Path/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/navigation/api/Path/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class MissionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all missions that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Missions successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Mission[]> {
        let url_ = this.baseUrl + "/missions/api/Mission?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Mission[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Mission.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Mission[]>(<any>null);
    }

    /**
     * Allow you to create an new mission entity
     * @param authorization (optional) 
     * @param entity Mission entity to be added to the database
     * @return Mission successfully created.
     */
    post(authorization: string | null | undefined, entity: Mission): Promise<Mission> {
        let url_ = this.baseUrl + "/missions/api/Mission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Mission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Mission.fromJS(resultData201) : new Mission();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Mission>(<any>null);
    }

    /**
     * Allow you to delete all missions that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Missions are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/missions/api/Mission?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the mission that match the id you have specified
     * @param authorization (optional) 
     * @return Mission successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Mission> {
        let url_ = this.baseUrl + "/missions/api/Mission/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Mission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Mission.fromJS(resultData200) : new Mission();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Mission>(<any>null);
    }

    /**
     * Allow you to create or replace a mission, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Mission entity to be added to the database
     * @return Mission successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Mission): Promise<Mission> {
        let url_ = this.baseUrl + "/missions/api/Mission/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Mission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Mission.fromJS(resultData201) : new Mission();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Mission>(<any>null);
    }

    /**
     * Allow you to update an mission.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Mission successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/missions/api/Mission/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an mission.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/missions/api/Mission/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/missions/api/Mission/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class MissionTemplateClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all mission templates that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Mission templates successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<MissionTemplate[]> {
        let url_ = this.baseUrl + "/missions/api/MissionTemplate?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<MissionTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MissionTemplate.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MissionTemplate[]>(<any>null);
    }

    /**
     * Allow you to create an new mission template entity
     * @param authorization (optional) 
     * @param entity MissionTemplate entity to be added to the database
     * @return MissionTemplate successfully created.
     */
    post(authorization: string | null | undefined, entity: MissionTemplate): Promise<MissionTemplate> {
        let url_ = this.baseUrl + "/missions/api/MissionTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<MissionTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? MissionTemplate.fromJS(resultData201) : new MissionTemplate();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MissionTemplate>(<any>null);
    }

    /**
     * Allow you to delete all mission templates that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Mission templates are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/missions/api/MissionTemplate?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the mission template that match the id you have specified
     * @param authorization (optional) 
     * @return MissionTemplate successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<MissionTemplate> {
        let url_ = this.baseUrl + "/missions/api/MissionTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<MissionTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MissionTemplate.fromJS(resultData200) : new MissionTemplate();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MissionTemplate>(<any>null);
    }

    /**
     * Allow you to create or replace a mission template, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity MissionTemplate entity to be added to the database
     * @return MissionTemplate successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: MissionTemplate): Promise<MissionTemplate> {
        let url_ = this.baseUrl + "/missions/api/MissionTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<MissionTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? MissionTemplate.fromJS(resultData201) : new MissionTemplate();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MissionTemplate>(<any>null);
    }

    /**
     * Allow you to update an mission template.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return MissionTemplate successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/missions/api/MissionTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an mission template.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/missions/api/MissionTemplate/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/missions/api/MissionTemplate/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class AgentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve the agent that is associated with the token you have provided.
     * @param authorization (optional) 
     * @return Agent successfully retrieved.
     */
    getMine(authorization: string | null | undefined): Promise<Agent> {
        let url_ = this.baseUrl + "/units/api/Agent/myself";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMine(_response);
        });
    }

    protected processGetMine(response: Response): Promise<Agent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Agent.fromJS(resultData200) : new Agent();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Agent>(<any>null);
    }

    /**
     * Retrieve all agents that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Agents successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Agent[]> {
        let url_ = this.baseUrl + "/units/api/Agent?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Agent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Agent.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Agent[]>(<any>null);
    }

    /**
     * Allow you to create an new agent entity
     * @param authorization (optional) 
     * @param entity Agent entity to be added to the database
     * @return Agent successfully created.
     */
    post(authorization: string | null | undefined, entity: Agent): Promise<Agent> {
        let url_ = this.baseUrl + "/units/api/Agent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Agent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Agent.fromJS(resultData201) : new Agent();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Agent>(<any>null);
    }

    /**
     * Allow you to delete all agents that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Agents are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/units/api/Agent?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the agent that match the id you have specified
     * @param authorization (optional) 
     * @return Agent successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Agent> {
        let url_ = this.baseUrl + "/units/api/Agent/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Agent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Agent.fromJS(resultData200) : new Agent();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Agent>(<any>null);
    }

    /**
     * Allow you to create or replace a agent, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Agent entity to be added to the database
     * @return Agent successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Agent): Promise<Agent> {
        let url_ = this.baseUrl + "/units/api/Agent/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Agent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Agent.fromJS(resultData201) : new Agent();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Agent>(<any>null);
    }

    /**
     * Allow you to update an agent.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Agent successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/units/api/Agent/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an agent.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/units/api/Agent/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/units/api/Agent/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class AgentStatusClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all Agent statuses that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Agents successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<AgentStatus[]> {
        let url_ = this.baseUrl + "/units/api/AgentStatus?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<AgentStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AgentStatus.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentStatus[]>(<any>null);
    }

    /**
     * Allow you to create an new Agent status entity
     * @param authorization (optional) 
     * @param entity Agent status entity to be added to the database
     * @return Agent status successfully created.
     */
    post(authorization: string | null | undefined, entity: AgentStatus): Promise<AgentStatus> {
        let url_ = this.baseUrl + "/units/api/AgentStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<AgentStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? AgentStatus.fromJS(resultData201) : new AgentStatus();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentStatus>(<any>null);
    }

    /**
     * Allow you to delete all Agents statuses that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Agents statuses are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/units/api/AgentStatus?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the Agent status that match the id you have specified
     * @param authorization (optional) 
     * @return Agent status successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<AgentStatus> {
        let url_ = this.baseUrl + "/units/api/AgentStatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AgentStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AgentStatus.fromJS(resultData200) : new AgentStatus();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentStatus>(<any>null);
    }

    /**
     * Allow you to create or replace a Agent status, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Agent status entity to be added to the database
     * @return Agent status successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: AgentStatus): Promise<AgentStatus> {
        let url_ = this.baseUrl + "/units/api/AgentStatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<AgentStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? AgentStatus.fromJS(resultData201) : new AgentStatus();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentStatus>(<any>null);
    }

    /**
     * Allow you to update a Agent status.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Agent status successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/units/api/AgentStatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an Agent status.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/units/api/AgentStatus/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/units/api/AgentStatus/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class CameraClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all cameras that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Cameras successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Camera[]> {
        let url_ = this.baseUrl + "/videomanager/api/Camera?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Camera[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Camera.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Camera[]>(<any>null);
    }

    /**
     * Allow you to create an new camera entity
     * @param authorization (optional) 
     * @param entity Camera entity to be added to the database
     * @return Camera successfully created.
     */
    post(authorization: string | null | undefined, entity: Camera): Promise<Camera> {
        let url_ = this.baseUrl + "/videomanager/api/Camera";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Camera> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Camera.fromJS(resultData201) : new Camera();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Camera>(<any>null);
    }

    /**
     * Allow you to delete all cameras that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Cameras are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/videomanager/api/Camera?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the camera that match the id you have specified
     * @param authorization (optional) 
     * @return Camera successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Camera> {
        let url_ = this.baseUrl + "/videomanager/api/Camera/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Camera> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Camera.fromJS(resultData200) : new Camera();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Camera>(<any>null);
    }

    /**
     * Allow you to create or replace a camera, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Camera entity to be added to the database
     * @return Camera successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Camera): Promise<Camera> {
        let url_ = this.baseUrl + "/videomanager/api/Camera/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Camera> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Camera.fromJS(resultData201) : new Camera();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Camera>(<any>null);
    }

    /**
     * Allow you to update an camera.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Camera successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/videomanager/api/Camera/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an camera.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/videomanager/api/Camera/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Allow you to check if the provided token has authorization to screenshot this camera.
     * @param authorization (optional) 
     * @return Provided token has the authorization to screenshot the provided camera.
     */
    canScreenshot(id: string | null, authorization: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/videomanager/{id}/Screenshot";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCanScreenshot(_response);
        });
    }

    protected processCanScreenshot(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Allow you to use the Pan Tilt Zoom Function of a camera.
     * @param authorization (optional) 
     * @param controller Should contains the delta rotation values to rotate the camera.
     * @return Ptz controller successfully modified.
     */
    updatePtzController(authorization: string | null | undefined, id: string | null, controller: PtzController): Promise<any> {
        let url_ = this.baseUrl + "/videomanager/{id}/PtzController";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(controller);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePtzController(_response);
        });
    }

    protected processUpdatePtzController(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to rotate the camera to an absolute defined rotation.
     * @param authorization (optional) 
     * @param state Should contains the absolute rotation values to rotate the camera.
     * @return Camera succesfully rotated to absolute position.
     */
    sendPtzAbsolute(authorization: string | null | undefined, id: string | null, state: PtzController): Promise<AbsolutePtzStateWasSet> {
        let url_ = this.baseUrl + "/videomanager/{id}/PtzAbsolute";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(state);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendPtzAbsolute(_response);
        });
    }

    protected processSendPtzAbsolute(response: Response): Promise<AbsolutePtzStateWasSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AbsolutePtzStateWasSet.fromJS(resultData200) : new AbsolutePtzStateWasSet();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AbsolutePtzStateWasSet>(<any>null);
    }

    /**
     * Allow you to rotate the camera so that the camera view face a specific WGS84 coordinate.
     * @param authorization (optional) 
     * @param command Should contains the coordinates value that the camera should face.
     */
    sendPtzCoordinate(authorization: string | null | undefined, id: string | null, command: PtzToCoordinates): Promise<void> {
        let url_ = this.baseUrl + "/videomanager/{id}/PtzCoordinate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendPtzCoordinate(_response);
        });
    }

    protected processSendPtzCoordinate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Allow you to rotate the camera to a predefined preset.
     * @param authorization (optional) 
     * @param speed (optional) 
     */
    setPtzOnPreset(authorization: string | null | undefined, id: string | null, presetName: string | null, speed: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/videomanager/{id}/PtzPreset/{presetName}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (presetName === undefined || presetName === null)
            throw new Error("The parameter 'presetName' must be defined.");
        url_ = url_.replace("{presetName}", encodeURIComponent("" + presetName)); 
        if (speed === null)
            throw new Error("The parameter 'speed' cannot be null.");
        else if (speed !== undefined)
            url_ += "speed=" + encodeURIComponent("" + speed) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPtzOnPreset(_response);
        });
    }

    protected processSetPtzOnPreset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/videomanager/api/Camera/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class LiveStreamClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all liveStreams that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return LiveStreams successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<LiveStream[]> {
        let url_ = this.baseUrl + "/videomanager/api/LiveStream?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<LiveStream[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LiveStream.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LiveStream[]>(<any>null);
    }

    /**
     * Allow you to create an new liveStream entity
     * @param authorization (optional) 
     * @param entity LiveStream entity to be added to the database
     * @return LiveStream successfully created.
     */
    post(authorization: string | null | undefined, entity: LiveStream): Promise<LiveStream> {
        let url_ = this.baseUrl + "/videomanager/api/LiveStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<LiveStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? LiveStream.fromJS(resultData201) : new LiveStream();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LiveStream>(<any>null);
    }

    /**
     * Allow you to delete all liveStreams that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return LiveStreams are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/videomanager/api/LiveStream?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the liveStream that match the id you have specified
     * @param authorization (optional) 
     * @return LiveStream successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<LiveStream> {
        let url_ = this.baseUrl + "/videomanager/api/LiveStream/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<LiveStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LiveStream.fromJS(resultData200) : new LiveStream();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LiveStream>(<any>null);
    }

    /**
     * Allow you to create or replace a liveStream, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity LiveStream entity to be added to the database
     * @return LiveStream successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: LiveStream): Promise<LiveStream> {
        let url_ = this.baseUrl + "/videomanager/api/LiveStream/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<LiveStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? LiveStream.fromJS(resultData201) : new LiveStream();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LiveStream>(<any>null);
    }

    /**
     * Allow you to update an liveStream.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return LiveStream successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/videomanager/api/LiveStream/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an liveStream.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/videomanager/api/LiveStream/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/videomanager/api/LiveStream/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class PlaybackStreamClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve an image at a defined time in the recordings of a camera.
     * @param authorization (optional) 
     * @param cameraId (optional) 
     * @param dateTime (optional) 
     * @param width (optional) 
     * @param height (optional) 
     * @return Image sucesfully retrieved.
     */
    getImageAt(authorization: string | null | undefined, cameraId: string | null | undefined, dateTime: Date | undefined, width: number | null | undefined, height: number | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/videomanager/api/PlaybackStream/GetImageAt?";
        if (cameraId !== undefined)
            url_ += "cameraId=" + encodeURIComponent("" + cameraId) + "&"; 
        if (dateTime === null)
            throw new Error("The parameter 'dateTime' cannot be null.");
        else if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toJSON() : "") + "&"; 
        if (width !== undefined)
            url_ += "width=" + encodeURIComponent("" + width) + "&"; 
        if (height !== undefined)
            url_ += "height=" + encodeURIComponent("" + height) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "image/jpg"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImageAt(_response);
        });
    }

    protected processGetImageAt(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Retrieve all motion intervals between provided dates for a specific camera.
     * @param authorization (optional) 
     * @param cameraId (optional) 
     * @param dateTimeBegin (optional) 
     * @param dateTimeEnd (optional) 
     * @return Motion intervals sucessfully retrieved.
     */
    getTimeIntervals(authorization: string | null | undefined, cameraId: string | null | undefined, dateTimeBegin: Date | undefined, dateTimeEnd: Date | undefined): Promise<TimeInterval[]> {
        let url_ = this.baseUrl + "/videomanager/api/PlaybackStream/GetTimeIntervals?";
        if (cameraId !== undefined)
            url_ += "cameraId=" + encodeURIComponent("" + cameraId) + "&"; 
        if (dateTimeBegin === null)
            throw new Error("The parameter 'dateTimeBegin' cannot be null.");
        else if (dateTimeBegin !== undefined)
            url_ += "dateTimeBegin=" + encodeURIComponent(dateTimeBegin ? "" + dateTimeBegin.toJSON() : "") + "&"; 
        if (dateTimeEnd === null)
            throw new Error("The parameter 'dateTimeEnd' cannot be null.");
        else if (dateTimeEnd !== undefined)
            url_ += "dateTimeEnd=" + encodeURIComponent(dateTimeEnd ? "" + dateTimeEnd.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTimeIntervals(_response);
        });
    }

    protected processGetTimeIntervals(response: Response): Promise<TimeInterval[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TimeInterval.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeInterval[]>(<any>null);
    }

    /**
     * Retrieve all playbackStreams that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return PlaybackStreams successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<PlaybackStream[]> {
        let url_ = this.baseUrl + "/videomanager/api/PlaybackStream?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<PlaybackStream[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlaybackStream.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaybackStream[]>(<any>null);
    }

    /**
     * Allow you to create an new playbackStream entity
     * @param authorization (optional) 
     * @param entity PlaybackStream entity to be added to the database
     * @return PlaybackStream successfully created.
     */
    post(authorization: string | null | undefined, entity: PlaybackStream): Promise<PlaybackStream> {
        let url_ = this.baseUrl + "/videomanager/api/PlaybackStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<PlaybackStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? PlaybackStream.fromJS(resultData201) : new PlaybackStream();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaybackStream>(<any>null);
    }

    /**
     * Allow you to delete all playbackStreams that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return PlaybackStreams are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/videomanager/api/PlaybackStream?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the playbackStream that match the id you have specified
     * @param authorization (optional) 
     * @return PlaybackStream successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<PlaybackStream> {
        let url_ = this.baseUrl + "/videomanager/api/PlaybackStream/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PlaybackStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PlaybackStream.fromJS(resultData200) : new PlaybackStream();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaybackStream>(<any>null);
    }

    /**
     * Allow you to create or replace a playbackStream, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity PlaybackStream entity to be added to the database
     * @return PlaybackStream successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: PlaybackStream): Promise<PlaybackStream> {
        let url_ = this.baseUrl + "/videomanager/api/PlaybackStream/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<PlaybackStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? PlaybackStream.fromJS(resultData201) : new PlaybackStream();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaybackStream>(<any>null);
    }

    /**
     * Allow you to update an playbackStream.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return PlaybackStream successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/videomanager/api/PlaybackStream/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an playbackStream.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/videomanager/api/PlaybackStream/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/videomanager/api/PlaybackStream/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class VideoExportClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve and download the binary data associated to a VideoExport entity
     * @param authorization (optional) 
     * @return Binary data of the video export succesfully retrieved
     */
    download(authorization: string | null | undefined, id: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/videomanager/api/VideoExport/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "video/x-msvideo"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Retrieve all videoExports that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return VideoExports successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<VideoExport[]> {
        let url_ = this.baseUrl + "/videomanager/api/VideoExport?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<VideoExport[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(VideoExport.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoExport[]>(<any>null);
    }

    /**
     * Allow you to create a new videoExport
     * @param authorization (optional) 
     * @param entity VideoExport entity to be added to the database
     * @return VideoExport successfully created.
     */
    post(authorization: string | null | undefined, entity: VideoExport): Promise<VideoExport> {
        let url_ = this.baseUrl + "/videomanager/api/VideoExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<VideoExport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? VideoExport.fromJS(resultData201) : new VideoExport();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoExport>(<any>null);
    }

    /**
     * Allow you to delete all videoExports that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return VideoExports are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/videomanager/api/VideoExport?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the videoExport that match the id you have specified
     * @param authorization (optional) 
     * @return VideoExport successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<VideoExport> {
        let url_ = this.baseUrl + "/videomanager/api/VideoExport/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<VideoExport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? VideoExport.fromJS(resultData200) : new VideoExport();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoExport>(<any>null);
    }

    /**
     * Allow you to create or replace a videoExport, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity VideoExport entity to be added to the database
     * @return VideoExport successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: VideoExport): Promise<VideoExport> {
        let url_ = this.baseUrl + "/videomanager/api/VideoExport/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<VideoExport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? VideoExport.fromJS(resultData201) : new VideoExport();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoExport>(<any>null);
    }

    /**
     * Allow you to update an videoExport.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return VideoExport successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/videomanager/api/VideoExport/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an videoExport.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/videomanager/api/VideoExport/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/videomanager/api/VideoExport/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class VmsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all vmses that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return VMSes successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Vms[]> {
        let url_ = this.baseUrl + "/videomanager/api/Vms?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Vms[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Vms.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vms[]>(<any>null);
    }

    /**
     * Allow you to create an new vms entity
     * @param authorization (optional) 
     * @param entity VMS entity to be added to the database
     * @return VMS successfully created.
     */
    post(authorization: string | null | undefined, entity: Vms): Promise<Vms> {
        let url_ = this.baseUrl + "/videomanager/api/Vms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Vms> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Vms.fromJS(resultData201) : new Vms();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vms>(<any>null);
    }

    /**
     * Allow you to delete all vmses that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return VMSes are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/videomanager/api/Vms?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the vms that match the id you have specified
     * @param authorization (optional) 
     * @return VMS successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Vms> {
        let url_ = this.baseUrl + "/videomanager/api/Vms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Vms> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Vms.fromJS(resultData200) : new Vms();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vms>(<any>null);
    }

    /**
     * Allow you to create or replace a vms, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity VMS entity to be added to the database
     * @return VMS successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Vms): Promise<Vms> {
        let url_ = this.baseUrl + "/videomanager/api/Vms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Vms> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Vms.fromJS(resultData201) : new Vms();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vms>(<any>null);
    }

    /**
     * Allow you to update an vms.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return VMS successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/videomanager/api/Vms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an vms.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/videomanager/api/Vms/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/videomanager/api/Vms/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class AlarmClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all alarms that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Alarms successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Alarm[]> {
        let url_ = this.baseUrl + "/alarms/api/Alarm?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Alarm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Alarm.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Alarm[]>(<any>null);
    }

    /**
     * Allow you to create an new alarm entity
     * @param authorization (optional) 
     * @param entity Alarm entity to be added to the database
     * @return Alarm successfully created.
     */
    post(authorization: string | null | undefined, entity: Alarm): Promise<Alarm> {
        let url_ = this.baseUrl + "/alarms/api/Alarm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Alarm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Alarm.fromJS(resultData201) : new Alarm();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Alarm>(<any>null);
    }

    /**
     * Allow you to delete all alarms that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Alarms are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/Alarm?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the alarm that match the id you have specified
     * @param authorization (optional) 
     * @return Alarm successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Alarm> {
        let url_ = this.baseUrl + "/alarms/api/Alarm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Alarm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Alarm.fromJS(resultData200) : new Alarm();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Alarm>(<any>null);
    }

    /**
     * Allow you to create or replace a alarm, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Alarm entity to be added to the database
     * @return Alarm successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Alarm): Promise<Alarm> {
        let url_ = this.baseUrl + "/alarms/api/Alarm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Alarm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Alarm.fromJS(resultData201) : new Alarm();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Alarm>(<any>null);
    }

    /**
     * Allow you to update an alarm.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Alarm successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/alarms/api/Alarm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an alarm.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/Alarm/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Allow you to add attachments to a specific alarm
     * @param authorization (optional) 
     * @param alarmId The identifier of the alarm in which this attachment must be displayed.
     * @param entity Attachment entity to be added to the database
     * @return Attachment was succesfully added to the alarm.
     */
    postAttachment(authorization: string | null | undefined, alarmId: string | null, entity: Attachment): Promise<Attachment> {
        let url_ = this.baseUrl + "/alarms/api/Alarm/{alarmId}/Attachment";
        if (alarmId === undefined || alarmId === null)
            throw new Error("The parameter 'alarmId' must be defined.");
        url_ = url_.replace("{alarmId}", encodeURIComponent("" + alarmId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostAttachment(_response);
        });
    }

    protected processPostAttachment(response: Response): Promise<Attachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Attachment.fromJS(resultData201) : new Attachment();
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Attachment>(<any>null);
    }

    /**
     * Retrieve the attachments from the specified alarm.
     * @param alarmId the identifier of the alarm from which you want to retrieve the attachments.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Attachments succesfully retrieved.
     */
    getAttachments(alarmId: string | null, authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Attachment[]> {
        let url_ = this.baseUrl + "/alarms/api/Alarm/{alarmId}/Attachment?";
        if (alarmId === undefined || alarmId === null)
            throw new Error("The parameter 'alarmId' must be defined.");
        url_ = url_.replace("{alarmId}", encodeURIComponent("" + alarmId)); 
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAttachments(_response);
        });
    }

    protected processGetAttachments(response: Response): Promise<Attachment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Attachment.fromJS(item));
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Attachment[]>(<any>null);
    }

    /**
     * Allow you to add logs to a specific alarm
     * @param authorization (optional) 
     * @param alarmId The identifier of the alarm in which this log must be displayed.
     * @param entity Log entity to be added to the database
     * @return Log was succesfully added to the alarm.
     */
    postLog(authorization: string | null | undefined, alarmId: string | null, entity: Log): Promise<Log> {
        let url_ = this.baseUrl + "/alarms/api/Alarm/{alarmId}/Log";
        if (alarmId === undefined || alarmId === null)
            throw new Error("The parameter 'alarmId' must be defined.");
        url_ = url_.replace("{alarmId}", encodeURIComponent("" + alarmId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostLog(_response);
        });
    }

    protected processPostLog(response: Response): Promise<Log> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Log.fromJS(resultData201) : new Log();
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Log>(<any>null);
    }

    /**
     * Retrieve the logs from the specified alarm.
     * @param alarmId the identifier of the alarm from which you want to retrieve the attachments.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Logs succesfully retrieved.
     */
    getLogs(alarmId: string | null, authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Log[]> {
        let url_ = this.baseUrl + "/alarms/api/Alarm/{alarmId}/Log?";
        if (alarmId === undefined || alarmId === null)
            throw new Error("The parameter 'alarmId' must be defined.");
        url_ = url_.replace("{alarmId}", encodeURIComponent("" + alarmId)); 
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLogs(_response);
        });
    }

    protected processGetLogs(response: Response): Promise<Log[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Log.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Log[]>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/alarms/api/Alarm/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class AlarmSystemClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all alarm systems that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Alarm systems successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<AlarmSystem[]> {
        let url_ = this.baseUrl + "/alarms/api/AlarmSystem?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<AlarmSystem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AlarmSystem.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlarmSystem[]>(<any>null);
    }

    /**
     * Allow you to create an new alarm system entity
     * @param authorization (optional) 
     * @param entity AlarmSystem entity to be added to the database
     * @return AlarmSystem successfully created.
     */
    post(authorization: string | null | undefined, entity: AlarmSystem): Promise<AlarmSystem> {
        let url_ = this.baseUrl + "/alarms/api/AlarmSystem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<AlarmSystem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? AlarmSystem.fromJS(resultData201) : new AlarmSystem();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlarmSystem>(<any>null);
    }

    /**
     * Allow you to delete all alarm systems that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Alarm systems are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/AlarmSystem?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the alarm system that match the id you have specified
     * @param authorization (optional) 
     * @return AlarmSystem successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<AlarmSystem> {
        let url_ = this.baseUrl + "/alarms/api/AlarmSystem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AlarmSystem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AlarmSystem.fromJS(resultData200) : new AlarmSystem();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlarmSystem>(<any>null);
    }

    /**
     * Allow you to create or replace a alarm system, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity AlarmSystem entity to be added to the database
     * @return AlarmSystem successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: AlarmSystem): Promise<AlarmSystem> {
        let url_ = this.baseUrl + "/alarms/api/AlarmSystem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<AlarmSystem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? AlarmSystem.fromJS(resultData201) : new AlarmSystem();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlarmSystem>(<any>null);
    }

    /**
     * Allow you to update an alarm system.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return AlarmSystem successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/alarms/api/AlarmSystem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an alarm system.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/AlarmSystem/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/alarms/api/AlarmSystem/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class AttachmentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all attachments that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Attachments successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Attachment[]> {
        let url_ = this.baseUrl + "/alarms/api/Attachment?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Attachment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Attachment.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Attachment[]>(<any>null);
    }

    /**
     * Allow you to create an new attachment entity
     * @param authorization (optional) 
     * @param entity Attachment entity to be added to the database
     * @return Attachment successfully created.
     */
    post(authorization: string | null | undefined, entity: Attachment): Promise<Attachment> {
        let url_ = this.baseUrl + "/alarms/api/Attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Attachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Attachment.fromJS(resultData201) : new Attachment();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Attachment>(<any>null);
    }

    /**
     * Allow you to delete all attachments that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Attachments are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/Attachment?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the attachment that match the id you have specified
     * @param authorization (optional) 
     * @return Attachment successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Attachment> {
        let url_ = this.baseUrl + "/alarms/api/Attachment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Attachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Attachment.fromJS(resultData200) : new Attachment();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Attachment>(<any>null);
    }

    /**
     * Allow you to create or replace a attachment, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Attachment entity to be added to the database
     * @return Attachment successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Attachment): Promise<Attachment> {
        let url_ = this.baseUrl + "/alarms/api/Attachment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Attachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Attachment.fromJS(resultData201) : new Attachment();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Attachment>(<any>null);
    }

    /**
     * Allow you to update an attachment.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Attachment successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/alarms/api/Attachment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an attachment.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/Attachment/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve and download the binary data associated to an attachment.
     * @param authorization (optional) 
     * @return Binary data of the attachment succesfully retrieved
     */
    downloadAttachment(id: string | null, authorization: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/alarms/api/Attachment/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadAttachment(_response);
        });
    }

    protected processDownloadAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Upload binary data to the specified attachment.
     * @param authorization (optional) 
     * @param file (optional) File to be added to the attachment.
     * @return Binary data sucessfully uploaded to the attachment.
     */
    uploadAttachment(authorization: string | null | undefined, id: string | null, file: FileParameter | null | undefined): Promise<Attachment> {
        let url_ = this.baseUrl + "/alarms/api/Attachment/{id}/upload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadAttachment(_response);
        });
    }

    protected processUploadAttachment(response: Response): Promise<Attachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Attachment.fromJS(resultData201) : new Attachment();
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Attachment>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/alarms/api/Attachment/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class CategoryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all categories that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Categories successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Category[]> {
        let url_ = this.baseUrl + "/alarms/api/Category?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Category[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Category.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Category[]>(<any>null);
    }

    /**
     * Allow you to create a new category entity
     * @param authorization (optional) 
     * @param entity Category entity to be added to the database
     * @return Category successfully created.
     */
    post(authorization: string | null | undefined, entity: Category): Promise<Category> {
        let url_ = this.baseUrl + "/alarms/api/Category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Category> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Category.fromJS(resultData201) : new Category();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Category>(<any>null);
    }

    /**
     * Allow you to delete all categories that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Categories are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/Category?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the category that match the id you have specified
     * @param authorization (optional) 
     * @return Category successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Category> {
        let url_ = this.baseUrl + "/alarms/api/Category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Category> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Category.fromJS(resultData200) : new Category();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Category>(<any>null);
    }

    /**
     * Allow you to create or replace a category, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Category entity to be added to the database
     * @return Category successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Category): Promise<Category> {
        let url_ = this.baseUrl + "/alarms/api/Category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Category> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Category.fromJS(resultData201) : new Category();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Category>(<any>null);
    }

    /**
     * Allow you to update a category.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Category successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/alarms/api/Category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete a category.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/Category/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/alarms/api/Category/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class CertaintyClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all certainties that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Certainties successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Certainty[]> {
        let url_ = this.baseUrl + "/alarms/api/Certainty?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Certainty[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Certainty.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Certainty[]>(<any>null);
    }

    /**
     * Allow you to create a new certainty entity
     * @param authorization (optional) 
     * @param entity Certainty entity to be added to the database
     * @return Certainty successfully created.
     */
    post(authorization: string | null | undefined, entity: Certainty): Promise<Certainty> {
        let url_ = this.baseUrl + "/alarms/api/Certainty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Certainty> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Certainty.fromJS(resultData201) : new Certainty();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Certainty>(<any>null);
    }

    /**
     * Allow you to delete all certainties that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Certainties are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/Certainty?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the certainty that match the id you have specified
     * @param authorization (optional) 
     * @return Certainty successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Certainty> {
        let url_ = this.baseUrl + "/alarms/api/Certainty/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Certainty> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Certainty.fromJS(resultData200) : new Certainty();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Certainty>(<any>null);
    }

    /**
     * Allow you to create or replace a certainty, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Certainty entity to be added to the database
     * @return Certainty successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Certainty): Promise<Certainty> {
        let url_ = this.baseUrl + "/alarms/api/Certainty/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Certainty> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Certainty.fromJS(resultData201) : new Certainty();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Certainty>(<any>null);
    }

    /**
     * Allow you to update a certainty.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Certainty successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/alarms/api/Certainty/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete a certainty.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/Certainty/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/alarms/api/Certainty/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class LogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all logs that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Logs successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Log[]> {
        let url_ = this.baseUrl + "/alarms/api/Log?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Log[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Log.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Log[]>(<any>null);
    }

    /**
     * Allow you to create a new log entity
     * @param authorization (optional) 
     * @param entity Log entity to be added to the database
     * @return Log successfully created.
     */
    post(authorization: string | null | undefined, entity: Log): Promise<Log> {
        let url_ = this.baseUrl + "/alarms/api/Log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Log> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Log.fromJS(resultData201) : new Log();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Log>(<any>null);
    }

    /**
     * Allow you to delete all logs that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Logs are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/Log?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the log that match the id you have specified
     * @param authorization (optional) 
     * @return Log successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Log> {
        let url_ = this.baseUrl + "/alarms/api/Log/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Log> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Log.fromJS(resultData200) : new Log();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Log>(<any>null);
    }

    /**
     * Allow you to create or replace a log, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Log entity to be added to the database
     * @return Log successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Log): Promise<Log> {
        let url_ = this.baseUrl + "/alarms/api/Log/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Log> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Log.fromJS(resultData201) : new Log();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Log>(<any>null);
    }

    /**
     * Allow you to update a log.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Log successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/alarms/api/Log/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete a log.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/Log/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/alarms/api/Log/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class SeverityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all severities that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Severities successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Severity[]> {
        let url_ = this.baseUrl + "/alarms/api/Severity?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Severity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Severity.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Severity[]>(<any>null);
    }

    /**
     * Allow you to create an new severity entity
     * @param authorization (optional) 
     * @param entity Severity entity to be added to the database
     * @return Severity successfully created.
     */
    post(authorization: string | null | undefined, entity: Severity): Promise<Severity> {
        let url_ = this.baseUrl + "/alarms/api/Severity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Severity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Severity.fromJS(resultData201) : new Severity();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Severity>(<any>null);
    }

    /**
     * Allow you to delete all severities that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Severities are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/Severity?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the severity that match the id you have specified
     * @param authorization (optional) 
     * @return Severity successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Severity> {
        let url_ = this.baseUrl + "/alarms/api/Severity/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Severity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Severity.fromJS(resultData200) : new Severity();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Severity>(<any>null);
    }

    /**
     * Allow you to create or replace a severity, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Severity entity to be added to the database
     * @return Severity successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Severity): Promise<Severity> {
        let url_ = this.baseUrl + "/alarms/api/Severity/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Severity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Severity.fromJS(resultData201) : new Severity();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Severity>(<any>null);
    }

    /**
     * Allow you to update an severity.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Severity successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/alarms/api/Severity/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an severity.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/Severity/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/alarms/api/Severity/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class StatusClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all statuses that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Statuses successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Status[]> {
        let url_ = this.baseUrl + "/alarms/api/Status?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Status[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Status.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Status[]>(<any>null);
    }

    /**
     * Allow you to create a new status entity
     * @param authorization (optional) 
     * @param entity Status entity to be added to the database
     * @return Status successfully created.
     */
    post(authorization: string | null | undefined, entity: Status): Promise<Status> {
        let url_ = this.baseUrl + "/alarms/api/Status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Status> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Status.fromJS(resultData201) : new Status();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Status>(<any>null);
    }

    /**
     * Allow you to delete all statuses that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Statuses are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/Status?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the status that match the id you have specified
     * @param authorization (optional) 
     * @return Status successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Status> {
        let url_ = this.baseUrl + "/alarms/api/Status/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Status> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Status.fromJS(resultData200) : new Status();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Status>(<any>null);
    }

    /**
     * Allow you to create or replace a status, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Status entity to be added to the database
     * @return Status successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Status): Promise<Status> {
        let url_ = this.baseUrl + "/alarms/api/Status/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Status> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Status.fromJS(resultData201) : new Status();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Status>(<any>null);
    }

    /**
     * Allow you to update a status.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Status successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/alarms/api/Status/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete a status.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/alarms/api/Status/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/alarms/api/Status/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class ChannelClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all channels that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Channels successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Channel[]> {
        let url_ = this.baseUrl + "/voip/api/Channel?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Channel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Channel.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Channel[]>(<any>null);
    }

    /**
     * Allow you to create an new channel entity
     * @param authorization (optional) 
     * @param entity Channel entity to be added to the database
     * @return Channel successfully created.
     */
    post(authorization: string | null | undefined, entity: Channel): Promise<Channel> {
        let url_ = this.baseUrl + "/voip/api/Channel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Channel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Channel.fromJS(resultData201) : new Channel();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Channel>(<any>null);
    }

    /**
     * Allow you to delete all channels that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Channels are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/voip/api/Channel?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the channel that match the id you have specified
     * @param authorization (optional) 
     * @return Channel successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Channel> {
        let url_ = this.baseUrl + "/voip/api/Channel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Channel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Channel.fromJS(resultData200) : new Channel();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Channel>(<any>null);
    }

    /**
     * Allow you to create or replace a channel, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Channel entity to be added to the database
     * @return Channel successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Channel): Promise<Channel> {
        let url_ = this.baseUrl + "/voip/api/Channel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Channel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Channel.fromJS(resultData201) : new Channel();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Channel>(<any>null);
    }

    /**
     * Allow you to update an channel.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Channel successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/voip/api/Channel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an channel.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/voip/api/Channel/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/voip/api/Channel/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class VoiceActivityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Use this route to notify other peoples in the channel that you are producing voice activity.
     * @param authorization (optional) 
     * @param channelId (optional) 
     * @return Voice activity has succesfully been notified.
     */
    voiceActivity(authorization: string | null | undefined, channelId: string | null | undefined): Promise<VoiceActivity> {
        let url_ = this.baseUrl + "/voip/api/VoiceActivity?";
        if (channelId !== undefined)
            url_ += "channelId=" + encodeURIComponent("" + channelId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVoiceActivity(_response);
        });
    }

    protected processVoiceActivity(response: Response): Promise<VoiceActivity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? VoiceActivity.fromJS(resultData200) : new VoiceActivity();
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoiceActivity>(<any>null);
    }
}

export class AgentBehaviourClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all agent behaviours that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return AgentBehaviours successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<AgentBehaviour[]> {
        let url_ = this.baseUrl + "/simulator/api/AgentBehaviour?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<AgentBehaviour[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AgentBehaviour.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentBehaviour[]>(<any>null);
    }

    /**
     * Allow you to create an new agent behaviour entity
     * @param authorization (optional) 
     * @param entity AgentBehaviour entity to be added to the database
     * @return AgentBehaviour successfully created.
     */
    post(authorization: string | null | undefined, entity: AgentBehaviour): Promise<AgentBehaviour> {
        let url_ = this.baseUrl + "/simulator/api/AgentBehaviour";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<AgentBehaviour> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? AgentBehaviour.fromJS(resultData201) : new AgentBehaviour();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentBehaviour>(<any>null);
    }

    /**
     * Allow you to delete all agent behaviours that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return AgentBehaviours are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/simulator/api/AgentBehaviour?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the agent behaviour that match the id you have specified
     * @param authorization (optional) 
     * @return AgentBehaviour successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<AgentBehaviour> {
        let url_ = this.baseUrl + "/simulator/api/AgentBehaviour/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AgentBehaviour> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AgentBehaviour.fromJS(resultData200) : new AgentBehaviour();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentBehaviour>(<any>null);
    }

    /**
     * Allow you to create or replace an agent behaviour, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity AgentBehaviour entity to be added to the database
     * @return AgentBehaviour successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: AgentBehaviour): Promise<AgentBehaviour> {
        let url_ = this.baseUrl + "/simulator/api/AgentBehaviour/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<AgentBehaviour> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? AgentBehaviour.fromJS(resultData201) : new AgentBehaviour();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentBehaviour>(<any>null);
    }

    /**
     * Allow you to update an agent behaviour.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return AgentBehaviour successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/simulator/api/AgentBehaviour/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an agent behaviour.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/simulator/api/AgentBehaviour/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/simulator/api/AgentBehaviour/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class ScenarioClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all alarms that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Alarms successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Scenario[]> {
        let url_ = this.baseUrl + "/simulator/api/Scenario?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Scenario[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Scenario.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Scenario[]>(<any>null);
    }

    /**
     * Allow you to create an new scenario entity
     * @param authorization (optional) 
     * @param entity Scenario entity to be added to the database
     * @return Scenario successfully created.
     */
    post(authorization: string | null | undefined, entity: Scenario): Promise<Scenario> {
        let url_ = this.baseUrl + "/simulator/api/Scenario";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Scenario> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Scenario.fromJS(resultData201) : new Scenario();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Scenario>(<any>null);
    }

    /**
     * Allow you to delete all alarms that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Alarms are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/simulator/api/Scenario?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the scenario that match the id you have specified
     * @param authorization (optional) 
     * @return Scenario successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Scenario> {
        let url_ = this.baseUrl + "/simulator/api/Scenario/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Scenario> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Scenario.fromJS(resultData200) : new Scenario();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Scenario>(<any>null);
    }

    /**
     * Allow you to create or replace a scenario, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Scenario entity to be added to the database
     * @return Scenario successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Scenario): Promise<Scenario> {
        let url_ = this.baseUrl + "/simulator/api/Scenario/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Scenario> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Scenario.fromJS(resultData201) : new Scenario();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Scenario>(<any>null);
    }

    /**
     * Allow you to update an scenario.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Scenario successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/simulator/api/Scenario/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an scenario.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/simulator/api/Scenario/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/simulator/api/Scenario/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class SimulationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all alarms that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Alarms successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Simulation[]> {
        let url_ = this.baseUrl + "/simulator/api/Simulation?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Simulation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Simulation.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Simulation[]>(<any>null);
    }

    /**
     * Allow you to create an new simulation entity
     * @param authorization (optional) 
     * @param entity Simulation entity to be added to the database
     * @return Simulation successfully created.
     */
    post(authorization: string | null | undefined, entity: Simulation): Promise<Simulation> {
        let url_ = this.baseUrl + "/simulator/api/Simulation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Simulation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Simulation.fromJS(resultData201) : new Simulation();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Simulation>(<any>null);
    }

    /**
     * Allow you to delete all alarms that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Alarms are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/simulator/api/Simulation?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the simulation that match the id you have specified
     * @param authorization (optional) 
     * @return Simulation successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Simulation> {
        let url_ = this.baseUrl + "/simulator/api/Simulation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Simulation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Simulation.fromJS(resultData200) : new Simulation();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Simulation>(<any>null);
    }

    /**
     * Allow you to create or replace a simulation, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Simulation entity to be added to the database
     * @return Simulation successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Simulation): Promise<Simulation> {
        let url_ = this.baseUrl + "/simulator/api/Simulation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Simulation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Simulation.fromJS(resultData201) : new Simulation();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Simulation>(<any>null);
    }

    /**
     * Allow you to update an simulation.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Simulation successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/simulator/api/Simulation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an simulation.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/simulator/api/Simulation/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/simulator/api/Simulation/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class AccessBadgeCarrierClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all access badge carriers that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return AccessBadgeCarriers successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<AccessBadgeCarrier[]> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadgeCarrier?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<AccessBadgeCarrier[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AccessBadgeCarrier.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessBadgeCarrier[]>(<any>null);
    }

    /**
     * Allow you to create an new access badge carrier entity
     * @param authorization (optional) 
     * @param entity AccessBadgeCarrier entity to be added to the database
     * @return AccessBadgeCarrier successfully created.
     */
    post(authorization: string | null | undefined, entity: AccessBadgeCarrier): Promise<AccessBadgeCarrier> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadgeCarrier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<AccessBadgeCarrier> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? AccessBadgeCarrier.fromJS(resultData201) : new AccessBadgeCarrier();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessBadgeCarrier>(<any>null);
    }

    /**
     * Allow you to delete all access badge carriers that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return AccessBadgeCarriers are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadgeCarrier?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the access badge carrier that match the id you have specified
     * @param authorization (optional) 
     * @return AccessBadgeCarrier successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<AccessBadgeCarrier> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadgeCarrier/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AccessBadgeCarrier> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AccessBadgeCarrier.fromJS(resultData200) : new AccessBadgeCarrier();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessBadgeCarrier>(<any>null);
    }

    /**
     * Allow you to create or replace a access badge carrier, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity AccessBadgeCarrier entity to be added to the database
     * @return AccessBadgeCarrier successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: AccessBadgeCarrier): Promise<AccessBadgeCarrier> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadgeCarrier/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<AccessBadgeCarrier> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? AccessBadgeCarrier.fromJS(resultData201) : new AccessBadgeCarrier();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessBadgeCarrier>(<any>null);
    }

    /**
     * Allow you to update an access badge carrier.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return AccessBadgeCarrier successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadgeCarrier/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an access badge carrier.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadgeCarrier/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadgeCarrier/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class AccessBadgeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all access badges that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return AccessBadges successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<AccessBadge[]> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadge?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<AccessBadge[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AccessBadge.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessBadge[]>(<any>null);
    }

    /**
     * Allow you to create an new access badge entity
     * @param authorization (optional) 
     * @param entity AccessBadge entity to be added to the database
     * @return AccessBadge successfully created.
     */
    post(authorization: string | null | undefined, entity: AccessBadge): Promise<AccessBadge> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<AccessBadge> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? AccessBadge.fromJS(resultData201) : new AccessBadge();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessBadge>(<any>null);
    }

    /**
     * Allow you to delete all access badges that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return AccessBadges are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadge?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the access badge that match the id you have specified
     * @param authorization (optional) 
     * @return AccessBadge successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<AccessBadge> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadge/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AccessBadge> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AccessBadge.fromJS(resultData200) : new AccessBadge();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessBadge>(<any>null);
    }

    /**
     * Allow you to create or replace a access badge, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity AccessBadge entity to be added to the database
     * @return AccessBadge successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: AccessBadge): Promise<AccessBadge> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadge/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<AccessBadge> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? AccessBadge.fromJS(resultData201) : new AccessBadge();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessBadge>(<any>null);
    }

    /**
     * Allow you to update an access badge.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return AccessBadge successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadge/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an access badge.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadge/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessBadge/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class AccessNotificationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all access notifications that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return AccessNotifications successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<AccessNotification[]> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessNotification?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<AccessNotification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AccessNotification.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessNotification[]>(<any>null);
    }

    /**
     * Allow you to create an new access notification entity
     * @param authorization (optional) 
     * @param entity AccessNotification entity to be added to the database
     * @return AccessNotification successfully created.
     */
    post(authorization: string | null | undefined, entity: AccessNotification): Promise<AccessNotification> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<AccessNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? AccessNotification.fromJS(resultData201) : new AccessNotification();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessNotification>(<any>null);
    }

    /**
     * Allow you to delete all access notifications that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return AccessNotifications are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessNotification?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the access notification that match the id you have specified
     * @param authorization (optional) 
     * @return AccessNotification successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<AccessNotification> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessNotification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AccessNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AccessNotification.fromJS(resultData200) : new AccessNotification();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessNotification>(<any>null);
    }

    /**
     * Allow you to create or replace a access notification, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity AccessNotification entity to be added to the database
     * @return AccessNotification successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: AccessNotification): Promise<AccessNotification> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessNotification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<AccessNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? AccessNotification.fromJS(resultData201) : new AccessNotification();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessNotification>(<any>null);
    }

    /**
     * Allow you to update an access notification.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return AccessNotification successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessNotification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an access notification.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessNotification/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessNotification/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class AccessPointClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all access points that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return AccessPoints successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<AccessPoint[]> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessPoint?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<AccessPoint[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AccessPoint.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessPoint[]>(<any>null);
    }

    /**
     * Allow you to create an new access point entity
     * @param authorization (optional) 
     * @param entity AccessPoint entity to be added to the database
     * @return AccessPoint successfully created.
     */
    post(authorization: string | null | undefined, entity: AccessPoint): Promise<AccessPoint> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<AccessPoint> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? AccessPoint.fromJS(resultData201) : new AccessPoint();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessPoint>(<any>null);
    }

    /**
     * Allow you to delete all access points that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return AccessPoints are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessPoint?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the access point that match the id you have specified
     * @param authorization (optional) 
     * @return AccessPoint successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<AccessPoint> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessPoint/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AccessPoint> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AccessPoint.fromJS(resultData200) : new AccessPoint();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessPoint>(<any>null);
    }

    /**
     * Allow you to create or replace a access point, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity AccessPoint entity to be added to the database
     * @return AccessPoint successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: AccessPoint): Promise<AccessPoint> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessPoint/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<AccessPoint> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? AccessPoint.fromJS(resultData201) : new AccessPoint();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessPoint>(<any>null);
    }

    /**
     * Allow you to update an access point.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return AccessPoint successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessPoint/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an access point.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessPoint/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/accesscontrol/api/AccessPoint/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class AcsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all ACSes that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return ACSes successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Acs[]> {
        let url_ = this.baseUrl + "/accesscontrol/api/Acs?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Acs[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Acs.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Acs[]>(<any>null);
    }

    /**
     * Allow you to create an new ACS entity
     * @param authorization (optional) 
     * @param entity ACS entity to be added to the database
     * @return ACS successfully created.
     */
    post(authorization: string | null | undefined, entity: Acs): Promise<Acs> {
        let url_ = this.baseUrl + "/accesscontrol/api/Acs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Acs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Acs.fromJS(resultData201) : new Acs();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Acs>(<any>null);
    }

    /**
     * Allow you to delete all ACSes that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return ACSes are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accesscontrol/api/Acs?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the ACS that match the id you have specified
     * @param authorization (optional) 
     * @return ACS successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Acs> {
        let url_ = this.baseUrl + "/accesscontrol/api/Acs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Acs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Acs.fromJS(resultData200) : new Acs();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Acs>(<any>null);
    }

    /**
     * Allow you to create or replace an ACS, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity ACS entity to be added to the database
     * @return ACS successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Acs): Promise<Acs> {
        let url_ = this.baseUrl + "/accesscontrol/api/Acs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Acs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Acs.fromJS(resultData201) : new Acs();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Acs>(<any>null);
    }

    /**
     * Allow you to update an ACS.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return ACS successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/accesscontrol/api/Acs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an ACS.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accesscontrol/api/Acs/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/accesscontrol/api/Acs/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class DiagramClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all diagrams that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Diagrams successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Diagram[]> {
        let url_ = this.baseUrl + "/flow/api/Diagram?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Diagram[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Diagram.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Diagram[]>(<any>null);
    }

    /**
     * Allow you to create an new diagram entity
     * @param authorization (optional) 
     * @param entity Diagram entity to be added to the database
     * @return Diagram successfully created.
     */
    post(authorization: string | null | undefined, entity: Diagram): Promise<Diagram> {
        let url_ = this.baseUrl + "/flow/api/Diagram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Diagram> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Diagram.fromJS(resultData201) : new Diagram();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Diagram>(<any>null);
    }

    /**
     * Allow you to delete all diagrams that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Diagrams are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/flow/api/Diagram?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the diagram that match the id you have specified
     * @param authorization (optional) 
     * @return Diagram successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Diagram> {
        let url_ = this.baseUrl + "/flow/api/Diagram/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Diagram> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Diagram.fromJS(resultData200) : new Diagram();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Diagram>(<any>null);
    }

    /**
     * Allow you to create or replace a diagram, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Diagram entity to be added to the database
     * @return Diagram successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Diagram): Promise<Diagram> {
        let url_ = this.baseUrl + "/flow/api/Diagram/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Diagram> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Diagram.fromJS(resultData201) : new Diagram();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Diagram>(<any>null);
    }

    /**
     * Allow you to update an diagram.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Diagram successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/flow/api/Diagram/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an diagram.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/flow/api/Diagram/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/flow/api/Diagram/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class LogsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all logs that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Logs successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Logs[]> {
        let url_ = this.baseUrl + "/flow/api/Logs?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Logs[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Logs.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Logs[]>(<any>null);
    }

    /**
     * Allow you to create an new log entity
     * @param authorization (optional) 
     * @param entity Logs entity to be added to the database
     * @return Log successfully created.
     */
    post(authorization: string | null | undefined, entity: Logs): Promise<Logs> {
        let url_ = this.baseUrl + "/flow/api/Logs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Logs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Logs.fromJS(resultData201) : new Logs();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Logs>(<any>null);
    }

    /**
     * Allow you to delete all logs that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Logs are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/flow/api/Logs?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the log that match the id you have specified
     * @param authorization (optional) 
     * @return Log successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Logs> {
        let url_ = this.baseUrl + "/flow/api/Logs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Logs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Logs.fromJS(resultData200) : new Logs();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Logs>(<any>null);
    }

    /**
     * Allow you to create or replace a log, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Logs entity to be added to the database
     * @return Logs successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Logs): Promise<Logs> {
        let url_ = this.baseUrl + "/flow/api/Logs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Logs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Logs.fromJS(resultData201) : new Logs();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Logs>(<any>null);
    }

    /**
     * Allow you to update an log.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Log successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/flow/api/Logs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete a log.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/flow/api/Logs/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/flow/api/Logs/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }

    post2(index: string | null, authorization: string | null | undefined, log: Log): Promise<Log> {
        let url_ = this.baseUrl + "/log/api/Logs/{index}";
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined.");
        url_ = url_.replace("{index}", encodeURIComponent("" + index)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(log);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost2(_response);
        });
    }

    protected processPost2(response: Response): Promise<Log> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Log.fromJS(resultData200) : new Log();
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Log>(<any>null);
    }

    post22(index: string | null, authorization: string | null | undefined, logs: Log[]): Promise<Log> {
        let url_ = this.baseUrl + "/log/api/Logs/{index}/batch";
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined.");
        url_ = url_.replace("{index}", encodeURIComponent("" + index)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logs);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost22(_response);
        });
    }

    protected processPost22(response: Response): Promise<Log> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Log.fromJS(resultData200) : new Log();
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Log>(<any>null);
    }

    /**
     * Alarm represents an event that should be noticed and handled by an operator.
     * @param authorization (optional) 
     */
    search(index: string | null, authorization: string | null | undefined, searchQuery: any): Promise<any> {
        let url_ = this.baseUrl + "/log/api/Logs/{index}/search";
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined.");
        url_ = url_.replace("{index}", encodeURIComponent("" + index)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }
}

export class ModuleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all modules that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Modules successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Module[]> {
        let url_ = this.baseUrl + "/flow/api/Module?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Module.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module[]>(<any>null);
    }

    /**
     * Allow you to create an new module entity
     * @param authorization (optional) 
     * @param entity Module entity to be added to the database
     * @return Module successfully created.
     */
    post(authorization: string | null | undefined, entity: Module): Promise<Module> {
        let url_ = this.baseUrl + "/flow/api/Module";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Module> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Module.fromJS(resultData201) : new Module();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module>(<any>null);
    }

    /**
     * Allow you to delete all modules that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Modules are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/flow/api/Module?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the module that match the id you have specified
     * @param authorization (optional) 
     * @return Module successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Module> {
        let url_ = this.baseUrl + "/flow/api/Module/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Module> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Module.fromJS(resultData200) : new Module();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module>(<any>null);
    }

    /**
     * Allow you to create or replace a module, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Module entity to be added to the database
     * @return Module successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Module): Promise<Module> {
        let url_ = this.baseUrl + "/flow/api/Module/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Module> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Module.fromJS(resultData201) : new Module();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module>(<any>null);
    }

    /**
     * Allow you to update an module.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Module successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/flow/api/Module/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an module.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/flow/api/Module/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/flow/api/Module/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class ProcessClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all processes that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Processes successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Process[]> {
        let url_ = this.baseUrl + "/flow/api/Process?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Process[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Process.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Process[]>(<any>null);
    }

    /**
     * Allow you to create a new process entity
     * @param authorization (optional) 
     * @param entity Process entity to be added to the database
     * @return Process successfully created.
     */
    post(authorization: string | null | undefined, entity: Process): Promise<Process> {
        let url_ = this.baseUrl + "/flow/api/Process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Process> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Process.fromJS(resultData201) : new Process();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Process>(<any>null);
    }

    /**
     * Allow you to delete all processes that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Processes are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/flow/api/Process?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the process that match the id you have specified
     * @param authorization (optional) 
     * @return Process successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Process> {
        let url_ = this.baseUrl + "/flow/api/Process/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Process> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Process.fromJS(resultData200) : new Process();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Process>(<any>null);
    }

    /**
     * Allow you to create or replace a process, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Process entity to be added to the database
     * @return Process successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Process): Promise<Process> {
        let url_ = this.baseUrl + "/flow/api/Process/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Process> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Process.fromJS(resultData201) : new Process();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Process>(<any>null);
    }

    /**
     * Allow you to update a process.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Process successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/flow/api/Process/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete a process.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/flow/api/Process/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the logs from the specified process.
     * @param authorization (optional) 
     * @param id the identifier of the process from which you want to retrieve the logs.
     * @return Logs succesfully retrieved.
     */
    getLogs(authorization: string | null | undefined, id: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/flow/api/Process/{id}/Log";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLogs(_response);
        });
    }

    protected processGetLogs(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Allow you to add logs to a specific process
     * @param authorization (optional) 
     * @param id The identifier of the process in which this log must be displayed.
     * @param entity Log entity to be added to the database
     * @return Log was succesfully added to the process.
     */
    postLogs(authorization: string | null | undefined, id: string | null, entity: Logs): Promise<Logs> {
        let url_ = this.baseUrl + "/flow/api/Process/{id}/Log";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostLogs(_response);
        });
    }

    protected processPostLogs(response: Response): Promise<Logs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Logs.fromJS(resultData201) : new Logs();
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Logs>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/flow/api/Process/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class UserTaskClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all user tasks that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return UserTasks successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<UserTask[]> {
        let url_ = this.baseUrl + "/tasks/api/UserTask?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<UserTask[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UserTask.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserTask[]>(<any>null);
    }

    /**
     * Allow you to create a new user task entity
     * @param authorization (optional) 
     * @param entity UserTask entity to be added to the database
     * @return UserTask successfully created.
     */
    post(authorization: string | null | undefined, entity: UserTask): Promise<UserTask> {
        let url_ = this.baseUrl + "/tasks/api/UserTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<UserTask> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? UserTask.fromJS(resultData201) : new UserTask();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserTask>(<any>null);
    }

    /**
     * Allow you to delete all user tasks that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return UserTasks are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/tasks/api/UserTask?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the user tasks that match the id you have specified
     * @param authorization (optional) 
     * @return UserTask successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<UserTask> {
        let url_ = this.baseUrl + "/tasks/api/UserTask/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<UserTask> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserTask.fromJS(resultData200) : new UserTask();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserTask>(<any>null);
    }

    /**
     * Allow you to create or replace a user task, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity UserTask entity to be added to the database
     * @return UserTask successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: UserTask): Promise<UserTask> {
        let url_ = this.baseUrl + "/tasks/api/UserTask/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<UserTask> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? UserTask.fromJS(resultData201) : new UserTask();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserTask>(<any>null);
    }

    /**
     * Allow you to update an user task.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return UserTask successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/tasks/api/UserTask/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an user task.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/tasks/api/UserTask/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/tasks/api/UserTask/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class LicenseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all licenses that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @return Licenses successfully retrieved.
     */
    getAll(authorization: string | null | undefined): Promise<ProductLicense[]> {
        let url_ = this.baseUrl + "/license/api/License";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProductLicense[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ProductLicense.fromJS(item));
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductLicense[]>(<any>null);
    }

    /**
     * Allow you to upload a license to Constellation.
     * @param authorization (optional) 
     * @param licenseFile (optional) License file to be uploaded to Constellation.
     * @return License succesfully uploaded to Constellation.
     */
    upload(authorization: string | null | undefined, licenseFile: FileParameter | null | undefined): Promise<ProductLicense> {
        let url_ = this.baseUrl + "/license/api/License";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (licenseFile !== null && licenseFile !== undefined)
            content_.append("licenseFile", licenseFile.data, licenseFile.fileName ? licenseFile.fileName : "licenseFile");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<ProductLicense> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? ProductLicense.fromJS(resultData201) : new ProductLicense();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductLicense>(<any>null);
    }

    /**
     * Allow you to delete all licenses that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Licenses are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/license/api/License?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the license bound to a specific hardware
     * @param authorization (optional) 
     * @return License successfully retrieved.
     */
    getByHardwareId(authorization: string | null | undefined, hardwareId: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/license/api/License/hardware/{hardwareId}";
        if (hardwareId === undefined || hardwareId === null)
            throw new Error("The parameter 'hardwareId' must be defined.");
        url_ = url_.replace("{hardwareId}", encodeURIComponent("" + hardwareId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByHardwareId(_response);
        });
    }

    protected processGetByHardwareId(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Retrieve the license file that match the id you have specified.
     * @param authorization (optional) 
     * @return License file successfully retrieved.
     */
    get(authorization: string | null | undefined, id: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/license/api/License/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Allow you to delete a license.
     * @param authorization (optional) 
     * @param reason (optional) 
     * @return License sucesfully deleted or no content exist at this id.
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/license/api/License/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the license request file required for Obvious Technologies to generate a complete license for your installation.
     * @param authorization (optional) 
     * @return Request license file sucessfully retrieved.
     */
    getLicenseRequest(authorization: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/license/api/License/requestFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicenseRequest(_response);
        });
    }

    protected processGetLicenseRequest(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class VariableMessageSignClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all variable message sign that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return VariableMessageSigns successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<VariableMessageSign[]> {
        let url_ = this.baseUrl + "/variablemessagesigns/api/VariableMessageSign?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<VariableMessageSign[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(VariableMessageSign.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VariableMessageSign[]>(<any>null);
    }

    /**
     * Allow you to create an new variable message sign entity
     * @param authorization (optional) 
     * @param entity VariableMessageSign entity to be added to the database
     * @return VariableMessageSign successfully created.
     */
    post(authorization: string | null | undefined, entity: VariableMessageSign): Promise<VariableMessageSign> {
        let url_ = this.baseUrl + "/variablemessagesigns/api/VariableMessageSign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<VariableMessageSign> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? VariableMessageSign.fromJS(resultData201) : new VariableMessageSign();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VariableMessageSign>(<any>null);
    }

    /**
     * Allow you to delete all variable message signs that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return VariableMessageSigns are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/variablemessagesigns/api/VariableMessageSign?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the variable message sign that match the id you have specified
     * @param authorization (optional) 
     * @return VariableMessageSign successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<VariableMessageSign> {
        let url_ = this.baseUrl + "/variablemessagesigns/api/VariableMessageSign/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<VariableMessageSign> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? VariableMessageSign.fromJS(resultData200) : new VariableMessageSign();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VariableMessageSign>(<any>null);
    }

    /**
     * Allow you to create or replace a variable message sign, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity VariableMessageSign entity to be added to the database
     * @return VariableMessageSign successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: VariableMessageSign): Promise<VariableMessageSign> {
        let url_ = this.baseUrl + "/variablemessagesigns/api/VariableMessageSign/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<VariableMessageSign> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? VariableMessageSign.fromJS(resultData201) : new VariableMessageSign();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VariableMessageSign>(<any>null);
    }

    /**
     * Allow you to update a variable message sign.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return VariableMessageSign successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/variablemessagesigns/api/VariableMessageSign/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete a variable message sign.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/variablemessagesigns/api/VariableMessageSign/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/variablemessagesigns/api/VariableMessageSign/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class SipPhoneConfigurationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve the sip phone configuration that is associated with the token you have provided.
     * @param authorization (optional) 
     * @return Sip phone configuration successfully retrieved.
     */
    getMine(authorization: string | null | undefined): Promise<SipPhoneConfiguration> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneConfiguration/myself";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMine(_response);
        });
    }

    protected processGetMine(response: Response): Promise<SipPhoneConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SipPhoneConfiguration.fromJS(resultData200) : new SipPhoneConfiguration();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SipPhoneConfiguration>(<any>null);
    }

    /**
     * Retrieve all sipPhoneConfigurations that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return SipPhoneConfigurations successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<SipPhoneConfiguration[]> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneConfiguration?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<SipPhoneConfiguration[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SipPhoneConfiguration.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SipPhoneConfiguration[]>(<any>null);
    }

    /**
     * Allow you to create an new sipPhoneConfiguration entity
     * @param authorization (optional) 
     * @param entity SipPhoneConfiguration entity to be added to the database
     * @return SipPhoneConfiguration successfully created.
     */
    post(authorization: string | null | undefined, entity: SipPhoneConfiguration): Promise<SipPhoneConfiguration> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<SipPhoneConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? SipPhoneConfiguration.fromJS(resultData201) : new SipPhoneConfiguration();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SipPhoneConfiguration>(<any>null);
    }

    /**
     * Allow you to delete all sipPhoneConfigurations that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return SipPhoneConfigurations are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneConfiguration?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the sipPhoneConfiguration that match the id you have specified
     * @param authorization (optional) 
     * @return SipPhoneConfiguration successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<SipPhoneConfiguration> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneConfiguration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SipPhoneConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SipPhoneConfiguration.fromJS(resultData200) : new SipPhoneConfiguration();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SipPhoneConfiguration>(<any>null);
    }

    /**
     * Allow you to create or replace a sipPhoneConfiguration, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity SipPhoneConfiguration entity to be added to the database
     * @return SipPhoneConfiguration successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: SipPhoneConfiguration): Promise<SipPhoneConfiguration> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneConfiguration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<SipPhoneConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? SipPhoneConfiguration.fromJS(resultData201) : new SipPhoneConfiguration();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SipPhoneConfiguration>(<any>null);
    }

    /**
     * Allow you to update an sipPhoneConfiguration.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return SipPhoneConfiguration successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneConfiguration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an sipPhoneConfiguration.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneConfiguration/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneConfiguration/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class SipPhoneContactClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all sipPhoneContacts that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return SipPhoneContacts successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<SipPhoneContact[]> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneContact?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<SipPhoneContact[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SipPhoneContact.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SipPhoneContact[]>(<any>null);
    }

    /**
     * Allow you to create an new sipPhoneContact entity
     * @param authorization (optional) 
     * @param entity SipPhoneContact entity to be added to the database
     * @return SipPhoneContact successfully created.
     */
    post(authorization: string | null | undefined, entity: SipPhoneContact): Promise<SipPhoneContact> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<SipPhoneContact> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? SipPhoneContact.fromJS(resultData201) : new SipPhoneContact();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SipPhoneContact>(<any>null);
    }

    /**
     * Allow you to delete all sipPhoneContacts that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return SipPhoneContacts are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneContact?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the sipPhoneContact that match the id you have specified
     * @param authorization (optional) 
     * @return SipPhoneContact successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<SipPhoneContact> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneContact/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SipPhoneContact> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SipPhoneContact.fromJS(resultData200) : new SipPhoneContact();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SipPhoneContact>(<any>null);
    }

    /**
     * Allow you to create or replace a sipPhoneContact, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity SipPhoneContact entity to be added to the database
     * @return SipPhoneContact successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: SipPhoneContact): Promise<SipPhoneContact> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneContact/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<SipPhoneContact> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? SipPhoneContact.fromJS(resultData201) : new SipPhoneContact();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SipPhoneContact>(<any>null);
    }

    /**
     * Allow you to update an sipPhoneContact.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return SipPhoneContact successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneContact/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an sipPhoneContact.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneContact/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/sip/api/SipPhoneContact/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class NotificationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all notifications that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Notifications successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Notification[]> {
        let url_ = this.baseUrl + "/notifications/api/Notification?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Notification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Notification.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification[]>(<any>null);
    }

    /**
     * Allow you to create an new notification entity
     * @param authorization (optional) 
     * @param entity Notification entity to be added to the database
     * @return Notification successfully created.
     */
    post(authorization: string | null | undefined, entity: Notification): Promise<Notification> {
        let url_ = this.baseUrl + "/notifications/api/Notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Notification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Notification.fromJS(resultData201) : new Notification();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification>(<any>null);
    }

    /**
     * Allow you to delete all notifications that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Notifications are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/notifications/api/Notification?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the notification that match the id you have specified
     * @param authorization (optional) 
     * @return Notification successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Notification> {
        let url_ = this.baseUrl + "/notifications/api/Notification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Notification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Notification.fromJS(resultData200) : new Notification();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification>(<any>null);
    }

    /**
     * Allow you to create or replace a notification, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Notification entity to be added to the database
     * @return Notification successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Notification): Promise<Notification> {
        let url_ = this.baseUrl + "/notifications/api/Notification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Notification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Notification.fromJS(resultData201) : new Notification();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification>(<any>null);
    }

    /**
     * Allow you to update an notification.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Notification successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/notifications/api/Notification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an notification.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/notifications/api/Notification/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/notifications/api/Notification/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class NotificationTypeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all notificationTypes that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return NotificationTypes successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<NotificationType[]> {
        let url_ = this.baseUrl + "/notifications/api/NotificationType?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<NotificationType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NotificationType.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationType[]>(<any>null);
    }

    /**
     * Allow you to create an new notificationType entity
     * @param authorization (optional) 
     * @param entity NotificationType entity to be added to the database
     * @return NotificationType successfully created.
     */
    post(authorization: string | null | undefined, entity: NotificationType): Promise<NotificationType> {
        let url_ = this.baseUrl + "/notifications/api/NotificationType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<NotificationType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? NotificationType.fromJS(resultData201) : new NotificationType();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationType>(<any>null);
    }

    /**
     * Allow you to delete all notificationTypes that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return NotificationTypes are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/notifications/api/NotificationType?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the notificationType that match the id you have specified
     * @param authorization (optional) 
     * @return NotificationType successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<NotificationType> {
        let url_ = this.baseUrl + "/notifications/api/NotificationType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<NotificationType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NotificationType.fromJS(resultData200) : new NotificationType();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationType>(<any>null);
    }

    /**
     * Allow you to create or replace a notificationType, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity NotificationType entity to be added to the database
     * @return NotificationType successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: NotificationType): Promise<NotificationType> {
        let url_ = this.baseUrl + "/notifications/api/NotificationType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<NotificationType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? NotificationType.fromJS(resultData201) : new NotificationType();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationType>(<any>null);
    }

    /**
     * Allow you to update an notificationType.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return NotificationType successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/notifications/api/NotificationType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an notificationType.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/notifications/api/NotificationType/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve and download the sound associated with the notification type.
     * @param authorization (optional) 
     * @return Sound of the notification type succesfully retrieved
     */
    downloadSound(id: string | null, authorization: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/notifications/api/NotificationType/{id}/sound/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadSound(_response);
        });
    }

    protected processDownloadSound(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Retrieve and download the image associated with the notification type.
     * @param authorization (optional) 
     * @return Image of the notification type succesfully retrieved
     */
    downloadImage(id: string | null, authorization: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/notifications/api/NotificationType/{id}/image/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadImage(_response);
        });
    }

    protected processDownloadImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Upload sound to the specified notification type.
     * @param authorization (optional) 
     * @param file (optional) Sound to be added to the notification type.
     * @return Sound sucessfully uploaded to the notification type.
     */
    uploadSound(authorization: string | null | undefined, id: string | null, file: FileParameter | null | undefined): Promise<NotificationType> {
        let url_ = this.baseUrl + "/notifications/api/NotificationType/{id}/sound/upload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadSound(_response);
        });
    }

    protected processUploadSound(response: Response): Promise<NotificationType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? NotificationType.fromJS(resultData201) : new NotificationType();
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationType>(<any>null);
    }

    /**
     * Upload image to the specified notification type.
     * @param authorization (optional) 
     * @param file (optional) Image to be added to the notification type.
     * @return Image sucessfully uploaded to the notification type.
     */
    uploadImage(authorization: string | null | undefined, id: string | null, file: FileParameter | null | undefined): Promise<NotificationType> {
        let url_ = this.baseUrl + "/notifications/api/NotificationType/{id}/image/upload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadImage(_response);
        });
    }

    protected processUploadImage(response: Response): Promise<NotificationType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? NotificationType.fromJS(resultData201) : new NotificationType();
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationType>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/notifications/api/NotificationType/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class ConnectorClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all connectors that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Connectors successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Connector[]> {
        let url_ = this.baseUrl + "/connectors/api/Connector?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Connector[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Connector.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Connector[]>(<any>null);
    }

    /**
     * Allow you to deploy a new connector to integrate an external sub-system.
     * @param authorization (optional) 
     * @param entity Connector entity to be added to the database
     * @return Connector successfully created.
     */
    post(authorization: string | null | undefined, entity: Connector): Promise<Connector> {
        let url_ = this.baseUrl + "/connectors/api/Connector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Connector> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Connector.fromJS(resultData201) : new Connector();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Connector>(<any>null);
    }

    /**
     * Allow you to delete all connectors that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Connectors are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/connectors/api/Connector?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the connector that match the id you have specified
     * @param authorization (optional) 
     * @return Connector successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Connector> {
        let url_ = this.baseUrl + "/connectors/api/Connector/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Connector> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Connector.fromJS(resultData200) : new Connector();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Connector>(<any>null);
    }

    /**
     * Allow you to create or replace a connector, depending wether the id you provided already exists, specified connector will be redeployed upon calling this route.
     * @param authorization (optional) 
     * @param entity Connector entity to be added to the database
     * @return Connector successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Connector): Promise<Connector> {
        let url_ = this.baseUrl + "/connectors/api/Connector/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Connector> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Connector.fromJS(resultData201) : new Connector();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Connector>(<any>null);
    }

    /**
     * Allow you to update a connector's configuration, specified connector will be redeployed upon calling this route.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Connector successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/connectors/api/Connector/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete a connector.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/connectors/api/Connector/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/connectors/api/Connector/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class NodeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all nodes that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Nodes successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Node[]> {
        let url_ = this.baseUrl + "/connectors/api/Node?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Node[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Node.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Node[]>(<any>null);
    }

    /**
     * Allow you to create an new node entity
     * @param authorization (optional) 
     * @param entity Node entity to be added to the database
     * @return Node successfully created.
     */
    post(authorization: string | null | undefined, entity: Node): Promise<Node> {
        let url_ = this.baseUrl + "/connectors/api/Node";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Node> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Node.fromJS(resultData201) : new Node();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Node>(<any>null);
    }

    /**
     * Allow you to delete all nodes that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Nodes are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/connectors/api/Node?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the node that match the id you have specified
     * @param authorization (optional) 
     * @return Node successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Node> {
        let url_ = this.baseUrl + "/connectors/api/Node/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Node> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Node.fromJS(resultData200) : new Node();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Node>(<any>null);
    }

    /**
     * Allow you to create or replace a node, depending wether the id you provided already exists
     * @param authorization (optional) 
     * @param entity Node entity to be added to the database
     * @return Node successfully created or replaced.
     */
    put(id: string | null, authorization: string | null | undefined, entity: Node): Promise<Node> {
        let url_ = this.baseUrl + "/connectors/api/Node/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Node> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Node.fromJS(resultData201) : new Node();
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Node>(<any>null);
    }

    /**
     * Allow you to update an node.
     * @param authorization (optional) 
     * @param patch Should contains only the fields that you need to update
     * @return Node successfully updated.
     */
    patch(id: string | null, authorization: string | null | undefined, patch: any): Promise<any> {
        let url_ = this.baseUrl + "/connectors/api/Node/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Allow you to delete an node.
     * @param authorization (optional) 
     * @param reason (optional) 
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/connectors/api/Node/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/connectors/api/Node/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class TemplateClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://exp.dev.obvious.tech";
    }

    /**
     * Retrieve all templates that you are authorized to view, can be narrowed down using filters, pagination, and search fields.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Templates successfully retrieved.
     */
    getAll(authorization: string | null | undefined, filters: string | null | undefined, sorts: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Promise<Template[]> {
        let url_ = this.baseUrl + "/connectors/api/Template?";
        if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&"; 
        if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&"; 
        if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Template[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Template.fromJS(item));
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Template[]>(<any>null);
    }

    /**
     * Allow you to delete all templates that you are authorized to delete, can be narrowed down using filters. use with cautious.
     * @param authorization (optional) 
     * @param filters (optional) 
     * @param reason (optional) 
     * @return Templates are sucesfully deleted or no contents match the query
     */
    deleteAll(authorization: string | null | undefined, filters: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/connectors/api/Template?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve the template that match the id you have specified
     * @param authorization (optional) 
     * @return Template successfully retrieved.
     */
    get(id: string | null, authorization: string | null | undefined): Promise<Template> {
        let url_ = this.baseUrl + "/connectors/api/Template/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Template> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Template.fromJS(resultData200) : new Template();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Template>(<any>null);
    }

    /**
     * Allow you to delete a template.
     * @param authorization (optional) 
     * @param reason (optional) 
     * @return Template sucesfully deleted or no content exist at this id.
     */
    delete(id: string | null, authorization: string | null | undefined, reason: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/connectors/api/Template/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResponse.fromJS(resultData404) : new NotFoundResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve and download the constellation connector package (.ccp) file associated to a template.
     * @param authorization (optional) 
     * @return Constellation connector package of the attachment succesfully retrieved
     */
    download(id: string | null, authorization: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connectors/api/Template/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Upload constellation connector package (.ccp) file to the specified template.
     * @param authorization (optional) 
     * @param file (optional) File to be added to the attachment, must be .ccp file.
     * @return Constellation connector package sucessfully uploaded to the template.
     */
    upload(authorization: string | null | undefined, file: FileParameter | null | undefined): Promise<Template> {
        let url_ = this.baseUrl + "/connectors/api/Template/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<Template> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? UnauthorizedResponse.fromJS(resultData401) : new UnauthorizedResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResponse.fromJS(resultData400) : new BadRequestResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? Template.fromJS(resultData201) : new Template();
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Template>(<any>null);
    }

    count(authorization: string | null | undefined, filters: string | null | undefined, search: string | null | undefined): Promise<CountResponse> {
        let url_ = this.baseUrl + "/connectors/api/Template/count?";
        if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&"; 
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "authorization": authorization !== undefined && authorization !== null ? "" + authorization : "", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<CountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountResponse.fromJS(resultData200) : new CountResponse();
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ErrorResponse.fromJS(resultData401) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ErrorResponse.fromJS(resultData400) : new ErrorResponse();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountResponse>(<any>null);
    }
}

export class SaltChanged implements ISaltChanged {
    id?: string | undefined;
    creatorId?: string | undefined;
    traceId?: string | undefined;
    value!: string;
    key?: string | undefined;

    constructor(data?: ISaltChanged) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creatorId = data["creatorId"];
            this.traceId = data["traceId"];
            this.value = data["value"];
            this.key = data["key"];
        }
    }

    static fromJS(data: any): SaltChanged {
        data = typeof data === 'object' ? data : {};
        let result = new SaltChanged();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorId"] = this.creatorId;
        data["traceId"] = this.traceId;
        data["value"] = this.value;
        data["key"] = this.key;
        return data; 
    }
}

export interface ISaltChanged {
    id?: string | undefined;
    creatorId?: string | undefined;
    traceId?: string | undefined;
    value: string;
    key?: string | undefined;
}

/** Authorizations allow to grant access to a passport or a role, to access certain functions or access entities of a group. */
export class Authorization implements IAuthorization {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the bearer of this authorization. */
    bearer?: Bearer | undefined;
    /** Define the `data` field type. */
    type!: string;
    /** Represents the group that this Authorization concerns. */
    group!: string;
    /** Represents the data held in this authorization, this field can have completely different schemes, the `type` field define how it should be parsed. */
    data!: any;

    constructor(data?: IAuthorization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.bearer = data["bearer"] ? Bearer.fromJS(data["bearer"]) : <any>undefined;
            this.type = data["type"];
            this.group = data["group"];
            this.data = data["data"];
        }
    }

    static fromJS(data: any): Authorization {
        data = typeof data === 'object' ? data : {};
        let result = new Authorization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["bearer"] = this.bearer ? this.bearer.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["group"] = this.group;
        data["data"] = this.data;
        return data; 
    }
}

/** Authorizations allow to grant access to a passport or a role, to access certain functions or access entities of a group. */
export interface IAuthorization {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the bearer of this authorization. */
    bearer?: Bearer | undefined;
    /** Define the `data` field type. */
    type: string;
    /** Represents the group that this Authorization concerns. */
    group: string;
    /** Represents the data held in this authorization, this field can have completely different schemes, the `type` field define how it should be parsed. */
    data: any;
}

export class Bearer implements IBearer {
    /** Represents the identifier of the bearer of this authorization. */
    bearerId?: string | undefined;
    /** Represents the type of the bearer of this authorization. */
    bearerType!: BearerType;

    constructor(data?: IBearer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bearerId = data["bearerId"];
            this.bearerType = data["bearerType"];
        }
    }

    static fromJS(data: any): Bearer {
        data = typeof data === 'object' ? data : {};
        let result = new Bearer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bearerId"] = this.bearerId;
        data["bearerType"] = this.bearerType;
        return data; 
    }
}

export interface IBearer {
    /** Represents the identifier of the bearer of this authorization. */
    bearerId?: string | undefined;
    /** Represents the type of the bearer of this authorization. */
    bearerType: BearerType;
}

export enum BearerType {
    Passport = "Passport", 
    Role = "Role", 
}

export class UnauthorizedResponse implements IUnauthorizedResponse {
    statusCode!: HttpStatusCode;
    errorMessage?: string | undefined;

    constructor(data?: IUnauthorizedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.statusCode = data["statusCode"];
            this.errorMessage = data["errorMessage"];
        }
    }

    static fromJS(data: any): UnauthorizedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnauthorizedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["errorMessage"] = this.errorMessage;
        return data; 
    }
}

export interface IUnauthorizedResponse {
    statusCode: HttpStatusCode;
    errorMessage?: string | undefined;
}

export enum HttpStatusCode {
    Continue = 100, 
    SwitchingProtocols = 101, 
    Processing = 102, 
    EarlyHints = 103, 
    OK = 200, 
    Created = 201, 
    Accepted = 202, 
    NonAuthoritativeInformation = 203, 
    NoContent = 204, 
    ResetContent = 205, 
    PartialContent = 206, 
    MultiStatus = 207, 
    AlreadyReported = 208, 
    IMUsed = 226, 
    MultipleChoices = 300, 
    Ambiguous = 300, 
    MovedPermanently = 301, 
    Moved = 301, 
    Found = 302, 
    Redirect = 302, 
    SeeOther = 303, 
    RedirectMethod = 303, 
    NotModified = 304, 
    UseProxy = 305, 
    Unused = 306, 
    TemporaryRedirect = 307, 
    RedirectKeepVerb = 307, 
    PermanentRedirect = 308, 
    BadRequest = 400, 
    Unauthorized = 401, 
    PaymentRequired = 402, 
    Forbidden = 403, 
    NotFound = 404, 
    MethodNotAllowed = 405, 
    NotAcceptable = 406, 
    ProxyAuthenticationRequired = 407, 
    RequestTimeout = 408, 
    Conflict = 409, 
    Gone = 410, 
    LengthRequired = 411, 
    PreconditionFailed = 412, 
    RequestEntityTooLarge = 413, 
    RequestUriTooLong = 414, 
    UnsupportedMediaType = 415, 
    RequestedRangeNotSatisfiable = 416, 
    ExpectationFailed = 417, 
    MisdirectedRequest = 421, 
    UnprocessableEntity = 422, 
    Locked = 423, 
    FailedDependency = 424, 
    UpgradeRequired = 426, 
    PreconditionRequired = 428, 
    TooManyRequests = 429, 
    RequestHeaderFieldsTooLarge = 431, 
    UnavailableForLegalReasons = 451, 
    InternalServerError = 500, 
    NotImplemented = 501, 
    BadGateway = 502, 
    ServiceUnavailable = 503, 
    GatewayTimeout = 504, 
    HttpVersionNotSupported = 505, 
    VariantAlsoNegotiates = 506, 
    InsufficientStorage = 507, 
    LoopDetected = 508, 
    NotExtended = 510, 
    NetworkAuthenticationRequired = 511, 
}

export class BadRequestResponse implements IBadRequestResponse {
    statusCode!: HttpStatusCode;
    errorMessage?: string | undefined;

    constructor(data?: IBadRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.statusCode = data["statusCode"];
            this.errorMessage = data["errorMessage"];
        }
    }

    static fromJS(data: any): BadRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BadRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["errorMessage"] = this.errorMessage;
        return data; 
    }
}

export interface IBadRequestResponse {
    statusCode: HttpStatusCode;
    errorMessage?: string | undefined;
}

export class NotFoundResponse implements INotFoundResponse {
    statusCode!: HttpStatusCode;
    errorMessage?: string | undefined;

    constructor(data?: INotFoundResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.statusCode = data["statusCode"];
            this.errorMessage = data["errorMessage"];
        }
    }

    static fromJS(data: any): NotFoundResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotFoundResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["errorMessage"] = this.errorMessage;
        return data; 
    }
}

export interface INotFoundResponse {
    statusCode: HttpStatusCode;
    errorMessage?: string | undefined;
}

export class CountResponse implements ICountResponse {
    entity?: string | undefined;
    count!: number;

    constructor(data?: ICountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entity = data["entity"];
            this.count = data["count"];
        }
    }

    static fromJS(data: any): CountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity;
        data["count"] = this.count;
        return data; 
    }
}

export interface ICountResponse {
    entity?: string | undefined;
    count: number;
}

export class ErrorResponse implements IErrorResponse {
    statusCode!: HttpStatusCode;
    errorMessage?: string | undefined;

    constructor(data?: IErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.statusCode = data["statusCode"];
            this.errorMessage = data["errorMessage"];
        }
    }

    static fromJS(data: any): ErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["errorMessage"] = this.errorMessage;
        return data; 
    }
}

export interface IErrorResponse {
    statusCode: HttpStatusCode;
    errorMessage?: string | undefined;
}

/** Groups allow to bring together entities and offer a hierarchical vision of entities in Constellation. Groups can be created in a hierarchical way, allowing to create sub-groups into groups, as such, sub-grouping is made using the `name` field of this Entity as an example, the `/world/france/` group would be a sub-group to the `/world/` group and the `/world/` group would be a sub-group to the `/` group. */
export class Group implements IGroup {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the full name of the group, including its path delimiters `/` */
    name!: string;

    constructor(data?: IGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): Group {
        data = typeof data === 'object' ? data : {};
        let result = new Group();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        return data; 
    }
}

/** Groups allow to bring together entities and offer a hierarchical vision of entities in Constellation. Groups can be created in a hierarchical way, allowing to create sub-groups into groups, as such, sub-grouping is made using the `name` field of this Entity as an example, the `/world/france/` group would be a sub-group to the `/world/` group and the `/world/` group would be a sub-group to the `/` group. */
export interface IGroup {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the full name of the group, including its path delimiters `/` */
    name: string;
}

/** PassportConfiguration Entity */
export class PassportConfiguration implements IPassportConfiguration {
    id?: string | undefined;
    groups?: string[] | undefined;
    configuration?: any | undefined;

    constructor(data?: IPassportConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.configuration = data["configuration"];
        }
    }

    static fromJS(data: any): PassportConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new PassportConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["configuration"] = this.configuration;
        return data; 
    }
}

/** PassportConfiguration Entity */
export interface IPassportConfiguration {
    id?: string | undefined;
    groups?: string[] | undefined;
    configuration?: any | undefined;
}

/** Passports are the back-bone of the Authentication service, they allow you to signin and be identified by Constellation. */
export class Passport implements IPassport {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** The accessKey is generated by the system and can be used to signin without requiring username and password. */
    accessKey?: string | undefined;
    /** Represents the username part of the passport's credentials. */
    username!: string;
    /** Represents the password part of the passport's credentials. */
    password!: string;
    /** Represents the roles that this passport has, the passport will inherit all authorizations of the specified roles.  */
    roleIds!: string[];

    constructor(data?: IPassport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roleIds = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.accessKey = data["accessKey"];
            this.username = data["username"];
            this.password = data["password"];
            if (data["roleIds"] && data["roleIds"].constructor === Array) {
                this.roleIds = [];
                for (let item of data["roleIds"])
                    this.roleIds.push(item);
            }
        }
    }

    static fromJS(data: any): Passport {
        data = typeof data === 'object' ? data : {};
        let result = new Passport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["accessKey"] = this.accessKey;
        data["username"] = this.username;
        data["password"] = this.password;
        if (this.roleIds && this.roleIds.constructor === Array) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data; 
    }
}

/** Passports are the back-bone of the Authentication service, they allow you to signin and be identified by Constellation. */
export interface IPassport {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** The accessKey is generated by the system and can be used to signin without requiring username and password. */
    accessKey?: string | undefined;
    /** Represents the username part of the passport's credentials. */
    username: string;
    /** Represents the password part of the passport's credentials. */
    password: string;
    /** Represents the roles that this passport has, the passport will inherit all authorizations of the specified roles.  */
    roleIds: string[];
}

export class Role implements IRole {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the name of this role. */
    name!: string;
    /** Represents a description of this role.  */
    description?: string | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }
}

export interface IRole {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the name of this role. */
    name: string;
    /** Represents a description of this role.  */
    description?: string | undefined;
}

/** Represents templates used to create new roles linked to specific groups. */
export class RoleTemplate implements IRoleTemplate {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the name of this role template.  */
    name?: string | undefined;
    /** Represents a description of this role template.  */
    description?: string | undefined;
    /** Represents the authorizations that a new role created that is created with this template should have.  */
    authorizations?: AuthorizationData[] | undefined;

    constructor(data?: IRoleTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.description = data["description"];
            if (data["authorizations"] && data["authorizations"].constructor === Array) {
                this.authorizations = [];
                for (let item of data["authorizations"])
                    this.authorizations.push(AuthorizationData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new RoleTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["description"] = this.description;
        if (this.authorizations && this.authorizations.constructor === Array) {
            data["authorizations"] = [];
            for (let item of this.authorizations)
                data["authorizations"].push(item.toJSON());
        }
        return data; 
    }
}

/** Represents templates used to create new roles linked to specific groups. */
export interface IRoleTemplate {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the name of this role template.  */
    name?: string | undefined;
    /** Represents a description of this role template.  */
    description?: string | undefined;
    /** Represents the authorizations that a new role created that is created with this template should have.  */
    authorizations?: AuthorizationData[] | undefined;
}

export class AuthorizationData implements IAuthorizationData {
    type?: string | undefined;
    data?: any | undefined;

    constructor(data?: IAuthorizationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.data = data["data"];
        }
    }

    static fromJS(data: any): AuthorizationData {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["data"] = this.data;
        return data; 
    }
}

export interface IAuthorizationData {
    type?: string | undefined;
    data?: any | undefined;
}

export class SigninResponse implements ISigninResponse {
    /** Authentication token that you need to provide for subsequent API calls, contains your identity and authorizations data. */
    token?: string | undefined;
    /** Your passport data matching the credentials you provided */
    passport?: Passport | undefined;

    constructor(data?: ISigninResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.token = data["token"];
            this.passport = data["passport"] ? Passport.fromJS(data["passport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SigninResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SigninResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["passport"] = this.passport ? this.passport.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISigninResponse {
    /** Authentication token that you need to provide for subsequent API calls, contains your identity and authorizations data. */
    token?: string | undefined;
    /** Your passport data matching the credentials you provided */
    passport?: Passport | undefined;
}

export enum AuthorizationLevel {
    Read = 0, 
    Update = 1, 
    Create = 2, 
    Delete = 3, 
}

export class EntityGroupAuthorization implements IEntityGroupAuthorization {
    entity?: string | undefined;
    level!: AuthorizationLevel;

    constructor(data?: IEntityGroupAuthorization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entity = data["entity"];
            this.level = data["level"];
        }
    }

    static fromJS(data: any): EntityGroupAuthorization {
        data = typeof data === 'object' ? data : {};
        let result = new EntityGroupAuthorization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity;
        data["level"] = this.level;
        return data; 
    }
}

export interface IEntityGroupAuthorization {
    entity?: string | undefined;
    level: AuthorizationLevel;
}

/** Maps represents the 3d elements, as unity packages, displayed by clients as a layer of data on top of the 2d tiles */
export class Map implements IMap {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Name of the map.  */
    name!: string;
    /** Calibration data for this map.  */
    manifest!: MapManifest;
    /** Internal Id of the binary data file.  */
    fileId?: string | undefined;

    constructor(data?: IMap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.manifest = new MapManifest();
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.manifest = data["manifest"] ? MapManifest.fromJS(data["manifest"]) : new MapManifest();
            this.fileId = data["fileId"];
        }
    }

    static fromJS(data: any): Map {
        data = typeof data === 'object' ? data : {};
        let result = new Map();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["manifest"] = this.manifest ? this.manifest.toJSON() : <any>undefined;
        data["fileId"] = this.fileId;
        return data; 
    }
}

/** Maps represents the 3d elements, as unity packages, displayed by clients as a layer of data on top of the 2d tiles */
export interface IMap {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Name of the map.  */
    name: string;
    /** Calibration data for this map.  */
    manifest: MapManifest;
    /** Internal Id of the binary data file.  */
    fileId?: string | undefined;
}

export class MapManifest implements IMapManifest {
    /** The origin location of this map, the 0,0,0 location of the unity package should perfectly match the GPS coordinate define here.  */
    origin!: Coordinate;
    /** Scale ratio of the map, scale of 1 means 1 unity unit equals to 1 meters.  */
    scale!: number;
    /** Bounding box of the map, the coordinates should match the gps coordinates of the corners of the map.  */
    boundingBox!: GeoBoundingBox;
    /** Zoom level at which this map should be displayed. */
    zoomLevel!: number;

    constructor(data?: IMapManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.origin = new Coordinate();
            this.boundingBox = new GeoBoundingBox();
        }
    }

    init(data?: any) {
        if (data) {
            this.origin = data["origin"] ? Coordinate.fromJS(data["origin"]) : new Coordinate();
            this.scale = data["scale"];
            this.boundingBox = data["boundingBox"] ? GeoBoundingBox.fromJS(data["boundingBox"]) : new GeoBoundingBox();
            this.zoomLevel = data["zoomLevel"];
        }
    }

    static fromJS(data: any): MapManifest {
        data = typeof data === 'object' ? data : {};
        let result = new MapManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["scale"] = this.scale;
        data["boundingBox"] = this.boundingBox ? this.boundingBox.toJSON() : <any>undefined;
        data["zoomLevel"] = this.zoomLevel;
        return data; 
    }
}

export interface IMapManifest {
    /** The origin location of this map, the 0,0,0 location of the unity package should perfectly match the GPS coordinate define here.  */
    origin: Coordinate;
    /** Scale ratio of the map, scale of 1 means 1 unity unit equals to 1 meters.  */
    scale: number;
    /** Bounding box of the map, the coordinates should match the gps coordinates of the corners of the map.  */
    boundingBox: GeoBoundingBox;
    /** Zoom level at which this map should be displayed. */
    zoomLevel: number;
}

/** Define a Coordinate as WGS84 decimal degrees coordinate system and Altitude as meters above ground. */
export class Coordinate implements ICoordinate {
    /** Represents the latitude part of the coordinate in decimal degrees WGS84.  */
    latitude!: number;
    /** Represents the longitude part of the coordinate in decimal degrees WGS84.  */
    longitude!: number;
    /** Represents the altitude part of the coordinate, as meters above ground.  */
    altitude!: number;

    constructor(data?: ICoordinate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.altitude = data["altitude"];
        }
    }

    static fromJS(data: any): Coordinate {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["altitude"] = this.altitude;
        return data; 
    }
}

/** Define a Coordinate as WGS84 decimal degrees coordinate system and Altitude as meters above ground. */
export interface ICoordinate {
    /** Represents the latitude part of the coordinate in decimal degrees WGS84.  */
    latitude: number;
    /** Represents the longitude part of the coordinate in decimal degrees WGS84.  */
    longitude: number;
    /** Represents the altitude part of the coordinate, as meters above ground.  */
    altitude: number;
}

/** Define a bounding box using North West position and South East position as WGS84 decimal degrees coordinate system. */
export class GeoBoundingBox implements IGeoBoundingBox {
    /** North latitude coordinate.  */
    north!: number;
    /** West longitude coordinate.  */
    west!: number;
    /** South latitude coordinate.  */
    south!: number;
    /** East longitude coordinate.  */
    east!: number;

    constructor(data?: IGeoBoundingBox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.north = data["north"];
            this.west = data["west"];
            this.south = data["south"];
            this.east = data["east"];
        }
    }

    static fromJS(data: any): GeoBoundingBox {
        data = typeof data === 'object' ? data : {};
        let result = new GeoBoundingBox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["north"] = this.north;
        data["west"] = this.west;
        data["south"] = this.south;
        data["east"] = this.east;
        return data; 
    }
}

/** Define a bounding box using North West position and South East position as WGS84 decimal degrees coordinate system. */
export interface IGeoBoundingBox {
    /** North latitude coordinate.  */
    north: number;
    /** West longitude coordinate.  */
    west: number;
    /** South latitude coordinate.  */
    south: number;
    /** East longitude coordinate.  */
    east: number;
}

/** Point of views represents a predefined position and rotation on the globe that can be accessed by a client. Point of views can be created in a hierarchical way, allowing to create groups of point of views into point of views, as such, sub-grouping is made using the `Group` field of this Entity as an example, the `/world/france/` group would be a sub-group to the `/world/` group and the `/world/` group would be a sub-group to the `/` group. this shall be displayed by clients accordingly to show a hierarchical vision of the point of views. */
export class PointOfView implements IPointOfView {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the full path of this point of view, including its path delimiters `/` */
    group?: string | undefined;
    /** Represents the displayed name on screen, as it is meant to be on small buttons this name should be relatively small and abbreviated. */
    displayName!: string;
    /** Represents the full name without being abbreviated. */
    fullName!: string;
    /** Represents a short description of this point of view. */
    description?: string | undefined;
    /** Represents the coordinate of this point of view. */
    location!: Coordinate;
    /** Represents the rotation of this point of view. */
    rotation!: Rotation;

    constructor(data?: IPointOfView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.location = new Coordinate();
            this.rotation = new Rotation();
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.group = data["group"];
            this.displayName = data["displayName"];
            this.fullName = data["fullName"];
            this.description = data["description"];
            this.location = data["location"] ? Coordinate.fromJS(data["location"]) : new Coordinate();
            this.rotation = data["rotation"] ? Rotation.fromJS(data["rotation"]) : new Rotation();
        }
    }

    static fromJS(data: any): PointOfView {
        data = typeof data === 'object' ? data : {};
        let result = new PointOfView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["group"] = this.group;
        data["displayName"] = this.displayName;
        data["fullName"] = this.fullName;
        data["description"] = this.description;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["rotation"] = this.rotation ? this.rotation.toJSON() : <any>undefined;
        return data; 
    }
}

/** Point of views represents a predefined position and rotation on the globe that can be accessed by a client. Point of views can be created in a hierarchical way, allowing to create groups of point of views into point of views, as such, sub-grouping is made using the `Group` field of this Entity as an example, the `/world/france/` group would be a sub-group to the `/world/` group and the `/world/` group would be a sub-group to the `/` group. this shall be displayed by clients accordingly to show a hierarchical vision of the point of views. */
export interface IPointOfView {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the full path of this point of view, including its path delimiters `/` */
    group?: string | undefined;
    /** Represents the displayed name on screen, as it is meant to be on small buttons this name should be relatively small and abbreviated. */
    displayName: string;
    /** Represents the full name without being abbreviated. */
    fullName: string;
    /** Represents a short description of this point of view. */
    description?: string | undefined;
    /** Represents the coordinate of this point of view. */
    location: Coordinate;
    /** Represents the rotation of this point of view. */
    rotation: Rotation;
}

/** Define a rotation with Yaw/Pitch/Zoom as left handed system. */
export class Rotation implements IRotation {
    /** Yaw as degrees.  */
    yaw!: number;
    /** Pitch as degrees.  */
    pitch!: number;
    /** Zoom as meters above ground.  */
    zoom!: number;

    constructor(data?: IRotation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.yaw = data["yaw"];
            this.pitch = data["pitch"];
            this.zoom = data["zoom"];
        }
    }

    static fromJS(data: any): Rotation {
        data = typeof data === 'object' ? data : {};
        let result = new Rotation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["yaw"] = this.yaw;
        data["pitch"] = this.pitch;
        data["zoom"] = this.zoom;
        return data; 
    }
}

/** Define a rotation with Yaw/Pitch/Zoom as left handed system. */
export interface IRotation {
    /** Yaw as degrees.  */
    yaw: number;
    /** Pitch as degrees.  */
    pitch: number;
    /** Zoom as meters above ground.  */
    zoom: number;
}

/** Markers define a geo-referenced point that should be displayed on top of the rendered map by clients. Those markers can also have an entity attached so that clients can define additional behaviors upon clicking on them. Markers with EntityBehaviours have their location automatically updated by their underlying entity. */
export class Marker implements IMarker {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the group which this marker should be displayed in, mostly used to put a Marker directly inside a 3d building in Maps. */
    group?: string | undefined;
    /** Represents the coordinate of this Marker. */
    coordinates!: Coordinate;
    /** Represents the id of the `Image` entity, stored  */
    imageId?: string | undefined;
    /** Define if the underlying entity attached to this marker is active, default behaviour for inactive entities is to hide the marker. */
    isEntityActive!: boolean;
    /** Represents the Id of the underlying attached entity, can be set to null for a marker with no underlying attached entity. */
    entityId?: string | undefined;
    /** Represents the type of the underlying attached entity, can be set to null for a marker with no underlying attached entity. */
    entityBehaviour?: string | undefined;
    /** Represents the label that will be displayed over the icon on the map, this label should be relatively small. */
    label?: string | undefined;
    /** Represents the status of the underlying attached entity. */
    status?: string | undefined;
    /** Represents the layers name that this marker should be displayed with. */
    layers?: string[] | undefined;

    constructor(data?: IMarker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.coordinates = new Coordinate();
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.group = data["group"];
            this.coordinates = data["coordinates"] ? Coordinate.fromJS(data["coordinates"]) : new Coordinate();
            this.imageId = data["imageId"];
            this.isEntityActive = data["isEntityActive"];
            this.entityId = data["entityId"];
            this.entityBehaviour = data["entityBehaviour"];
            this.label = data["label"];
            this.status = data["status"];
            if (data["layers"] && data["layers"].constructor === Array) {
                this.layers = [];
                for (let item of data["layers"])
                    this.layers.push(item);
            }
        }
    }

    static fromJS(data: any): Marker {
        data = typeof data === 'object' ? data : {};
        let result = new Marker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["group"] = this.group;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        data["imageId"] = this.imageId;
        data["isEntityActive"] = this.isEntityActive;
        data["entityId"] = this.entityId;
        data["entityBehaviour"] = this.entityBehaviour;
        data["label"] = this.label;
        data["status"] = this.status;
        if (this.layers && this.layers.constructor === Array) {
            data["layers"] = [];
            for (let item of this.layers)
                data["layers"].push(item);
        }
        return data; 
    }
}

/** Markers define a geo-referenced point that should be displayed on top of the rendered map by clients. Those markers can also have an entity attached so that clients can define additional behaviors upon clicking on them. Markers with EntityBehaviours have their location automatically updated by their underlying entity. */
export interface IMarker {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the group which this marker should be displayed in, mostly used to put a Marker directly inside a 3d building in Maps. */
    group?: string | undefined;
    /** Represents the coordinate of this Marker. */
    coordinates: Coordinate;
    /** Represents the id of the `Image` entity, stored  */
    imageId?: string | undefined;
    /** Define if the underlying entity attached to this marker is active, default behaviour for inactive entities is to hide the marker. */
    isEntityActive: boolean;
    /** Represents the Id of the underlying attached entity, can be set to null for a marker with no underlying attached entity. */
    entityId?: string | undefined;
    /** Represents the type of the underlying attached entity, can be set to null for a marker with no underlying attached entity. */
    entityBehaviour?: string | undefined;
    /** Represents the label that will be displayed over the icon on the map, this label should be relatively small. */
    label?: string | undefined;
    /** Represents the status of the underlying attached entity. */
    status?: string | undefined;
    /** Represents the layers name that this marker should be displayed with. */
    layers?: string[] | undefined;
}

/** Drawing are geo-localized images generated by the users */
export class Drawing implements IDrawing {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the orientation in degrees with respect to the north. */
    orientation!: number;
    /** Represents the binary data that was uploaded to this drawing. */
    file?: DrawingFile | undefined;
    /** Represents the image bounding box */
    boundingBox!: DrawingBoundingBox;
    /** Represents the image resolution */
    resolution!: DrawingResolution;
    /** Represents the image GeoJson */
    geoJson?: any | undefined;
    /** Represents the layers name that this marker should be displayed with. */
    layers?: string[] | undefined;

    constructor(data?: IDrawing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boundingBox = new DrawingBoundingBox();
            this.resolution = new DrawingResolution();
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.orientation = data["orientation"];
            this.file = data["file"] ? DrawingFile.fromJS(data["file"]) : <any>undefined;
            this.boundingBox = data["boundingBox"] ? DrawingBoundingBox.fromJS(data["boundingBox"]) : new DrawingBoundingBox();
            this.resolution = data["resolution"] ? DrawingResolution.fromJS(data["resolution"]) : new DrawingResolution();
            this.geoJson = data["geoJson"];
            if (data["layers"] && data["layers"].constructor === Array) {
                this.layers = [];
                for (let item of data["layers"])
                    this.layers.push(item);
            }
        }
    }

    static fromJS(data: any): Drawing {
        data = typeof data === 'object' ? data : {};
        let result = new Drawing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["orientation"] = this.orientation;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["boundingBox"] = this.boundingBox ? this.boundingBox.toJSON() : <any>undefined;
        data["resolution"] = this.resolution ? this.resolution.toJSON() : <any>undefined;
        data["geoJson"] = this.geoJson;
        if (this.layers && this.layers.constructor === Array) {
            data["layers"] = [];
            for (let item of this.layers)
                data["layers"].push(item);
        }
        return data; 
    }
}

/** Drawing are geo-localized images generated by the users */
export interface IDrawing {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the orientation in degrees with respect to the north. */
    orientation: number;
    /** Represents the binary data that was uploaded to this drawing. */
    file?: DrawingFile | undefined;
    /** Represents the image bounding box */
    boundingBox: DrawingBoundingBox;
    /** Represents the image resolution */
    resolution: DrawingResolution;
    /** Represents the image GeoJson */
    geoJson?: any | undefined;
    /** Represents the layers name that this marker should be displayed with. */
    layers?: string[] | undefined;
}

/** DrawingResolution is a class containing the binary file content of Drawings */
export class DrawingFile implements IDrawingFile {
    /** File Id.  */
    id?: string | undefined;
    /** File Name.  */
    name?: string | undefined;

    constructor(data?: IDrawingFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): DrawingFile {
        data = typeof data === 'object' ? data : {};
        let result = new DrawingFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

/** DrawingResolution is a class containing the binary file content of Drawings */
export interface IDrawingFile {
    /** File Id.  */
    id?: string | undefined;
    /** File Name.  */
    name?: string | undefined;
}

/** DrawingResolution is a class containing the bounding box information of Drawings */
export class DrawingBoundingBox implements IDrawingBoundingBox {
    /** North latitude coordinate.  */
    north!: number;
    /** West longitude coordinate.  */
    west!: number;
    /** South latitude coordinate.  */
    south!: number;
    /** East longitude coordinate.  */
    east!: number;

    constructor(data?: IDrawingBoundingBox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.north = data["north"];
            this.west = data["west"];
            this.south = data["south"];
            this.east = data["east"];
        }
    }

    static fromJS(data: any): DrawingBoundingBox {
        data = typeof data === 'object' ? data : {};
        let result = new DrawingBoundingBox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["north"] = this.north;
        data["west"] = this.west;
        data["south"] = this.south;
        data["east"] = this.east;
        return data; 
    }
}

/** DrawingResolution is a class containing the bounding box information of Drawings */
export interface IDrawingBoundingBox {
    /** North latitude coordinate.  */
    north: number;
    /** West longitude coordinate.  */
    west: number;
    /** South latitude coordinate.  */
    south: number;
    /** East longitude coordinate.  */
    east: number;
}

/** DrawingResolution is a class containing the resolution information of Drawings */
export class DrawingResolution implements IDrawingResolution {
    /** Drawing x resolution.  */
    x!: number;
    /** Drawing y resolution.  */
    y!: number;

    constructor(data?: IDrawingResolution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.x = data["x"];
            this.y = data["y"];
        }
    }

    static fromJS(data: any): DrawingResolution {
        data = typeof data === 'object' ? data : {};
        let result = new DrawingResolution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        return data; 
    }
}

/** DrawingResolution is a class containing the resolution information of Drawings */
export interface IDrawingResolution {
    /** Drawing x resolution.  */
    x: number;
    /** Drawing y resolution.  */
    y: number;
}

/** Grids define a geo-referenced grid that should be displayed on top of the rendered map by clients. */
export class Grid implements IGrid {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the group which this grid should be displayed in, mostly used to put a grid directly inside a 3d building in Maps. */
    group?: string | undefined;
    /** Position of the grid on the map; using `linePivot`;`columnPivot` as origin. */
    coordinates!: Coordinate;
    /** Represents the name of this grid. */
    name?: string | undefined;
    /** Format: /^#[:xdigit:]{6}$/
Color of the grid's cell borders, in Hexadecimal RGB format
(with preceding `#`).
Example: "#12FFA3" */
    color?: string | undefined;
    /** Format: /^#[:xdigit:]{6}$/
Selected cell border color, in Hexadecimal RGB format
(including preceding `#`).

Example: "#12FFA3" */
    outlineColor?: string | undefined;
    /** Width of the cell borders in pixels. */
    thickness!: number;
    /** Double in range [0;100]
Grid's alpha value (transparency) */
    alpha!: number;
    /** Double in interval ]-∞;+∞[
Counter-clockwise rotation in degrees of the grid around it's centroid,
relative to the north. */
    orientation!: number;
    /** Integer in interval ]-∞;0]
Index of the first line from the top side of the (not yet rotated) Grid.
`0` meaning there is no negative indexed cells. */
    linesIndexBegin!: number;
    /** Integer in interval [1;+∞[
Index of the last line from the top side of the (not yet rotated) Grid. */
    linesIndexEnd!: number;
    /** Integer in interval ]-∞;0]
Index of the first column from the left side of the (not yet rotated) Grid.
`0` meaning there is no negative indexed cells. */
    columnsIndexBegin!: number;
    /** Integer in interval [1;+∞[
Index of the last column from the left side of the (not yet rotated) Grid. */
    columnsIndexEnd!: number;
    /** Double in interval [lineIndexBegin;lineIndexEnd]
Grid vertical coordinate (gridSize unit) at which the grid
is tangent to the globe (for spherical map projections).
The origin of the coordinates being placed at the top-left of the A1 cell.

This value is first set at creation time of the Grid (to the grid's centroid),
it is not changed when the grid is translated or expanded, but only when it's
orientation changes (on Hypervisor). */
    linePivot!: number;
    /** Double in interval [columnIndexBegin;columnIndexEnd]
Grid horizontal coordinate (gridSize unit) at which the grid
is tangent to the globe (for spherical map projections).
The origin of the coordinates being placed at the top-left of the A1 cell.

This value is first set at creation time of the Grid (to the grid's centroid),
it is not changed when the grid is translated or expanded, but only when it's
orientation changes (on Hypervisor). */
    columnPivot!: number;
    /** Unsigned Double
Grid cell width/heigth in meters.  */
    gridSize!: number;
    /** Represents the layers of this grid. */
    layers?: string[] | undefined;

    constructor(data?: IGrid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.coordinates = new Coordinate();
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.group = data["group"];
            this.coordinates = data["coordinates"] ? Coordinate.fromJS(data["coordinates"]) : new Coordinate();
            this.name = data["name"];
            this.color = data["color"];
            this.outlineColor = data["outlineColor"];
            this.thickness = data["thickness"];
            this.alpha = data["alpha"];
            this.orientation = data["orientation"];
            this.linesIndexBegin = data["linesIndexBegin"];
            this.linesIndexEnd = data["linesIndexEnd"];
            this.columnsIndexBegin = data["columnsIndexBegin"];
            this.columnsIndexEnd = data["columnsIndexEnd"];
            this.linePivot = data["linePivot"];
            this.columnPivot = data["columnPivot"];
            this.gridSize = data["gridSize"];
            if (data["layers"] && data["layers"].constructor === Array) {
                this.layers = [];
                for (let item of data["layers"])
                    this.layers.push(item);
            }
        }
    }

    static fromJS(data: any): Grid {
        data = typeof data === 'object' ? data : {};
        let result = new Grid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["group"] = this.group;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["color"] = this.color;
        data["outlineColor"] = this.outlineColor;
        data["thickness"] = this.thickness;
        data["alpha"] = this.alpha;
        data["orientation"] = this.orientation;
        data["linesIndexBegin"] = this.linesIndexBegin;
        data["linesIndexEnd"] = this.linesIndexEnd;
        data["columnsIndexBegin"] = this.columnsIndexBegin;
        data["columnsIndexEnd"] = this.columnsIndexEnd;
        data["linePivot"] = this.linePivot;
        data["columnPivot"] = this.columnPivot;
        data["gridSize"] = this.gridSize;
        if (this.layers && this.layers.constructor === Array) {
            data["layers"] = [];
            for (let item of this.layers)
                data["layers"].push(item);
        }
        return data; 
    }
}

/** Grids define a geo-referenced grid that should be displayed on top of the rendered map by clients. */
export interface IGrid {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the group which this grid should be displayed in, mostly used to put a grid directly inside a 3d building in Maps. */
    group?: string | undefined;
    /** Position of the grid on the map; using `linePivot`;`columnPivot` as origin. */
    coordinates: Coordinate;
    /** Represents the name of this grid. */
    name?: string | undefined;
    /** Format: /^#[:xdigit:]{6}$/
Color of the grid's cell borders, in Hexadecimal RGB format
(with preceding `#`).
Example: "#12FFA3" */
    color?: string | undefined;
    /** Format: /^#[:xdigit:]{6}$/
Selected cell border color, in Hexadecimal RGB format
(including preceding `#`).

Example: "#12FFA3" */
    outlineColor?: string | undefined;
    /** Width of the cell borders in pixels. */
    thickness: number;
    /** Double in range [0;100]
Grid's alpha value (transparency) */
    alpha: number;
    /** Double in interval ]-∞;+∞[
Counter-clockwise rotation in degrees of the grid around it's centroid,
relative to the north. */
    orientation: number;
    /** Integer in interval ]-∞;0]
Index of the first line from the top side of the (not yet rotated) Grid.
`0` meaning there is no negative indexed cells. */
    linesIndexBegin: number;
    /** Integer in interval [1;+∞[
Index of the last line from the top side of the (not yet rotated) Grid. */
    linesIndexEnd: number;
    /** Integer in interval ]-∞;0]
Index of the first column from the left side of the (not yet rotated) Grid.
`0` meaning there is no negative indexed cells. */
    columnsIndexBegin: number;
    /** Integer in interval [1;+∞[
Index of the last column from the left side of the (not yet rotated) Grid. */
    columnsIndexEnd: number;
    /** Double in interval [lineIndexBegin;lineIndexEnd]
Grid vertical coordinate (gridSize unit) at which the grid
is tangent to the globe (for spherical map projections).
The origin of the coordinates being placed at the top-left of the A1 cell.

This value is first set at creation time of the Grid (to the grid's centroid),
it is not changed when the grid is translated or expanded, but only when it's
orientation changes (on Hypervisor). */
    linePivot: number;
    /** Double in interval [columnIndexBegin;columnIndexEnd]
Grid horizontal coordinate (gridSize unit) at which the grid
is tangent to the globe (for spherical map projections).
The origin of the coordinates being placed at the top-left of the A1 cell.

This value is first set at creation time of the Grid (to the grid's centroid),
it is not changed when the grid is translated or expanded, but only when it's
orientation changes (on Hypervisor). */
    columnPivot: number;
    /** Unsigned Double
Grid cell width/heigth in meters.  */
    gridSize: number;
    /** Represents the layers of this grid. */
    layers?: string[] | undefined;
}

/** Layer Entity */
export class Layer implements ILayer {
    id?: string | undefined;
    groups?: string[] | undefined;
    name?: string | undefined;
    imageId?: string | undefined;
    group?: string | undefined;
    order!: number;
    displayName?: string | undefined;
    creationDate!: Date;
    lastEditDate!: Date;
    creatorId?: string | undefined;

    constructor(data?: ILayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.imageId = data["imageId"];
            this.group = data["group"];
            this.order = data["order"];
            this.displayName = data["displayName"];
            this.creationDate = data["creationDate"] ? new Date(data["creationDate"].toString()) : <any>undefined;
            this.lastEditDate = data["lastEditDate"] ? new Date(data["lastEditDate"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
        }
    }

    static fromJS(data: any): Layer {
        data = typeof data === 'object' ? data : {};
        let result = new Layer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["imageId"] = this.imageId;
        data["group"] = this.group;
        data["order"] = this.order;
        data["displayName"] = this.displayName;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["lastEditDate"] = this.lastEditDate ? this.lastEditDate.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        return data; 
    }
}

/** Layer Entity */
export interface ILayer {
    id?: string | undefined;
    groups?: string[] | undefined;
    name?: string | undefined;
    imageId?: string | undefined;
    group?: string | undefined;
    order: number;
    displayName?: string | undefined;
    creationDate: Date;
    lastEditDate: Date;
    creatorId?: string | undefined;
}

/** LayerInteractions Entity */
export class LayerInteractions implements ILayerInteractions {
    id?: string | undefined;
    groups?: string[] | undefined;
    tokens?: LayerInteractionToken[] | undefined;

    constructor(data?: ILayerInteractions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            if (data["tokens"] && data["tokens"].constructor === Array) {
                this.tokens = [];
                for (let item of data["tokens"])
                    this.tokens.push(LayerInteractionToken.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LayerInteractions {
        data = typeof data === 'object' ? data : {};
        let result = new LayerInteractions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        if (this.tokens && this.tokens.constructor === Array) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        return data; 
    }
}

/** LayerInteractions Entity */
export interface ILayerInteractions {
    id?: string | undefined;
    groups?: string[] | undefined;
    tokens?: LayerInteractionToken[] | undefined;
}

export class LayerInteractionToken implements ILayerInteractionToken {
    type?: string | undefined;
    value?: string | undefined;

    constructor(data?: ILayerInteractionToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): LayerInteractionToken {
        data = typeof data === 'object' ? data : {};
        let result = new LayerInteractionToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data; 
    }
}

export interface ILayerInteractionToken {
    type?: string | undefined;
    value?: string | undefined;
}

/** MarkerAttachments are a sub-entity of markers and are used to upload voluminous or extra data that should be attacked to the markers. */
export class MarkerAttachment implements IMarkerAttachment {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the identifier of the `Marker` that this attachment is linked to. */
    markerId?: string | undefined;
    /** Represents the type of this attachment, will also define how the `data` field is formatted. */
    type!: string;
    /** Represents the date of this attachment */
    creationDate!: Date;
    /** Represents the author of this attachment */
    author?: string | undefined;
    /** Represent the data held in this attachment, this field can have completely different schemes, the `type` field define how it should be parsed */
    data!: any;
    /** Represents the binary data that was uploaded to this attachment. */
    file?: AttachmentFile | undefined;

    constructor(data?: IMarkerAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.markerId = data["markerId"];
            this.type = data["type"];
            this.creationDate = data["creationDate"] ? new Date(data["creationDate"].toString()) : <any>undefined;
            this.author = data["author"];
            this.data = data["data"];
            this.file = data["file"] ? AttachmentFile.fromJS(data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MarkerAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new MarkerAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["markerId"] = this.markerId;
        data["type"] = this.type;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["author"] = this.author;
        data["data"] = this.data;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data; 
    }
}

/** MarkerAttachments are a sub-entity of markers and are used to upload voluminous or extra data that should be attacked to the markers. */
export interface IMarkerAttachment {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the identifier of the `Marker` that this attachment is linked to. */
    markerId?: string | undefined;
    /** Represents the type of this attachment, will also define how the `data` field is formatted. */
    type: string;
    /** Represents the date of this attachment */
    creationDate: Date;
    /** Represents the author of this attachment */
    author?: string | undefined;
    /** Represent the data held in this attachment, this field can have completely different schemes, the `type` field define how it should be parsed */
    data: any;
    /** Represents the binary data that was uploaded to this attachment. */
    file?: AttachmentFile | undefined;
}

export class AttachmentFile implements IAttachmentFile {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IAttachmentFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): AttachmentFile {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IAttachmentFile {
    id?: string | undefined;
    name?: string | undefined;
}

/** No documentation available yet. */
export class Track implements ITrack {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    location?: Coordinate | undefined;
    locationHistory?: TimestampedCoordinate[] | undefined;
    isEntityActive!: boolean;
    trackedEntityId?: string | undefined;
    trackedEntityBehaviour?: string | undefined;
    markerId?: string | undefined;

    constructor(data?: ITrack) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.location = data["location"] ? Coordinate.fromJS(data["location"]) : <any>undefined;
            if (data["locationHistory"] && data["locationHistory"].constructor === Array) {
                this.locationHistory = [];
                for (let item of data["locationHistory"])
                    this.locationHistory.push(TimestampedCoordinate.fromJS(item));
            }
            this.isEntityActive = data["isEntityActive"];
            this.trackedEntityId = data["trackedEntityId"];
            this.trackedEntityBehaviour = data["trackedEntityBehaviour"];
            this.markerId = data["markerId"];
        }
    }

    static fromJS(data: any): Track {
        data = typeof data === 'object' ? data : {};
        let result = new Track();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (this.locationHistory && this.locationHistory.constructor === Array) {
            data["locationHistory"] = [];
            for (let item of this.locationHistory)
                data["locationHistory"].push(item.toJSON());
        }
        data["isEntityActive"] = this.isEntityActive;
        data["trackedEntityId"] = this.trackedEntityId;
        data["trackedEntityBehaviour"] = this.trackedEntityBehaviour;
        data["markerId"] = this.markerId;
        return data; 
    }
}

/** No documentation available yet. */
export interface ITrack {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    location?: Coordinate | undefined;
    locationHistory?: TimestampedCoordinate[] | undefined;
    isEntityActive: boolean;
    trackedEntityId?: string | undefined;
    trackedEntityBehaviour?: string | undefined;
    markerId?: string | undefined;
}

/** Represents a coordinate with a timestamp attached. */
export class TimestampedCoordinate implements ITimestampedCoordinate {
    /** Timestamp when the item reached this location.  */
    timestamp!: Date;
    /** Location that was reached at the timestamp time.  */
    location?: Coordinate | undefined;

    constructor(data?: ITimestampedCoordinate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>undefined;
            this.location = data["location"] ? Coordinate.fromJS(data["location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimestampedCoordinate {
        data = typeof data === 'object' ? data : {};
        let result = new TimestampedCoordinate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data; 
    }
}

/** Represents a coordinate with a timestamp attached. */
export interface ITimestampedCoordinate {
    /** Timestamp when the item reached this location.  */
    timestamp: Date;
    /** Location that was reached at the timestamp time.  */
    location?: Coordinate | undefined;
}

/** No documentation available yet. */
export class Zone implements IZone {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    originator?: string | undefined;
    originatorId?: string | undefined;
    geometryType?: string | undefined;
    color?: string | undefined;
    geometry?: any | undefined;
    layers?: string[] | undefined;

    constructor(data?: IZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.originator = data["originator"];
            this.originatorId = data["originatorId"];
            this.geometryType = data["geometryType"];
            this.color = data["color"];
            this.geometry = data["geometry"];
            if (data["layers"] && data["layers"].constructor === Array) {
                this.layers = [];
                for (let item of data["layers"])
                    this.layers.push(item);
            }
        }
    }

    static fromJS(data: any): Zone {
        data = typeof data === 'object' ? data : {};
        let result = new Zone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["originator"] = this.originator;
        data["originatorId"] = this.originatorId;
        data["geometryType"] = this.geometryType;
        data["color"] = this.color;
        data["geometry"] = this.geometry;
        if (this.layers && this.layers.constructor === Array) {
            data["layers"] = [];
            for (let item of this.layers)
                data["layers"].push(item);
        }
        return data; 
    }
}

/** No documentation available yet. */
export interface IZone {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    originator?: string | undefined;
    originatorId?: string | undefined;
    geometryType?: string | undefined;
    color?: string | undefined;
    geometry?: any | undefined;
    layers?: string[] | undefined;
}

export class BoundingBox implements IBoundingBox {
    id?: string | undefined;
    cameraId?: string | undefined;
    date!: Date;
    minimumX!: number;
    maximumX!: number;
    minimumY!: number;
    maximumY!: number;
    screenWidth!: number;
    screenHeight!: number;
    colorHexadecimal?: string | undefined;
    description?: string | undefined;

    constructor(data?: IBoundingBox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.cameraId = data["cameraId"];
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.minimumX = data["minimumX"];
            this.maximumX = data["maximumX"];
            this.minimumY = data["minimumY"];
            this.maximumY = data["maximumY"];
            this.screenWidth = data["screenWidth"];
            this.screenHeight = data["screenHeight"];
            this.colorHexadecimal = data["colorHexadecimal"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): BoundingBox {
        data = typeof data === 'object' ? data : {};
        let result = new BoundingBox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cameraId"] = this.cameraId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["minimumX"] = this.minimumX;
        data["maximumX"] = this.maximumX;
        data["minimumY"] = this.minimumY;
        data["maximumY"] = this.maximumY;
        data["screenWidth"] = this.screenWidth;
        data["screenHeight"] = this.screenHeight;
        data["colorHexadecimal"] = this.colorHexadecimal;
        data["description"] = this.description;
        return data; 
    }
}

export interface IBoundingBox {
    id?: string | undefined;
    cameraId?: string | undefined;
    date: Date;
    minimumX: number;
    maximumX: number;
    minimumY: number;
    maximumY: number;
    screenWidth: number;
    screenHeight: number;
    colorHexadecimal?: string | undefined;
    description?: string | undefined;
}

/** Represents the data model of a ptz priority authorization type. */
export class PtzPriorityAuthorization implements IPtzPriorityAuthorization {
    /** Represents the weight this authorization has, higher the stronger.  */
    weight!: number;

    constructor(data?: IPtzPriorityAuthorization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.weight = data["weight"];
        }
    }

    static fromJS(data: any): PtzPriorityAuthorization {
        data = typeof data === 'object' ? data : {};
        let result = new PtzPriorityAuthorization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight;
        return data; 
    }
}

/** Represents the data model of a ptz priority authorization type. */
export interface IPtzPriorityAuthorization {
    /** Represents the weight this authorization has, higher the stronger.  */
    weight: number;
}

/** Represents the data model of a screeshot authorization type. */
export class ScreenshotAuthorization implements IScreenshotAuthorization {
    /** Defines wether this authorization grants access to screenshot or not.  */
    enabled!: boolean;

    constructor(data?: IScreenshotAuthorization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.enabled = data["enabled"];
        }
    }

    static fromJS(data: any): ScreenshotAuthorization {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenshotAuthorization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        return data; 
    }
}

/** Represents the data model of a screeshot authorization type. */
export interface IScreenshotAuthorization {
    /** Defines wether this authorization grants access to screenshot or not.  */
    enabled: boolean;
}

/** Images represents a gallery of UI elements used by the clients. */
export class Image implements IImage {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the image binary data.  */
    imageData!: string;
    /** Represents the name of the image.  */
    name?: string | undefined;

    constructor(data?: IImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.imageData = data["imageData"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): Image {
        data = typeof data === 'object' ? data : {};
        let result = new Image();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["imageData"] = this.imageData;
        data["name"] = this.name;
        return data; 
    }
}

/** Images represents a gallery of UI elements used by the clients. */
export interface IImage {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the image binary data.  */
    imageData: string;
    /** Represents the name of the image.  */
    name?: string | undefined;
}

export class SourceToDestinationDuration implements ISourceToDestinationDuration {
    sourceId?: string | undefined;
    destinationId?: string | undefined;
    duration!: number;

    constructor(data?: ISourceToDestinationDuration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sourceId = data["sourceId"];
            this.destinationId = data["destinationId"];
            this.duration = data["duration"];
        }
    }

    static fromJS(data: any): SourceToDestinationDuration {
        data = typeof data === 'object' ? data : {};
        let result = new SourceToDestinationDuration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["destinationId"] = this.destinationId;
        data["duration"] = this.duration;
        return data; 
    }
}

export interface ISourceToDestinationDuration {
    sourceId?: string | undefined;
    destinationId?: string | undefined;
    duration: number;
}

/** Paths represent a way to follow to reach a destination from a starting point. */
export class Path implements IPath {
    /** Represents the list of provided waypoints to be followed. */
    waypoints?: Coordinate[] | undefined;
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the assigned marker identifier that should follow this path, upon update of the location of the marker, path may be recalculated. */
    markerId?: string | undefined;
    /** Represents the destination marker identifier that should be reached, upon update of the location of the destination marker, path may be recalculated. */
    destinationMarkerId?: string | undefined;
    /** Represents the percentage progression of the assigned marker towards the destination. */
    markerProgress!: number;
    /** Represents the initial duration that this path should've take upon creation. */
    initialDuration!: number;
    /** Represents the start time of this path. */
    startDate!: Date;
    /** Represents the predicted end time of this path. */
    endDate!: Date;
    /** Represents the initial location. */
    start!: Coordinate;
    /** Represents the destination location.  */
    end!: Coordinate;
    /** Obsolete, the `steps` field should be used instead */
    waypointsByIndex!: { [key: string] : Coordinate[]; };
    /** Represents all the steps to be made to reach the destination, each element in this list is a sub-portion of the way, taking into account provided waypoints. */
    steps?: Step[][] | undefined;
    /** Represents the transport mode that was used to calculate the path initially. */
    transportMode?: string | undefined;
    /** Represents the name of the entity. */
    name?: string | undefined;
    /** Represents the layers name that this marker should be displayed with. */
    layers?: string[] | undefined;

    constructor(data?: IPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.start = new Coordinate();
            this.end = new Coordinate();
            this.waypointsByIndex = {};
        }
    }

    init(data?: any) {
        if (data) {
            if (data["waypoints"] && data["waypoints"].constructor === Array) {
                this.waypoints = [];
                for (let item of data["waypoints"])
                    this.waypoints.push(Coordinate.fromJS(item));
            }
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.markerId = data["markerId"];
            this.destinationMarkerId = data["destinationMarkerId"];
            this.markerProgress = data["markerProgress"];
            this.initialDuration = data["initialDuration"];
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.start = data["start"] ? Coordinate.fromJS(data["start"]) : new Coordinate();
            this.end = data["end"] ? Coordinate.fromJS(data["end"]) : new Coordinate();
            if (data["waypointsByIndex"]) {
                this.waypointsByIndex = {};
                for (let key in data["waypointsByIndex"]) {
                    if (data["waypointsByIndex"].hasOwnProperty(key))
                        this.waypointsByIndex[key] = data["waypointsByIndex"][key] ? data["waypointsByIndex"][key].map((i: any) => Coordinate.fromJS(i)) : [];
                }
            }
            if (data["steps"] && data["steps"].constructor === Array) {
                this.steps = [];
                for (let item of data["steps"])
                    this.steps.push(item);
            }
            this.transportMode = data["transportMode"];
            this.name = data["name"];
            if (data["layers"] && data["layers"].constructor === Array) {
                this.layers = [];
                for (let item of data["layers"])
                    this.layers.push(item);
            }
        }
    }

    static fromJS(data: any): Path {
        data = typeof data === 'object' ? data : {};
        let result = new Path();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.waypoints && this.waypoints.constructor === Array) {
            data["waypoints"] = [];
            for (let item of this.waypoints)
                data["waypoints"].push(item.toJSON());
        }
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["markerId"] = this.markerId;
        data["destinationMarkerId"] = this.destinationMarkerId;
        data["markerProgress"] = this.markerProgress;
        data["initialDuration"] = this.initialDuration;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["start"] = this.start ? this.start.toJSON() : <any>undefined;
        data["end"] = this.end ? this.end.toJSON() : <any>undefined;
        if (this.waypointsByIndex) {
            data["waypointsByIndex"] = {};
            for (let key in this.waypointsByIndex) {
                if (this.waypointsByIndex.hasOwnProperty(key))
                    data["waypointsByIndex"][key] = this.waypointsByIndex[key];
            }
        }
        if (this.steps && this.steps.constructor === Array) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item);
        }
        data["transportMode"] = this.transportMode;
        data["name"] = this.name;
        if (this.layers && this.layers.constructor === Array) {
            data["layers"] = [];
            for (let item of this.layers)
                data["layers"].push(item);
        }
        return data; 
    }
}

/** Paths represent a way to follow to reach a destination from a starting point. */
export interface IPath {
    /** Represents the list of provided waypoints to be followed. */
    waypoints?: Coordinate[] | undefined;
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the assigned marker identifier that should follow this path, upon update of the location of the marker, path may be recalculated. */
    markerId?: string | undefined;
    /** Represents the destination marker identifier that should be reached, upon update of the location of the destination marker, path may be recalculated. */
    destinationMarkerId?: string | undefined;
    /** Represents the percentage progression of the assigned marker towards the destination. */
    markerProgress: number;
    /** Represents the initial duration that this path should've take upon creation. */
    initialDuration: number;
    /** Represents the start time of this path. */
    startDate: Date;
    /** Represents the predicted end time of this path. */
    endDate: Date;
    /** Represents the initial location. */
    start: Coordinate;
    /** Represents the destination location.  */
    end: Coordinate;
    /** Obsolete, the `steps` field should be used instead */
    waypointsByIndex: { [key: string] : Coordinate[]; };
    /** Represents all the steps to be made to reach the destination, each element in this list is a sub-portion of the way, taking into account provided waypoints. */
    steps?: Step[][] | undefined;
    /** Represents the transport mode that was used to calculate the path initially. */
    transportMode?: string | undefined;
    /** Represents the name of the entity. */
    name?: string | undefined;
    /** Represents the layers name that this marker should be displayed with. */
    layers?: string[] | undefined;
}

/** Taken from project-osrm, please review http://project-osrm.org/docs/v5.5.1/api/#nearest-service */
export class Step implements IStep {
    intersections?: Intersection[] | undefined;
    driving_side?: string | undefined;
    geometry?: Geometry | undefined;
    mode?: string | undefined;
    maneuver?: Maneuver | undefined;
    weight!: number;
    duration!: number;
    name?: string | undefined;
    distance!: number;

    constructor(data?: IStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["intersections"] && data["intersections"].constructor === Array) {
                this.intersections = [];
                for (let item of data["intersections"])
                    this.intersections.push(Intersection.fromJS(item));
            }
            this.driving_side = data["driving_side"];
            this.geometry = data["geometry"] ? Geometry.fromJS(data["geometry"]) : <any>undefined;
            this.mode = data["mode"];
            this.maneuver = data["maneuver"] ? Maneuver.fromJS(data["maneuver"]) : <any>undefined;
            this.weight = data["weight"];
            this.duration = data["duration"];
            this.name = data["name"];
            this.distance = data["distance"];
        }
    }

    static fromJS(data: any): Step {
        data = typeof data === 'object' ? data : {};
        let result = new Step();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.intersections && this.intersections.constructor === Array) {
            data["intersections"] = [];
            for (let item of this.intersections)
                data["intersections"].push(item.toJSON());
        }
        data["driving_side"] = this.driving_side;
        data["geometry"] = this.geometry ? this.geometry.toJSON() : <any>undefined;
        data["mode"] = this.mode;
        data["maneuver"] = this.maneuver ? this.maneuver.toJSON() : <any>undefined;
        data["weight"] = this.weight;
        data["duration"] = this.duration;
        data["name"] = this.name;
        data["distance"] = this.distance;
        return data; 
    }
}

/** Taken from project-osrm, please review http://project-osrm.org/docs/v5.5.1/api/#nearest-service */
export interface IStep {
    intersections?: Intersection[] | undefined;
    driving_side?: string | undefined;
    geometry?: Geometry | undefined;
    mode?: string | undefined;
    maneuver?: Maneuver | undefined;
    weight: number;
    duration: number;
    name?: string | undefined;
    distance: number;
}

/** Taken from project-osrm, please review http://project-osrm.org/docs/v5.5.1/api/#nearest-service */
export class Intersection implements IIntersection {
    out!: number;
    entry?: boolean[] | undefined;
    bearings?: number[] | undefined;
    location?: number[] | undefined;
    in?: number | undefined;

    constructor(data?: IIntersection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.out = data["out"];
            if (data["entry"] && data["entry"].constructor === Array) {
                this.entry = [];
                for (let item of data["entry"])
                    this.entry.push(item);
            }
            if (data["bearings"] && data["bearings"].constructor === Array) {
                this.bearings = [];
                for (let item of data["bearings"])
                    this.bearings.push(item);
            }
            if (data["location"] && data["location"].constructor === Array) {
                this.location = [];
                for (let item of data["location"])
                    this.location.push(item);
            }
            this.in = data["in"];
        }
    }

    static fromJS(data: any): Intersection {
        data = typeof data === 'object' ? data : {};
        let result = new Intersection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["out"] = this.out;
        if (this.entry && this.entry.constructor === Array) {
            data["entry"] = [];
            for (let item of this.entry)
                data["entry"].push(item);
        }
        if (this.bearings && this.bearings.constructor === Array) {
            data["bearings"] = [];
            for (let item of this.bearings)
                data["bearings"].push(item);
        }
        if (this.location && this.location.constructor === Array) {
            data["location"] = [];
            for (let item of this.location)
                data["location"].push(item);
        }
        data["in"] = this.in;
        return data; 
    }
}

/** Taken from project-osrm, please review http://project-osrm.org/docs/v5.5.1/api/#nearest-service */
export interface IIntersection {
    out: number;
    entry?: boolean[] | undefined;
    bearings?: number[] | undefined;
    location?: number[] | undefined;
    in?: number | undefined;
}

/** Taken from project-osrm, please review http://project-osrm.org/docs/v5.5.1/api/#nearest-service */
export class Geometry implements IGeometry {
    coordinates?: number[][] | undefined;
    type?: string | undefined;

    constructor(data?: IGeometry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["coordinates"] && data["coordinates"].constructor === Array) {
                this.coordinates = [];
                for (let item of data["coordinates"])
                    this.coordinates.push(item);
            }
            this.type = data["type"];
        }
    }

    static fromJS(data: any): Geometry {
        data = typeof data === 'object' ? data : {};
        let result = new Geometry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.coordinates && this.coordinates.constructor === Array) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item);
        }
        data["type"] = this.type;
        return data; 
    }
}

/** Taken from project-osrm, please review http://project-osrm.org/docs/v5.5.1/api/#nearest-service */
export interface IGeometry {
    coordinates?: number[][] | undefined;
    type?: string | undefined;
}

/** Taken from project-osrm, please review http://project-osrm.org/docs/v5.5.1/api/#nearest-service */
export class Maneuver implements IManeuver {
    bearing_after!: number;
    bearing_before!: number;
    location?: number[] | undefined;
    type?: string | undefined;
    modifier?: string | undefined;

    constructor(data?: IManeuver) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bearing_after = data["bearing_after"];
            this.bearing_before = data["bearing_before"];
            if (data["location"] && data["location"].constructor === Array) {
                this.location = [];
                for (let item of data["location"])
                    this.location.push(item);
            }
            this.type = data["type"];
            this.modifier = data["modifier"];
        }
    }

    static fromJS(data: any): Maneuver {
        data = typeof data === 'object' ? data : {};
        let result = new Maneuver();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bearing_after"] = this.bearing_after;
        data["bearing_before"] = this.bearing_before;
        if (this.location && this.location.constructor === Array) {
            data["location"] = [];
            for (let item of this.location)
                data["location"].push(item);
        }
        data["type"] = this.type;
        data["modifier"] = this.modifier;
        return data; 
    }
}

/** Taken from project-osrm, please review http://project-osrm.org/docs/v5.5.1/api/#nearest-service */
export interface IManeuver {
    bearing_after: number;
    bearing_before: number;
    location?: number[] | undefined;
    type?: string | undefined;
    modifier?: string | undefined;
}

/** Request model to get a path between two WGS84 coordinates and optionnaly, a list of waypoints. */
export class PathBetweenRequest implements IPathBetweenRequest {
    /** Represents the starting point. */
    start!: Coordinate;
    /** Represents the destination. */
    end!: Coordinate;
    /** Represents the list of waypoints that this path should cover. */
    waypoints?: Coordinate[] | undefined;

    constructor(data?: IPathBetweenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.start = new Coordinate();
            this.end = new Coordinate();
        }
    }

    init(data?: any) {
        if (data) {
            this.start = data["start"] ? Coordinate.fromJS(data["start"]) : new Coordinate();
            this.end = data["end"] ? Coordinate.fromJS(data["end"]) : new Coordinate();
            if (data["waypoints"] && data["waypoints"].constructor === Array) {
                this.waypoints = [];
                for (let item of data["waypoints"])
                    this.waypoints.push(Coordinate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PathBetweenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PathBetweenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toJSON() : <any>undefined;
        data["end"] = this.end ? this.end.toJSON() : <any>undefined;
        if (this.waypoints && this.waypoints.constructor === Array) {
            data["waypoints"] = [];
            for (let item of this.waypoints)
                data["waypoints"].push(item.toJSON());
        }
        return data; 
    }
}

/** Request model to get a path between two WGS84 coordinates and optionnaly, a list of waypoints. */
export interface IPathBetweenRequest {
    /** Represents the starting point. */
    start: Coordinate;
    /** Represents the destination. */
    end: Coordinate;
    /** Represents the list of waypoints that this path should cover. */
    waypoints?: Coordinate[] | undefined;
}

/** Missions represents an order given from an operator to an Agenz mobile application. */
export class Mission implements IMission {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the passport identifier of the passport that gave this mission. */
    originatorId!: string;
    /** Represents the description of the mission given by the operator to be executed by the agent. */
    description!: string;
    /** Represents wether or not the agent has viewed this mission. */
    viewed!: boolean;
    /** Represents the id of the agent that has to execute this mission. */
    agentId!: string;
    /** Represents the identifier of the path that the agent has to follow to reach it's destination */
    pathId!: string;
    /** Represents the identifier of the alarm that this mission was created for. */
    alarmId?: string | undefined;

    constructor(data?: IMission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.originatorId = data["originatorId"];
            this.description = data["description"];
            this.viewed = data["viewed"];
            this.agentId = data["agentId"];
            this.pathId = data["pathId"];
            this.alarmId = data["alarmId"];
        }
    }

    static fromJS(data: any): Mission {
        data = typeof data === 'object' ? data : {};
        let result = new Mission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["originatorId"] = this.originatorId;
        data["description"] = this.description;
        data["viewed"] = this.viewed;
        data["agentId"] = this.agentId;
        data["pathId"] = this.pathId;
        data["alarmId"] = this.alarmId;
        return data; 
    }
}

/** Missions represents an order given from an operator to an Agenz mobile application. */
export interface IMission {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the passport identifier of the passport that gave this mission. */
    originatorId: string;
    /** Represents the description of the mission given by the operator to be executed by the agent. */
    description: string;
    /** Represents wether or not the agent has viewed this mission. */
    viewed: boolean;
    /** Represents the id of the agent that has to execute this mission. */
    agentId: string;
    /** Represents the identifier of the path that the agent has to follow to reach it's destination */
    pathId: string;
    /** Represents the identifier of the alarm that this mission was created for. */
    alarmId?: string | undefined;
}

/** Mission templates hold the default information that should be used when creating a new mission from a template. */
export class MissionTemplate implements IMissionTemplate {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this template. */
    name!: string;
    /** Represents the description of this template. */
    description!: string;
    /** Represents the text that should be displayed in the mission when creating a new mission using this template. */
    missionText!: string;

    constructor(data?: IMissionTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.description = data["description"];
            this.missionText = data["missionText"];
        }
    }

    static fromJS(data: any): MissionTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new MissionTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["description"] = this.description;
        data["missionText"] = this.missionText;
        return data; 
    }
}

/** Mission templates hold the default information that should be used when creating a new mission from a template. */
export interface IMissionTemplate {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this template. */
    name: string;
    /** Represents the description of this template. */
    description: string;
    /** Represents the text that should be displayed in the mission when creating a new mission using this template. */
    missionText: string;
}

/** Agents represents mobile units that can receive mission and be dispatched on the ground to solve situations. */
export class Agent implements IAgent {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the first name of the agent.  */
    firstname!: string;
    /** Represents the status of the agent.  */
    status!: string;
    /** Represents the last name of the agent.  */
    lastname?: string | undefined;
    /** Represents the job of the agent.  */
    job?: string | undefined;
    /** Represents the identifier of the `Image` entity holding the photo of the agent.  */
    photoId?: string | undefined;
    /** Represents the organization this agent works for.  */
    organization?: string | undefined;
    /** Represents the service this agent works for.  */
    service?: string | undefined;
    /** Represents the birth date of the agent.  */
    birthDate!: Date;
    /** Represents the identifier of the `Marker` that is generated upon creation of the agent with `Location` filled. */
    markerId?: string | undefined;
    /** Represents the transport mode of the agent, can be `driving` or `walking`  */
    transportMode!: TransportMode;
    /** Represents the location in WGS84 decimal degrees of the agent.  */
    location?: Coordinate | undefined;
    locationTimestamp!: Date;
    /** Represents the identifier of the `passport` attached to this agent.  */
    passportId?: string | undefined;
    /** Represents the identifier of the `camera`s attached to this agent.  */
    cameraIds?: string[] | undefined;
    /** Represents the identifier of the current mission this agent has.  */
    missionId?: string | undefined;
    /** Defines wether the agent is currently connected.  */
    isConnected!: boolean;
    /** Number of active connections.  */
    activeConnections!: number;
    /** Represents the list of equipments of this agent.  */
    equipments?: string[] | undefined;

    constructor(data?: IAgent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.firstname = data["firstname"];
            this.status = data["status"];
            this.lastname = data["lastname"];
            this.job = data["job"];
            this.photoId = data["photoId"];
            this.organization = data["organization"];
            this.service = data["service"];
            this.birthDate = data["birthDate"] ? new Date(data["birthDate"].toString()) : <any>undefined;
            this.markerId = data["markerId"];
            this.transportMode = data["transportMode"];
            this.location = data["location"] ? Coordinate.fromJS(data["location"]) : <any>undefined;
            this.locationTimestamp = data["locationTimestamp"] ? new Date(data["locationTimestamp"].toString()) : <any>undefined;
            this.passportId = data["passportId"];
            if (data["cameraIds"] && data["cameraIds"].constructor === Array) {
                this.cameraIds = [];
                for (let item of data["cameraIds"])
                    this.cameraIds.push(item);
            }
            this.missionId = data["missionId"];
            this.isConnected = data["isConnected"];
            this.activeConnections = data["activeConnections"];
            if (data["equipments"] && data["equipments"].constructor === Array) {
                this.equipments = [];
                for (let item of data["equipments"])
                    this.equipments.push(item);
            }
        }
    }

    static fromJS(data: any): Agent {
        data = typeof data === 'object' ? data : {};
        let result = new Agent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["firstname"] = this.firstname;
        data["status"] = this.status;
        data["lastname"] = this.lastname;
        data["job"] = this.job;
        data["photoId"] = this.photoId;
        data["organization"] = this.organization;
        data["service"] = this.service;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["markerId"] = this.markerId;
        data["transportMode"] = this.transportMode;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["locationTimestamp"] = this.locationTimestamp ? this.locationTimestamp.toISOString() : <any>undefined;
        data["passportId"] = this.passportId;
        if (this.cameraIds && this.cameraIds.constructor === Array) {
            data["cameraIds"] = [];
            for (let item of this.cameraIds)
                data["cameraIds"].push(item);
        }
        data["missionId"] = this.missionId;
        data["isConnected"] = this.isConnected;
        data["activeConnections"] = this.activeConnections;
        if (this.equipments && this.equipments.constructor === Array) {
            data["equipments"] = [];
            for (let item of this.equipments)
                data["equipments"].push(item);
        }
        return data; 
    }
}

/** Agents represents mobile units that can receive mission and be dispatched on the ground to solve situations. */
export interface IAgent {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the first name of the agent.  */
    firstname: string;
    /** Represents the status of the agent.  */
    status: string;
    /** Represents the last name of the agent.  */
    lastname?: string | undefined;
    /** Represents the job of the agent.  */
    job?: string | undefined;
    /** Represents the identifier of the `Image` entity holding the photo of the agent.  */
    photoId?: string | undefined;
    /** Represents the organization this agent works for.  */
    organization?: string | undefined;
    /** Represents the service this agent works for.  */
    service?: string | undefined;
    /** Represents the birth date of the agent.  */
    birthDate: Date;
    /** Represents the identifier of the `Marker` that is generated upon creation of the agent with `Location` filled. */
    markerId?: string | undefined;
    /** Represents the transport mode of the agent, can be `driving` or `walking`  */
    transportMode: TransportMode;
    /** Represents the location in WGS84 decimal degrees of the agent.  */
    location?: Coordinate | undefined;
    locationTimestamp: Date;
    /** Represents the identifier of the `passport` attached to this agent.  */
    passportId?: string | undefined;
    /** Represents the identifier of the `camera`s attached to this agent.  */
    cameraIds?: string[] | undefined;
    /** Represents the identifier of the current mission this agent has.  */
    missionId?: string | undefined;
    /** Defines wether the agent is currently connected.  */
    isConnected: boolean;
    /** Number of active connections.  */
    activeConnections: number;
    /** Represents the list of equipments of this agent.  */
    equipments?: string[] | undefined;
}

/** Represents a transport mode. */
export enum TransportMode {
    Driving = "driving", 
    Walking = "walking", 
}

/** Agents statuses the differents statuses that a Agent can have. */
export class AgentStatus implements IAgentStatus {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this status. */
    name!: string;
    /** Represents the color that should be shown to the clients for Agents having this status. */
    color!: string;

    constructor(data?: IAgentStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.color = data["color"];
        }
    }

    static fromJS(data: any): AgentStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AgentStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["color"] = this.color;
        return data; 
    }
}

/** Agents statuses the differents statuses that a Agent can have. */
export interface IAgentStatus {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this status. */
    name: string;
    /** Represents the color that should be shown to the clients for Agents having this status. */
    color: string;
}

/** Cameras represents a physical camera sensor connected to the platform. */
export class Camera implements ICamera {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the full path of this camera, including its path delimiters `/`, so that it can be displayed in a folder-like list. */
    group?: string | undefined;
    /** Represents the name of the camera */
    name?: string | undefined;
    /** Represents the VMS identifier that this camera is attached to */
    vms?: string | undefined;
    /** Represents the identifier of the camera in the VMS external system. */
    vmsId?: string | undefined;
    /** Represents the identifier of another camera that should be displayed as a single one in clients due to their proximity. */
    subCameraId?: string | undefined;
    /** Represents the coordinate of this Camera. */
    location?: Coordinate | undefined;
    /** Represents the identifier of the `Marker` that is generated upon creation of the camera with `Location` filled. */
    markerId?: string | undefined;
    /** Represents the orientation of this camera in degrees, with north as a reference (north = 0°) */
    orientation!: number;
    /** Represents the tilt rotation of this camera in degrees, with ground-facing orientation as reference (ground-facing = 0°) */
    tilt!: number;
    /** Represents the field of view of the camera in degrees */
    fieldOfView!: number;
    /** Represents the depth of the camera to which it can be used effectively */
    depth!: number;
    /** Defines wether or not the camera has PTZ (Pan Tilt Zoom) capabilities */
    hasPtzCapabilities!: boolean;
    /** Defines the current PTZ State */
    ptzState?: Ptz | undefined;
    /** Defines the minimum rotation values that the camera can reach with PTZ capabilities */
    minimumPtz?: Ptz | undefined;
    /** Defines the maximum rotation values that the camera can reach with PTZ capabilities */
    maximumPtz?: Ptz | undefined;
    /** Defines the maximum rotation values that the camera can reach with PTZ capabilities */
    ptzController?: PtzController | undefined;
    /** Represents the current passport that is taking control of the PTZ capabilities of the camera. */
    ptzLock?: PtzLock | undefined;
    /** Represents the different PTZ presets that this camera have. */
    ptzPresets?: PtzPreset[] | undefined;
    /** Represents the width resolution of the camera in pixels. */
    width!: number;
    /** Represents the surrounding camera references to be overlayed on the stream for an easy navigation between streams. */
    surroundingCameraReferences?: SurroundingCameraReference[] | undefined;
    /** Represents the Height resolution of the camera in pixels. */
    height!: number;
    /** Represents the frame per seconds of the camera. */
    fps!: number;

    constructor(data?: ICamera) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.group = data["group"];
            this.name = data["name"];
            this.vms = data["vms"];
            this.vmsId = data["vmsId"];
            this.subCameraId = data["subCameraId"];
            this.location = data["location"] ? Coordinate.fromJS(data["location"]) : <any>undefined;
            this.markerId = data["markerId"];
            this.orientation = data["orientation"];
            this.tilt = data["tilt"];
            this.fieldOfView = data["fieldOfView"];
            this.depth = data["depth"];
            this.hasPtzCapabilities = data["hasPtzCapabilities"];
            this.ptzState = data["ptzState"] ? Ptz.fromJS(data["ptzState"]) : <any>undefined;
            this.minimumPtz = data["minimumPtz"] ? Ptz.fromJS(data["minimumPtz"]) : <any>undefined;
            this.maximumPtz = data["maximumPtz"] ? Ptz.fromJS(data["maximumPtz"]) : <any>undefined;
            this.ptzController = data["ptzController"] ? PtzController.fromJS(data["ptzController"]) : <any>undefined;
            this.ptzLock = data["ptzLock"] ? PtzLock.fromJS(data["ptzLock"]) : <any>undefined;
            if (data["ptzPresets"] && data["ptzPresets"].constructor === Array) {
                this.ptzPresets = [];
                for (let item of data["ptzPresets"])
                    this.ptzPresets.push(PtzPreset.fromJS(item));
            }
            this.width = data["width"];
            if (data["surroundingCameraReferences"] && data["surroundingCameraReferences"].constructor === Array) {
                this.surroundingCameraReferences = [];
                for (let item of data["surroundingCameraReferences"])
                    this.surroundingCameraReferences.push(SurroundingCameraReference.fromJS(item));
            }
            this.height = data["height"];
            this.fps = data["fps"];
        }
    }

    static fromJS(data: any): Camera {
        data = typeof data === 'object' ? data : {};
        let result = new Camera();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["group"] = this.group;
        data["name"] = this.name;
        data["vms"] = this.vms;
        data["vmsId"] = this.vmsId;
        data["subCameraId"] = this.subCameraId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["markerId"] = this.markerId;
        data["orientation"] = this.orientation;
        data["tilt"] = this.tilt;
        data["fieldOfView"] = this.fieldOfView;
        data["depth"] = this.depth;
        data["hasPtzCapabilities"] = this.hasPtzCapabilities;
        data["ptzState"] = this.ptzState ? this.ptzState.toJSON() : <any>undefined;
        data["minimumPtz"] = this.minimumPtz ? this.minimumPtz.toJSON() : <any>undefined;
        data["maximumPtz"] = this.maximumPtz ? this.maximumPtz.toJSON() : <any>undefined;
        data["ptzController"] = this.ptzController ? this.ptzController.toJSON() : <any>undefined;
        data["ptzLock"] = this.ptzLock ? this.ptzLock.toJSON() : <any>undefined;
        if (this.ptzPresets && this.ptzPresets.constructor === Array) {
            data["ptzPresets"] = [];
            for (let item of this.ptzPresets)
                data["ptzPresets"].push(item.toJSON());
        }
        data["width"] = this.width;
        if (this.surroundingCameraReferences && this.surroundingCameraReferences.constructor === Array) {
            data["surroundingCameraReferences"] = [];
            for (let item of this.surroundingCameraReferences)
                data["surroundingCameraReferences"].push(item.toJSON());
        }
        data["height"] = this.height;
        data["fps"] = this.fps;
        return data; 
    }
}

/** Cameras represents a physical camera sensor connected to the platform. */
export interface ICamera {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the full path of this camera, including its path delimiters `/`, so that it can be displayed in a folder-like list. */
    group?: string | undefined;
    /** Represents the name of the camera */
    name?: string | undefined;
    /** Represents the VMS identifier that this camera is attached to */
    vms?: string | undefined;
    /** Represents the identifier of the camera in the VMS external system. */
    vmsId?: string | undefined;
    /** Represents the identifier of another camera that should be displayed as a single one in clients due to their proximity. */
    subCameraId?: string | undefined;
    /** Represents the coordinate of this Camera. */
    location?: Coordinate | undefined;
    /** Represents the identifier of the `Marker` that is generated upon creation of the camera with `Location` filled. */
    markerId?: string | undefined;
    /** Represents the orientation of this camera in degrees, with north as a reference (north = 0°) */
    orientation: number;
    /** Represents the tilt rotation of this camera in degrees, with ground-facing orientation as reference (ground-facing = 0°) */
    tilt: number;
    /** Represents the field of view of the camera in degrees */
    fieldOfView: number;
    /** Represents the depth of the camera to which it can be used effectively */
    depth: number;
    /** Defines wether or not the camera has PTZ (Pan Tilt Zoom) capabilities */
    hasPtzCapabilities: boolean;
    /** Defines the current PTZ State */
    ptzState?: Ptz | undefined;
    /** Defines the minimum rotation values that the camera can reach with PTZ capabilities */
    minimumPtz?: Ptz | undefined;
    /** Defines the maximum rotation values that the camera can reach with PTZ capabilities */
    maximumPtz?: Ptz | undefined;
    /** Defines the maximum rotation values that the camera can reach with PTZ capabilities */
    ptzController?: PtzController | undefined;
    /** Represents the current passport that is taking control of the PTZ capabilities of the camera. */
    ptzLock?: PtzLock | undefined;
    /** Represents the different PTZ presets that this camera have. */
    ptzPresets?: PtzPreset[] | undefined;
    /** Represents the width resolution of the camera in pixels. */
    width: number;
    /** Represents the surrounding camera references to be overlayed on the stream for an easy navigation between streams. */
    surroundingCameraReferences?: SurroundingCameraReference[] | undefined;
    /** Represents the Height resolution of the camera in pixels. */
    height: number;
    /** Represents the frame per seconds of the camera. */
    fps: number;
}

/** Represents a Pan Tilt Zoom data model. */
export class Ptz implements IPtz {
    /** Pan value. */
    pan!: number;
    /** Tilt value. */
    tilt!: number;
    /** Zoom value. */
    zoom!: number;

    constructor(data?: IPtz) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pan = data["pan"];
            this.tilt = data["tilt"];
            this.zoom = data["zoom"];
        }
    }

    static fromJS(data: any): Ptz {
        data = typeof data === 'object' ? data : {};
        let result = new Ptz();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pan"] = this.pan;
        data["tilt"] = this.tilt;
        data["zoom"] = this.zoom;
        return data; 
    }
}

/** Represents a Pan Tilt Zoom data model. */
export interface IPtz {
    /** Pan value. */
    pan: number;
    /** Tilt value. */
    tilt: number;
    /** Zoom value. */
    zoom: number;
}

/** Data model meant to represent a virtual controller for the PTZ Camera. */
export class PtzController implements IPtzController {
    /** In case of a relative control, PtzState represent the state of the virtual joystick used to rotate the camera.
As for an absolute this represent the absolute rotation values to rotate the camera. */
    ptzState?: Ptz | undefined;
    /** Represents the speed that should be used to rotate the camera to requested location. */
    speed!: number;

    constructor(data?: IPtzController) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ptzState = data["ptzState"] ? Ptz.fromJS(data["ptzState"]) : <any>undefined;
            this.speed = data["speed"];
        }
    }

    static fromJS(data: any): PtzController {
        data = typeof data === 'object' ? data : {};
        let result = new PtzController();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ptzState"] = this.ptzState ? this.ptzState.toJSON() : <any>undefined;
        data["speed"] = this.speed;
        return data; 
    }
}

/** Data model meant to represent a virtual controller for the PTZ Camera. */
export interface IPtzController {
    /** In case of a relative control, PtzState represent the state of the virtual joystick used to rotate the camera.
As for an absolute this represent the absolute rotation values to rotate the camera. */
    ptzState?: Ptz | undefined;
    /** Represents the speed that should be used to rotate the camera to requested location. */
    speed: number;
}

/** Represents a PTZ Lock model, it is essentially made to avoid multiple passports to control the same camera at the same time. */
export class PtzLock implements IPtzLock {
    /** Represents the identifier of the current passport that is using the camera. */
    passportId?: string | undefined;
    /** Represents the weight of the passport that is using the camera (Weight defines wether a lock can be overrided by an account with a superior weight or not) */
    weight!: number;
    /** Represents the date where this lock was created, locks are meant to automatically expire after a configurable define-time. */
    timestamp!: Date;

    constructor(data?: IPtzLock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.passportId = data["passportId"];
            this.weight = data["weight"];
            this.timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PtzLock {
        data = typeof data === 'object' ? data : {};
        let result = new PtzLock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passportId"] = this.passportId;
        data["weight"] = this.weight;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

/** Represents a PTZ Lock model, it is essentially made to avoid multiple passports to control the same camera at the same time. */
export interface IPtzLock {
    /** Represents the identifier of the current passport that is using the camera. */
    passportId?: string | undefined;
    /** Represents the weight of the passport that is using the camera (Weight defines wether a lock can be overrided by an account with a superior weight or not) */
    weight: number;
    /** Represents the date where this lock was created, locks are meant to automatically expire after a configurable define-time. */
    timestamp: Date;
}

/** Represents a PTZ Preset */
export class PtzPreset implements IPtzPreset {
    /** Name of the preset. */
    name!: string;
    /** State of the preset. */
    ptzState?: Ptz | undefined;

    constructor(data?: IPtzPreset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.ptzState = data["ptzState"] ? Ptz.fromJS(data["ptzState"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PtzPreset {
        data = typeof data === 'object' ? data : {};
        let result = new PtzPreset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ptzState"] = this.ptzState ? this.ptzState.toJSON() : <any>undefined;
        return data; 
    }
}

/** Represents a PTZ Preset */
export interface IPtzPreset {
    /** Name of the preset. */
    name: string;
    /** State of the preset. */
    ptzState?: Ptz | undefined;
}

export class SurroundingCameraReference implements ISurroundingCameraReference {
    /** Represents the camera identifier that this reference relates to. */
    cameraId!: string;
    /** Represents the position of the camera icon to be overlayed on the stream. */
    streamPosition!: StreamPosition;

    constructor(data?: ISurroundingCameraReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.streamPosition = new StreamPosition();
        }
    }

    init(data?: any) {
        if (data) {
            this.cameraId = data["cameraId"];
            this.streamPosition = data["streamPosition"] ? StreamPosition.fromJS(data["streamPosition"]) : new StreamPosition();
        }
    }

    static fromJS(data: any): SurroundingCameraReference {
        data = typeof data === 'object' ? data : {};
        let result = new SurroundingCameraReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cameraId"] = this.cameraId;
        data["streamPosition"] = this.streamPosition ? this.streamPosition.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISurroundingCameraReference {
    /** Represents the camera identifier that this reference relates to. */
    cameraId: string;
    /** Represents the position of the camera icon to be overlayed on the stream. */
    streamPosition: StreamPosition;
}

export class StreamPosition implements IStreamPosition {
    /** Represents the position (0..1) on the X axis, 0 is max left and 1 is max right.  */
    x!: number;
    /** Represents the position (0..1) on the Y axis, 0 is max down and 1 is max up.  */
    y!: number;

    constructor(data?: IStreamPosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.x = data["x"];
            this.y = data["y"];
        }
    }

    static fromJS(data: any): StreamPosition {
        data = typeof data === 'object' ? data : {};
        let result = new StreamPosition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        return data; 
    }
}

export interface IStreamPosition {
    /** Represents the position (0..1) on the X axis, 0 is max left and 1 is max right.  */
    x: number;
    /** Represents the position (0..1) on the Y axis, 0 is max down and 1 is max up.  */
    y: number;
}

/** Result of a command to use the PTZ of a camera to rotate to an absolute state. */
export class AbsolutePtzStateWasSet implements IAbsolutePtzStateWasSet {
    /** Id of the event. */
    id?: string | undefined;
    /** Trace Id used to match request with generated event. */
    traceId?: string | undefined;
    /** If the request is made to move to a specific preset, preset name will be defined. */
    presetName?: string | undefined;
    /** Absolute state requested. */
    ptzState?: PtzController | undefined;
    /** Key of the event. */
    key?: string | undefined;
    /** Id of the camera. */
    cameraId?: string | undefined;
    /** Id of the passport that has requested to rotate the camera. */
    creatorId?: string | undefined;

    constructor(data?: IAbsolutePtzStateWasSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.traceId = data["traceId"];
            this.presetName = data["presetName"];
            this.ptzState = data["ptzState"] ? PtzController.fromJS(data["ptzState"]) : <any>undefined;
            this.key = data["key"];
            this.cameraId = data["cameraId"];
            this.creatorId = data["creatorId"];
        }
    }

    static fromJS(data: any): AbsolutePtzStateWasSet {
        data = typeof data === 'object' ? data : {};
        let result = new AbsolutePtzStateWasSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["traceId"] = this.traceId;
        data["presetName"] = this.presetName;
        data["ptzState"] = this.ptzState ? this.ptzState.toJSON() : <any>undefined;
        data["key"] = this.key;
        data["cameraId"] = this.cameraId;
        data["creatorId"] = this.creatorId;
        return data; 
    }
}

/** Result of a command to use the PTZ of a camera to rotate to an absolute state. */
export interface IAbsolutePtzStateWasSet {
    /** Id of the event. */
    id?: string | undefined;
    /** Trace Id used to match request with generated event. */
    traceId?: string | undefined;
    /** If the request is made to move to a specific preset, preset name will be defined. */
    presetName?: string | undefined;
    /** Absolute state requested. */
    ptzState?: PtzController | undefined;
    /** Key of the event. */
    key?: string | undefined;
    /** Id of the camera. */
    cameraId?: string | undefined;
    /** Id of the passport that has requested to rotate the camera. */
    creatorId?: string | undefined;
}

export class PtzToCoordinates implements IPtzToCoordinates {
    coordinates?: Coordinate | undefined;
    speed!: number;

    constructor(data?: IPtzToCoordinates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coordinates = data["coordinates"] ? Coordinate.fromJS(data["coordinates"]) : <any>undefined;
            this.speed = data["speed"];
        }
    }

    static fromJS(data: any): PtzToCoordinates {
        data = typeof data === 'object' ? data : {};
        let result = new PtzToCoordinates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        data["speed"] = this.speed;
        return data; 
    }
}

export interface IPtzToCoordinates {
    coordinates?: Coordinate | undefined;
    speed: number;
}

/** LiveStream represent a request to view live images of a camera. */
export class LiveStream implements ILiveStream {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the id of the camera that this live stream concerns. */
    cameraId!: string;
    /** Video Management Service will gracefully shutdown streams that has not received
any update on this field to make sure that no unused streams remains indefinitely.
LastKeepAlive has to be continuously updated every 60 seconds upon creation of the LiveStream. */
    lastKeepAlive!: Date;
    /** Represents the width resolution of the stream in pixels. */
    width!: number;
    /** Represents the Height resolution of the stream in pixels. */
    height!: number;
    /** Represents the codec that this stream is currently encoded in. */
    codec?: string | undefined;
    /** Represents the RTSP Link where binary data for video-streaming is available. */
    rtspLink?: string | undefined;

    constructor(data?: ILiveStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.cameraId = data["cameraId"];
            this.lastKeepAlive = data["lastKeepAlive"] ? new Date(data["lastKeepAlive"].toString()) : <any>undefined;
            this.width = data["width"];
            this.height = data["height"];
            this.codec = data["codec"];
            this.rtspLink = data["rtspLink"];
        }
    }

    static fromJS(data: any): LiveStream {
        data = typeof data === 'object' ? data : {};
        let result = new LiveStream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["cameraId"] = this.cameraId;
        data["lastKeepAlive"] = this.lastKeepAlive ? this.lastKeepAlive.toISOString() : <any>undefined;
        data["width"] = this.width;
        data["height"] = this.height;
        data["codec"] = this.codec;
        data["rtspLink"] = this.rtspLink;
        return data; 
    }
}

/** LiveStream represent a request to view live images of a camera. */
export interface ILiveStream {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the id of the camera that this live stream concerns. */
    cameraId: string;
    /** Video Management Service will gracefully shutdown streams that has not received
any update on this field to make sure that no unused streams remains indefinitely.
LastKeepAlive has to be continuously updated every 60 seconds upon creation of the LiveStream. */
    lastKeepAlive: Date;
    /** Represents the width resolution of the stream in pixels. */
    width: number;
    /** Represents the Height resolution of the stream in pixels. */
    height: number;
    /** Represents the codec that this stream is currently encoded in. */
    codec?: string | undefined;
    /** Represents the RTSP Link where binary data for video-streaming is available. */
    rtspLink?: string | undefined;
}

/** Model used to define a motion interval. */
export class TimeInterval implements ITimeInterval {
    /** Start time of motion. */
    startInterval!: Date;
    /** End time of motion. */
    endInterval!: Date;

    constructor(data?: ITimeInterval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startInterval = data["startInterval"] ? new Date(data["startInterval"].toString()) : <any>undefined;
            this.endInterval = data["endInterval"] ? new Date(data["endInterval"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeInterval {
        data = typeof data === 'object' ? data : {};
        let result = new TimeInterval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startInterval"] = this.startInterval ? this.startInterval.toISOString() : <any>undefined;
        data["endInterval"] = this.endInterval ? this.endInterval.toISOString() : <any>undefined;
        return data; 
    }
}

/** Model used to define a motion interval. */
export interface ITimeInterval {
    /** Start time of motion. */
    startInterval: Date;
    /** End time of motion. */
    endInterval: Date;
}

/** LiveStream represent a request to view past images of a camera. */
export class PlaybackStream implements IPlaybackStream {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the id of the camera that this playback stream concerns. */
    cameraId!: string;
    /** Video Management Service will gracefully shutdown streams that has not received
any update on this field to make sure that no unused streams remains indefinitely.
LastKeepAlive has to be continuously updated every 60 seconds upon creation of the LiveStream. */
    lastKeepAlive!: Date;
    /** Represents the start time of the requested sequence. */
    startTime!: Date;
    /** Represents the speed used for displaying the requested sequence. */
    speed!: number;
    /** Defines if this strem is currently playing or paused. */
    isPlaying!: boolean;
    /** Represents the Height resolution of the stream in pixels. */
    width!: number;
    /** Represents the width resolution of the stream in pixels. */
    height!: number;
    /** Represents the codec that this stream is currently encoded in. */
    codec?: string | undefined;
    /** Represents the current time of this stream. */
    currentTime!: Date;
    /** Represents the RTSP Link where binary data for video-streaming is available. */
    timestamp?: number | undefined;
    /** Defines wether the current selected time has recording or not.  */
    hasRecordingAtCurrentTime!: boolean;
    /** True if timestamp and currentime are synced   */
    currentTimeAndTimestampSynced!: boolean;
    /** Represents the Rtsp Link that this playback stream is available at.  */
    rtspLink?: string | undefined;

    constructor(data?: IPlaybackStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.cameraId = data["cameraId"];
            this.lastKeepAlive = data["lastKeepAlive"] ? new Date(data["lastKeepAlive"].toString()) : <any>undefined;
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.speed = data["speed"];
            this.isPlaying = data["isPlaying"];
            this.width = data["width"];
            this.height = data["height"];
            this.codec = data["codec"];
            this.currentTime = data["currentTime"] ? new Date(data["currentTime"].toString()) : <any>undefined;
            this.timestamp = data["timestamp"];
            this.hasRecordingAtCurrentTime = data["hasRecordingAtCurrentTime"];
            this.currentTimeAndTimestampSynced = data["currentTimeAndTimestampSynced"];
            this.rtspLink = data["rtspLink"];
        }
    }

    static fromJS(data: any): PlaybackStream {
        data = typeof data === 'object' ? data : {};
        let result = new PlaybackStream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["cameraId"] = this.cameraId;
        data["lastKeepAlive"] = this.lastKeepAlive ? this.lastKeepAlive.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["speed"] = this.speed;
        data["isPlaying"] = this.isPlaying;
        data["width"] = this.width;
        data["height"] = this.height;
        data["codec"] = this.codec;
        data["currentTime"] = this.currentTime ? this.currentTime.toISOString() : <any>undefined;
        data["timestamp"] = this.timestamp;
        data["hasRecordingAtCurrentTime"] = this.hasRecordingAtCurrentTime;
        data["currentTimeAndTimestampSynced"] = this.currentTimeAndTimestampSynced;
        data["rtspLink"] = this.rtspLink;
        return data; 
    }
}

/** LiveStream represent a request to view past images of a camera. */
export interface IPlaybackStream {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the id of the camera that this playback stream concerns. */
    cameraId: string;
    /** Video Management Service will gracefully shutdown streams that has not received
any update on this field to make sure that no unused streams remains indefinitely.
LastKeepAlive has to be continuously updated every 60 seconds upon creation of the LiveStream. */
    lastKeepAlive: Date;
    /** Represents the start time of the requested sequence. */
    startTime: Date;
    /** Represents the speed used for displaying the requested sequence. */
    speed: number;
    /** Defines if this strem is currently playing or paused. */
    isPlaying: boolean;
    /** Represents the Height resolution of the stream in pixels. */
    width: number;
    /** Represents the width resolution of the stream in pixels. */
    height: number;
    /** Represents the codec that this stream is currently encoded in. */
    codec?: string | undefined;
    /** Represents the current time of this stream. */
    currentTime: Date;
    /** Represents the RTSP Link where binary data for video-streaming is available. */
    timestamp?: number | undefined;
    /** Defines wether the current selected time has recording or not.  */
    hasRecordingAtCurrentTime: boolean;
    /** True if timestamp and currentime are synced   */
    currentTimeAndTimestampSynced: boolean;
    /** Represents the Rtsp Link that this playback stream is available at.  */
    rtspLink?: string | undefined;
}

/** VideoExport represents a requested export for a video sequence of a specific camera. */
export class VideoExport implements IVideoExport {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the name of the video export. */
    name!: string;
    /** Represents the identifier of the camera. */
    cameraId!: string;
    /** Represents the output format of this video export. */
    outputFormat?: string | undefined;
    /** Represents the overlay image to be displayed on top of the video export, as base64. */
    overlayImage?: string | undefined;
    /** Represents the start time of the exported sequence. */
    startInterval!: Date;
    /** Represents the end time of the exported sequence. */
    endInterval!: Date;
    /** Internal Id of the binary data file.  */
    fileId?: string | undefined;
    /** Represents the identifier of the VMS.  */
    vms?: string | undefined;
    /** Represents the percentage of progress of the video export (0..100%)  */
    progress!: number;
    /** Defines if the exporting has failed.  */
    exportingFailed!: boolean;
    /** Represents the reason of why the exporting has failed.  */
    exportingFailedError?: string | undefined;
    /** Represents the url of export where binary data is available.  */
    exportedUrl?: string | undefined;
    /** Define wether the export has been completed.  */
    exportingDone!: boolean;

    constructor(data?: IVideoExport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.cameraId = data["cameraId"];
            this.outputFormat = data["outputFormat"];
            this.overlayImage = data["overlayImage"];
            this.startInterval = data["startInterval"] ? new Date(data["startInterval"].toString()) : <any>undefined;
            this.endInterval = data["endInterval"] ? new Date(data["endInterval"].toString()) : <any>undefined;
            this.fileId = data["fileId"];
            this.vms = data["vms"];
            this.progress = data["progress"];
            this.exportingFailed = data["exportingFailed"];
            this.exportingFailedError = data["exportingFailedError"];
            this.exportedUrl = data["exportedUrl"];
            this.exportingDone = data["exportingDone"];
        }
    }

    static fromJS(data: any): VideoExport {
        data = typeof data === 'object' ? data : {};
        let result = new VideoExport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["cameraId"] = this.cameraId;
        data["outputFormat"] = this.outputFormat;
        data["overlayImage"] = this.overlayImage;
        data["startInterval"] = this.startInterval ? this.startInterval.toISOString() : <any>undefined;
        data["endInterval"] = this.endInterval ? this.endInterval.toISOString() : <any>undefined;
        data["fileId"] = this.fileId;
        data["vms"] = this.vms;
        data["progress"] = this.progress;
        data["exportingFailed"] = this.exportingFailed;
        data["exportingFailedError"] = this.exportingFailedError;
        data["exportedUrl"] = this.exportedUrl;
        data["exportingDone"] = this.exportingDone;
        return data; 
    }
}

/** VideoExport represents a requested export for a video sequence of a specific camera. */
export interface IVideoExport {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the name of the video export. */
    name: string;
    /** Represents the identifier of the camera. */
    cameraId: string;
    /** Represents the output format of this video export. */
    outputFormat?: string | undefined;
    /** Represents the overlay image to be displayed on top of the video export, as base64. */
    overlayImage?: string | undefined;
    /** Represents the start time of the exported sequence. */
    startInterval: Date;
    /** Represents the end time of the exported sequence. */
    endInterval: Date;
    /** Internal Id of the binary data file.  */
    fileId?: string | undefined;
    /** Represents the identifier of the VMS.  */
    vms?: string | undefined;
    /** Represents the percentage of progress of the video export (0..100%)  */
    progress: number;
    /** Defines if the exporting has failed.  */
    exportingFailed: boolean;
    /** Represents the reason of why the exporting has failed.  */
    exportingFailedError?: string | undefined;
    /** Represents the url of export where binary data is available.  */
    exportedUrl?: string | undefined;
    /** Define wether the export has been completed.  */
    exportingDone: boolean;
}

/** VMS (VideoManagementSystem) entities are a representation of an external VMS connected to the platform to include video related capabilities. */
export class Vms implements IVms {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the name of the VMS. */
    name!: string;
    /** Represents the reachable IP from Constellation to the connector of the VMS. */
    ip!: string;
    /** Represents the reachable port from Constellation to the connector of the VMS. */
    port!: number;
    lastKeepAlive!: Date;

    constructor(data?: IVms) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.ip = data["ip"];
            this.port = data["port"];
            this.lastKeepAlive = data["lastKeepAlive"] ? new Date(data["lastKeepAlive"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Vms {
        data = typeof data === 'object' ? data : {};
        let result = new Vms();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["ip"] = this.ip;
        data["port"] = this.port;
        data["lastKeepAlive"] = this.lastKeepAlive ? this.lastKeepAlive.toISOString() : <any>undefined;
        return data; 
    }
}

/** VMS (VideoManagementSystem) entities are a representation of an external VMS connected to the platform to include video related capabilities. */
export interface IVms {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the name of the VMS. */
    name: string;
    /** Represents the reachable IP from Constellation to the connector of the VMS. */
    ip: string;
    /** Represents the reachable port from Constellation to the connector of the VMS. */
    port: number;
    lastKeepAlive: Date;
}

/** Alarm represents an event that should be noticed and handled by an operator. */
export class Alarm implements IAlarm {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the creation date of the Alarm, this field will be auto-generated by constellation if left empty upon creation. */
    creationDate!: Date;
    /** Represents the category of the Alarm, can be one of the elements defined by the `Category` entities */
    category?: string | undefined;
    /** Represents the certainty of the Alarm, can be one of the elements defined by the `Certainty` entities */
    certainty?: string | undefined;
    /** Represents the severity of the Alarm, can be one of the elements defined by the `Severity` entities */
    severity?: string | undefined;
    /** Represents the status of the Alarm, can be one of the elements defined by the `Status` entities */
    status?: string | undefined;
    /** Represents the description of the Alarm. */
    description?: string | undefined;
    /** Represents the identifier of the `Marker` that is generated upon creation of the alarm with `Location` filled. */
    markerId?: string | undefined;
    /** Represents the identifier of the `Passport` that is taking actions to resolve this Alarm. */
    assignedPassportId?: string | undefined;
    /** Represents name of the system that has triggered this alarm. */
    originatorSystem?: string | undefined;
    /** Represents the sensors that has triggered this alarm. */
    originatorSensors?: Sensor[] | undefined;
    /** Represents the sensors that are impacted by this alarm. */
    impactedSensors?: Sensor[] | undefined;
    /** Represents the location of this alarm. */
    location?: Coordinate | undefined;
    /** This field is obsolete and will be removed in a future version. please use the Attachment API instead. */
    additionalDetails?: AdditionalDetails[] | undefined;

    constructor(data?: IAlarm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.creationDate = data["creationDate"] ? new Date(data["creationDate"].toString()) : <any>undefined;
            this.category = data["category"];
            this.certainty = data["certainty"];
            this.severity = data["severity"];
            this.status = data["status"];
            this.description = data["description"];
            this.markerId = data["markerId"];
            this.assignedPassportId = data["assignedPassportId"];
            this.originatorSystem = data["originatorSystem"];
            if (data["originatorSensors"] && data["originatorSensors"].constructor === Array) {
                this.originatorSensors = [];
                for (let item of data["originatorSensors"])
                    this.originatorSensors.push(Sensor.fromJS(item));
            }
            if (data["impactedSensors"] && data["impactedSensors"].constructor === Array) {
                this.impactedSensors = [];
                for (let item of data["impactedSensors"])
                    this.impactedSensors.push(Sensor.fromJS(item));
            }
            this.location = data["location"] ? Coordinate.fromJS(data["location"]) : <any>undefined;
            if (data["additionalDetails"] && data["additionalDetails"].constructor === Array) {
                this.additionalDetails = [];
                for (let item of data["additionalDetails"])
                    this.additionalDetails.push(AdditionalDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Alarm {
        data = typeof data === 'object' ? data : {};
        let result = new Alarm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["category"] = this.category;
        data["certainty"] = this.certainty;
        data["severity"] = this.severity;
        data["status"] = this.status;
        data["description"] = this.description;
        data["markerId"] = this.markerId;
        data["assignedPassportId"] = this.assignedPassportId;
        data["originatorSystem"] = this.originatorSystem;
        if (this.originatorSensors && this.originatorSensors.constructor === Array) {
            data["originatorSensors"] = [];
            for (let item of this.originatorSensors)
                data["originatorSensors"].push(item.toJSON());
        }
        if (this.impactedSensors && this.impactedSensors.constructor === Array) {
            data["impactedSensors"] = [];
            for (let item of this.impactedSensors)
                data["impactedSensors"].push(item.toJSON());
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (this.additionalDetails && this.additionalDetails.constructor === Array) {
            data["additionalDetails"] = [];
            for (let item of this.additionalDetails)
                data["additionalDetails"].push(item.toJSON());
        }
        return data; 
    }
}

/** Alarm represents an event that should be noticed and handled by an operator. */
export interface IAlarm {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the creation date of the Alarm, this field will be auto-generated by constellation if left empty upon creation. */
    creationDate: Date;
    /** Represents the category of the Alarm, can be one of the elements defined by the `Category` entities */
    category?: string | undefined;
    /** Represents the certainty of the Alarm, can be one of the elements defined by the `Certainty` entities */
    certainty?: string | undefined;
    /** Represents the severity of the Alarm, can be one of the elements defined by the `Severity` entities */
    severity?: string | undefined;
    /** Represents the status of the Alarm, can be one of the elements defined by the `Status` entities */
    status?: string | undefined;
    /** Represents the description of the Alarm. */
    description?: string | undefined;
    /** Represents the identifier of the `Marker` that is generated upon creation of the alarm with `Location` filled. */
    markerId?: string | undefined;
    /** Represents the identifier of the `Passport` that is taking actions to resolve this Alarm. */
    assignedPassportId?: string | undefined;
    /** Represents name of the system that has triggered this alarm. */
    originatorSystem?: string | undefined;
    /** Represents the sensors that has triggered this alarm. */
    originatorSensors?: Sensor[] | undefined;
    /** Represents the sensors that are impacted by this alarm. */
    impactedSensors?: Sensor[] | undefined;
    /** Represents the location of this alarm. */
    location?: Coordinate | undefined;
    /** This field is obsolete and will be removed in a future version. please use the Attachment API instead. */
    additionalDetails?: AdditionalDetails[] | undefined;
}

export class Sensor implements ISensor {
    type?: string | undefined;
    id?: string | undefined;

    constructor(data?: ISensor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Sensor {
        data = typeof data === 'object' ? data : {};
        let result = new Sensor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISensor {
    type?: string | undefined;
    id?: string | undefined;
}

/** This class is obsolete and will be removed in a future version. please use the Attachment API instead. */
export class AdditionalDetails implements IAdditionalDetails {
    type?: string | undefined;
    data?: any | undefined;

    constructor(data?: IAdditionalDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.data = data["data"];
        }
    }

    static fromJS(data: any): AdditionalDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["data"] = this.data;
        return data; 
    }
}

/** This class is obsolete and will be removed in a future version. please use the Attachment API instead. */
export interface IAdditionalDetails {
    type?: string | undefined;
    data?: any | undefined;
}

/** Attachments are a sub-entity of the alarm and are used to upload voluminous or extra data that should be displayed within an alarm. */
export class Attachment implements IAttachment {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the identifier of the `Alarm` that this attachment is linked to. */
    alarmId?: string | undefined;
    /** Represents wether this attachment has been archived or not. */
    isArchived!: boolean;
    /** Represents the type of this attachment, will also define how the `data` field is formatted. */
    type!: string;
    /** Represent the data held in this attachment, this field can have completely different schemes, the `type` field define how it should be parsed */
    data!: any;
    /** Represents the binary data that was uploaded to this attachment. */
    file?: AttachmentFile | undefined;

    constructor(data?: IAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.alarmId = data["alarmId"];
            this.isArchived = data["isArchived"];
            this.type = data["type"];
            this.data = data["data"];
            this.file = data["file"] ? AttachmentFile.fromJS(data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Attachment {
        data = typeof data === 'object' ? data : {};
        let result = new Attachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["alarmId"] = this.alarmId;
        data["isArchived"] = this.isArchived;
        data["type"] = this.type;
        data["data"] = this.data;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data; 
    }
}

/** Attachments are a sub-entity of the alarm and are used to upload voluminous or extra data that should be displayed within an alarm. */
export interface IAttachment {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the identifier of the `Alarm` that this attachment is linked to. */
    alarmId?: string | undefined;
    /** Represents wether this attachment has been archived or not. */
    isArchived: boolean;
    /** Represents the type of this attachment, will also define how the `data` field is formatted. */
    type: string;
    /** Represent the data held in this attachment, this field can have completely different schemes, the `type` field define how it should be parsed */
    data: any;
    /** Represents the binary data that was uploaded to this attachment. */
    file?: AttachmentFile | undefined;
}

/** Logs are a sub-entity of an alarm and are used to track the various events that have occurred in the context of an alarm. */
export class Log implements ILog {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the identifier of the `Alarm` that this attachment is linked to. */
    alarmId?: string | undefined;
    /** Represents the creation date of the Log, this field will be auto-generated by constellation if left empty upon creation. */
    date!: Date;
    /** Represents the origin of this log, can be an id of a passport or directly a human readable text. */
    origin!: string;
    /** Represents the core message of this log. */
    message!: string;
    /** Represents the additional data of this log, will define how the `data` field is formatted. */
    type?: string | undefined;
    /** Represent the data held in this log, this field can have completely different schemes, the `type` field define how it should be parsed */
    data?: any | undefined;

    constructor(data?: ILog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.alarmId = data["alarmId"];
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.origin = data["origin"];
            this.message = data["message"];
            this.type = data["type"];
            this.data = data["data"];
        }
    }

    static fromJS(data: any): Log {
        data = typeof data === 'object' ? data : {};
        let result = new Log();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["alarmId"] = this.alarmId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["origin"] = this.origin;
        data["message"] = this.message;
        data["type"] = this.type;
        data["data"] = this.data;
        return data; 
    }
}

/** Logs are a sub-entity of an alarm and are used to track the various events that have occurred in the context of an alarm. */
export interface ILog {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the identifier of the `Alarm` that this attachment is linked to. */
    alarmId?: string | undefined;
    /** Represents the creation date of the Log, this field will be auto-generated by constellation if left empty upon creation. */
    date: Date;
    /** Represents the origin of this log, can be an id of a passport or directly a human readable text. */
    origin: string;
    /** Represents the core message of this log. */
    message: string;
    /** Represents the additional data of this log, will define how the `data` field is formatted. */
    type?: string | undefined;
    /** Represent the data held in this log, this field can have completely different schemes, the `type` field define how it should be parsed */
    data?: any | undefined;
}

/** Alarm systems represent the different systems that can raise alarms. */
export class AlarmSystem implements IAlarmSystem {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this alarm system. */
    name!: string;

    constructor(data?: IAlarmSystem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): AlarmSystem {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmSystem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        return data; 
    }
}

/** Alarm systems represent the different systems that can raise alarms. */
export interface IAlarmSystem {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this alarm system. */
    name: string;
}

/** Categories are made to qualify the Alarms. */
export class Category implements ICategory {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this category. */
    name!: string;

    constructor(data?: ICategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        return data; 
    }
}

/** Categories are made to qualify the Alarms. */
export interface ICategory {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this category. */
    name: string;
}

/** Certainties are made to qualify confidence in the veracity of an alarm. */
export class Certainty implements ICertainty {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this category. */
    name!: string;
    /** Represents the sorting index between certainties */
    sortOrder!: number;

    constructor(data?: ICertainty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.sortOrder = data["sortOrder"];
        }
    }

    static fromJS(data: any): Certainty {
        data = typeof data === 'object' ? data : {};
        let result = new Certainty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data; 
    }
}

/** Certainties are made to qualify confidence in the veracity of an alarm. */
export interface ICertainty {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this category. */
    name: string;
    /** Represents the sorting index between certainties */
    sortOrder: number;
}

/** API Management for Severities - Severities are made to qualify the Alarms. */
export class Severity implements ISeverity {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this severity. */
    name!: string;
    /** Represents the color that should be shown to the operators for alarms having this severity. */
    color?: string | undefined;
    /** Represents the sorting index between certainties */
    sortOrder!: number;

    constructor(data?: ISeverity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.color = data["color"];
            this.sortOrder = data["sortOrder"];
        }
    }

    static fromJS(data: any): Severity {
        data = typeof data === 'object' ? data : {};
        let result = new Severity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["color"] = this.color;
        data["sortOrder"] = this.sortOrder;
        return data; 
    }
}

/** API Management for Severities - Severities are made to qualify the Alarms. */
export interface ISeverity {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this severity. */
    name: string;
    /** Represents the color that should be shown to the operators for alarms having this severity. */
    color?: string | undefined;
    /** Represents the sorting index between certainties */
    sortOrder: number;
}

/** Statuses represent the different states in which an alarm can be. */
export class Status implements IStatus {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this severity. */
    name!: string;

    constructor(data?: IStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): Status {
        data = typeof data === 'object' ? data : {};
        let result = new Status();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        return data; 
    }
}

/** Statuses represent the different states in which an alarm can be. */
export interface IStatus {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this severity. */
    name: string;
}

/** Channels represents VoIP communications rooms allowing `Passports` to communicate. */
export class Channel implements IChannel {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of the channel.  */
    name!: string;
    /** Represents the identifier of the `image` that should be displayed for this channel.  */
    imageId!: string;
    /** Represents the identifiers of the `passports` allowed to connect to this VoIP Room and communicate.  */
    authorizedPassports!: string[];

    constructor(data?: IChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.authorizedPassports = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.imageId = data["imageId"];
            if (data["authorizedPassports"] && data["authorizedPassports"].constructor === Array) {
                this.authorizedPassports = [];
                for (let item of data["authorizedPassports"])
                    this.authorizedPassports.push(item);
            }
        }
    }

    static fromJS(data: any): Channel {
        data = typeof data === 'object' ? data : {};
        let result = new Channel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["imageId"] = this.imageId;
        if (this.authorizedPassports && this.authorizedPassports.constructor === Array) {
            data["authorizedPassports"] = [];
            for (let item of this.authorizedPassports)
                data["authorizedPassports"].push(item);
        }
        return data; 
    }
}

/** Channels represents VoIP communications rooms allowing `Passports` to communicate. */
export interface IChannel {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of the channel.  */
    name: string;
    /** Represents the identifier of the `image` that should be displayed for this channel.  */
    imageId: string;
    /** Represents the identifiers of the `passports` allowed to connect to this VoIP Room and communicate.  */
    authorizedPassports: string[];
}

export class VoiceActivity implements IVoiceActivity {
    /** Represents the identifier of the voice activity event.  */
    id?: string | undefined;
    /** Represents the identifier of the `passport` that is producing this voice activity.  */
    speakerPassportId?: string | undefined;
    /** Represents the identifier of the `channel` that this voice activity is produced in.  */
    channelId?: string | undefined;
    /** Used to trace the request with the command and the produced event.  */
    traceId?: string | undefined;

    constructor(data?: IVoiceActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.speakerPassportId = data["speakerPassportId"];
            this.channelId = data["channelId"];
            this.traceId = data["traceId"];
        }
    }

    static fromJS(data: any): VoiceActivity {
        data = typeof data === 'object' ? data : {};
        let result = new VoiceActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["speakerPassportId"] = this.speakerPassportId;
        data["channelId"] = this.channelId;
        data["traceId"] = this.traceId;
        return data; 
    }
}

export interface IVoiceActivity {
    /** Represents the identifier of the voice activity event.  */
    id?: string | undefined;
    /** Represents the identifier of the `passport` that is producing this voice activity.  */
    speakerPassportId?: string | undefined;
    /** Represents the identifier of the `channel` that this voice activity is produced in.  */
    channelId?: string | undefined;
    /** Used to trace the request with the command and the produced event.  */
    traceId?: string | undefined;
}

/** AgentBehaviours defines the behaviour that should be applied to simulated agents. */
export class AgentBehaviour implements IAgentBehaviour {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the identifier of the `Agent` that should be articulated using this behaviour  */
    agentId!: string;
    /** Defines wether or not the `Agent` should wander of the `Map` when no missions has been created. */
    isWandering!: boolean;
    /** Represents the time in seconds that the `Agent` should use to resume wandering after his mission has been completed.  */
    resumeWanderingAfterSeconds!: number;
    /** Defines the bounding box where the `Agent` can wander.  */
    wanderingZone?: GeoBoundingBox | undefined;
    /** Represents the speed of the `Agent` in meters per seconds.  */
    speedInMetersPerSeconds!: number;
    /** Represents wether this behaviour is active or not.  */
    isActive!: boolean;

    constructor(data?: IAgentBehaviour) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.agentId = data["agentId"];
            this.isWandering = data["isWandering"];
            this.resumeWanderingAfterSeconds = data["resumeWanderingAfterSeconds"];
            this.wanderingZone = data["wanderingZone"] ? GeoBoundingBox.fromJS(data["wanderingZone"]) : <any>undefined;
            this.speedInMetersPerSeconds = data["speedInMetersPerSeconds"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): AgentBehaviour {
        data = typeof data === 'object' ? data : {};
        let result = new AgentBehaviour();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["agentId"] = this.agentId;
        data["isWandering"] = this.isWandering;
        data["resumeWanderingAfterSeconds"] = this.resumeWanderingAfterSeconds;
        data["wanderingZone"] = this.wanderingZone ? this.wanderingZone.toJSON() : <any>undefined;
        data["speedInMetersPerSeconds"] = this.speedInMetersPerSeconds;
        data["isActive"] = this.isActive;
        return data; 
    }
}

/** AgentBehaviours defines the behaviour that should be applied to simulated agents. */
export interface IAgentBehaviour {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the identifier of the `Agent` that should be articulated using this behaviour  */
    agentId: string;
    /** Defines wether or not the `Agent` should wander of the `Map` when no missions has been created. */
    isWandering: boolean;
    /** Represents the time in seconds that the `Agent` should use to resume wandering after his mission has been completed.  */
    resumeWanderingAfterSeconds: number;
    /** Defines the bounding box where the `Agent` can wander.  */
    wanderingZone?: GeoBoundingBox | undefined;
    /** Represents the speed of the `Agent` in meters per seconds.  */
    speedInMetersPerSeconds: number;
    /** Represents wether this behaviour is active or not.  */
    isActive: boolean;
}

/** Scenarios defines a series of time-based event and behaviours that should be run when creating a Simulation for a scenario. */
export class Scenario implements IScenario {
    /** Represents the initial `Agents` locations that should be used for this `Scenario`.  */
    initialAgentsLocations!: { [key: string] : Coordinate; };
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the time-series events that should be triggered for this scenario.
Key is the time since execution of the scenario and value is the actual event to be created. */
    events!: { [key: string] : ScenarioEvent; };

    constructor(data?: IScenario) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.initialAgentsLocations = {};
            this.events = {};
        }
    }

    init(data?: any) {
        if (data) {
            if (data["initialAgentsLocations"]) {
                this.initialAgentsLocations = {};
                for (let key in data["initialAgentsLocations"]) {
                    if (data["initialAgentsLocations"].hasOwnProperty(key))
                        this.initialAgentsLocations[key] = data["initialAgentsLocations"][key] ? Coordinate.fromJS(data["initialAgentsLocations"][key]) : new Coordinate();
                }
            }
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            if (data["events"]) {
                this.events = {};
                for (let key in data["events"]) {
                    if (data["events"].hasOwnProperty(key))
                        this.events[key] = data["events"][key] ? ScenarioEvent.fromJS(data["events"][key]) : new ScenarioEvent();
                }
            }
        }
    }

    static fromJS(data: any): Scenario {
        data = typeof data === 'object' ? data : {};
        let result = new Scenario();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.initialAgentsLocations) {
            data["initialAgentsLocations"] = {};
            for (let key in this.initialAgentsLocations) {
                if (this.initialAgentsLocations.hasOwnProperty(key))
                    data["initialAgentsLocations"][key] = this.initialAgentsLocations[key];
            }
        }
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        if (this.events) {
            data["events"] = {};
            for (let key in this.events) {
                if (this.events.hasOwnProperty(key))
                    data["events"][key] = this.events[key];
            }
        }
        return data; 
    }
}

/** Scenarios defines a series of time-based event and behaviours that should be run when creating a Simulation for a scenario. */
export interface IScenario {
    /** Represents the initial `Agents` locations that should be used for this `Scenario`.  */
    initialAgentsLocations: { [key: string] : Coordinate; };
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the time-series events that should be triggered for this scenario.
Key is the time since execution of the scenario and value is the actual event to be created. */
    events: { [key: string] : ScenarioEvent; };
}

export class ScenarioEvent implements IScenarioEvent {
    type?: string | undefined;
    /** Represents the event data, can be parsed using `Type` field.  */
    event?: any | undefined;

    constructor(data?: IScenarioEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.event = data["event"];
        }
    }

    static fromJS(data: any): ScenarioEvent {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["event"] = this.event;
        return data; 
    }
}

export interface IScenarioEvent {
    type?: string | undefined;
    /** Represents the event data, can be parsed using `Type` field.  */
    event?: any | undefined;
}

/** Simulations represents the execution of a scenario. */
export class Simulation implements ISimulation {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the identifier of the `Scenario` that this simulation was created for.  */
    scenarioId!: string;

    constructor(data?: ISimulation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.scenarioId = data["scenarioId"];
        }
    }

    static fromJS(data: any): Simulation {
        data = typeof data === 'object' ? data : {};
        let result = new Simulation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["scenarioId"] = this.scenarioId;
        return data; 
    }
}

/** Simulations represents the execution of a scenario. */
export interface ISimulation {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the identifier of the `Scenario` that this simulation was created for.  */
    scenarioId: string;
}

/** AccessBadgeCarriers represent the carrier of a badge in the ACS (Access Control System.) */
export class AccessBadgeCarrier implements IAccessBadgeCarrier {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the identifier of the `ACS` that this badge is managed by. */
    acs?: string | undefined;
    /** Represents the identifier of the badge in the access control system that this badge is managed by. */
    acsId?: string | undefined;
    /** Represents the full name of the carrier. */
    fullName!: string;
    /** Represents the organization that the carrier work for. */
    organization?: string | undefined;
    /**          Represents the photo of the access badge carrier as base64.
          */
    photo?: string | undefined;

    constructor(data?: IAccessBadgeCarrier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.acs = data["acs"];
            this.acsId = data["acsId"];
            this.fullName = data["fullName"];
            this.organization = data["organization"];
            this.photo = data["photo"];
        }
    }

    static fromJS(data: any): AccessBadgeCarrier {
        data = typeof data === 'object' ? data : {};
        let result = new AccessBadgeCarrier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["acs"] = this.acs;
        data["acsId"] = this.acsId;
        data["fullName"] = this.fullName;
        data["organization"] = this.organization;
        data["photo"] = this.photo;
        return data; 
    }
}

/** AccessBadgeCarriers represent the carrier of a badge in the ACS (Access Control System.) */
export interface IAccessBadgeCarrier {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the identifier of the `ACS` that this badge is managed by. */
    acs?: string | undefined;
    /** Represents the identifier of the badge in the access control system that this badge is managed by. */
    acsId?: string | undefined;
    /** Represents the full name of the carrier. */
    fullName: string;
    /** Represents the organization that the carrier work for. */
    organization?: string | undefined;
    /**          Represents the photo of the access badge carrier as base64.
          */
    photo?: string | undefined;
}

/** AccessBadges represent a physical badge that can be used to unlock AccessPoints. */
export class AccessBadge implements IAccessBadge {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the readable name of the access badge. */
    name!: string;
    /** Represents the identifier of the `ACS` that this badge is managed by. */
    acs?: string | undefined;
    /** Represents the identifier of the badge in the access control system that this badge is managed by. */
    acsId?: string | undefined;
    /** Represents the identifier of the `AccessBadgeCarrier` that this badge is currently associated to. */
    badgeCarrierId?: string | undefined;

    constructor(data?: IAccessBadge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.acs = data["acs"];
            this.acsId = data["acsId"];
            this.badgeCarrierId = data["badgeCarrierId"];
        }
    }

    static fromJS(data: any): AccessBadge {
        data = typeof data === 'object' ? data : {};
        let result = new AccessBadge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["acs"] = this.acs;
        data["acsId"] = this.acsId;
        data["badgeCarrierId"] = this.badgeCarrierId;
        return data; 
    }
}

/** AccessBadges represent a physical badge that can be used to unlock AccessPoints. */
export interface IAccessBadge {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the readable name of the access badge. */
    name: string;
    /** Represents the identifier of the `ACS` that this badge is managed by. */
    acs?: string | undefined;
    /** Represents the identifier of the badge in the access control system that this badge is managed by. */
    acsId?: string | undefined;
    /** Represents the identifier of the `AccessBadgeCarrier` that this badge is currently associated to. */
    badgeCarrierId?: string | undefined;
}

/** AccessNotifications represents a notification when the state of an access point is changed. */
export class AccessNotification implements IAccessNotification {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the identifier of the `ACS` that this notification was generated by. */
    acs?: string | undefined;
    /** Represents the identifier of the `AccessPoint` that has triggered this notification. */
    accessPointId!: string;
    /** Represents the message of this notification. */
    message!: string;
    /** Represents wether or not this notification is related to a problem and should be considered as an alarm. */
    error!: boolean;
    /** Represents the date this notification has occured. */
    date!: Date;
    /** Represents the identifier of the `AccessBadge` that has triggered this notification. */
    badgeId?: string | undefined;
    /** Represents the identifier of the `AccessBadgeCarrier` that has triggered this notification. */
    badgeCarrierId?: string | undefined;
    /** Represents the name of the `AccessBadge` that has triggered this notification. */
    badgeName?: string | undefined;
    /** Represents the name of the `AccessBadgeCarrier` that has triggered this notification. */
    badgeCarrierName?: string | undefined;
    /** Represents the photo as base64 of the `AccessBadgeCarrier` that has triggered this notification. */
    badgeCarrierPhoto?: string | undefined;

    constructor(data?: IAccessNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.acs = data["acs"];
            this.accessPointId = data["accessPointId"];
            this.message = data["message"];
            this.error = data["error"];
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.badgeId = data["badgeId"];
            this.badgeCarrierId = data["badgeCarrierId"];
            this.badgeName = data["badgeName"];
            this.badgeCarrierName = data["badgeCarrierName"];
            this.badgeCarrierPhoto = data["badgeCarrierPhoto"];
        }
    }

    static fromJS(data: any): AccessNotification {
        data = typeof data === 'object' ? data : {};
        let result = new AccessNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["acs"] = this.acs;
        data["accessPointId"] = this.accessPointId;
        data["message"] = this.message;
        data["error"] = this.error;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["badgeId"] = this.badgeId;
        data["badgeCarrierId"] = this.badgeCarrierId;
        data["badgeName"] = this.badgeName;
        data["badgeCarrierName"] = this.badgeCarrierName;
        data["badgeCarrierPhoto"] = this.badgeCarrierPhoto;
        return data; 
    }
}

/** AccessNotifications represents a notification when the state of an access point is changed. */
export interface IAccessNotification {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the identifier of the `ACS` that this notification was generated by. */
    acs?: string | undefined;
    /** Represents the identifier of the `AccessPoint` that has triggered this notification. */
    accessPointId: string;
    /** Represents the message of this notification. */
    message: string;
    /** Represents wether or not this notification is related to a problem and should be considered as an alarm. */
    error: boolean;
    /** Represents the date this notification has occured. */
    date: Date;
    /** Represents the identifier of the `AccessBadge` that has triggered this notification. */
    badgeId?: string | undefined;
    /** Represents the identifier of the `AccessBadgeCarrier` that has triggered this notification. */
    badgeCarrierId?: string | undefined;
    /** Represents the name of the `AccessBadge` that has triggered this notification. */
    badgeName?: string | undefined;
    /** Represents the name of the `AccessBadgeCarrier` that has triggered this notification. */
    badgeCarrierName?: string | undefined;
    /** Represents the photo as base64 of the `AccessBadgeCarrier` that has triggered this notification. */
    badgeCarrierPhoto?: string | undefined;
}

/** AccessPoints represents a physical access point that can be locked/unlocked. */
export class AccessPoint implements IAccessPoint {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the identifier of the `ACS` that this badge is managed by. */
    acs?: string | undefined;
    /** Represents the identifier of the badge in the access control system that this badge is managed by. */
    acsId?: string | undefined;
    /** Represents the state of the access point. */
    state!: AccessPointState;
    /** Represents the name of the access point.  */
    name!: string;
    /** Represents the type of the access point.  */
    type?: string | undefined;
    /** Represents the identifier of the `Marker` that is generated upon creation of the access point with `Location` filled. */
    markerId?: string | undefined;
    /** Represents the location of this access point. */
    location?: Coordinate | undefined;

    constructor(data?: IAccessPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.acs = data["acs"];
            this.acsId = data["acsId"];
            this.state = data["state"];
            this.name = data["name"];
            this.type = data["type"];
            this.markerId = data["markerId"];
            this.location = data["location"] ? Coordinate.fromJS(data["location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccessPoint {
        data = typeof data === 'object' ? data : {};
        let result = new AccessPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["acs"] = this.acs;
        data["acsId"] = this.acsId;
        data["state"] = this.state;
        data["name"] = this.name;
        data["type"] = this.type;
        data["markerId"] = this.markerId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data; 
    }
}

/** AccessPoints represents a physical access point that can be locked/unlocked. */
export interface IAccessPoint {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the identifier of the `ACS` that this badge is managed by. */
    acs?: string | undefined;
    /** Represents the identifier of the badge in the access control system that this badge is managed by. */
    acsId?: string | undefined;
    /** Represents the state of the access point. */
    state: AccessPointState;
    /** Represents the name of the access point.  */
    name: string;
    /** Represents the type of the access point.  */
    type?: string | undefined;
    /** Represents the identifier of the `Marker` that is generated upon creation of the access point with `Location` filled. */
    markerId?: string | undefined;
    /** Represents the location of this access point. */
    location?: Coordinate | undefined;
}

export enum AccessPointState {
    NormallyOpened = "NormallyOpened", 
    NormallyClosed = "NormallyClosed", 
    ForcedOpen = "ForcedOpen", 
    ForcedClose = "ForcedClose", 
    AccessTemporarilyGranted = "AccessTemporarilyGranted", 
    Broken = "Broken", 
    RemoteOutputSet = "RemoteOutputSet", 
    RemoteOutputReset = "RemoteOutputReset", 
    ToggleSet = "ToggleSet", 
    ToggleReset = "ToggleReset", 
    ToggleToggle = "ToggleToggle", 
    InputGuardInhibited = "InputGuardInhibited", 
    InputGuardUninhibited = "InputGuardUninhibited", 
    AreaArmed = "AreaArmed", 
    AreaDisarmed = "AreaDisarmed", 
}

/** ACSes (Access Control Systems) entities are a representation of an external ACS connected to the platform to include access control related capabilities. */
export class Acs implements IAcs {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the name of the ACS.  */
    name!: string;
    /** Represents the reachable IP from Constellation to the connector of the ACS. */
    ip!: string;
    /** Represents the reachable port from Constellation to the connector of the ACS. */
    port!: number;

    constructor(data?: IAcs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.ip = data["ip"];
            this.port = data["port"];
        }
    }

    static fromJS(data: any): Acs {
        data = typeof data === 'object' ? data : {};
        let result = new Acs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["ip"] = this.ip;
        data["port"] = this.port;
        return data; 
    }
}

/** ACSes (Access Control Systems) entities are a representation of an external ACS connected to the platform to include access control related capabilities. */
export interface IAcs {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the name of the ACS.  */
    name: string;
    /** Represents the reachable IP from Constellation to the connector of the ACS. */
    ip: string;
    /** Represents the reachable port from Constellation to the connector of the ACS. */
    port: number;
}

/** Diagrams represents a complete workflow to be ran after conditions are met. */
export class Diagram implements IDiagram {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the user defined name of the diagram.  */
    name!: string;
    /** Defines wether the diagram should be active or not, may be "stopped" or "active".  */
    status!: string;
    /** Represents the serializable definition of the diagram.  */
    data?: any | undefined;
    /** Represents the identifier of the passport of the creator's diagram.  */
    createdBy!: string;
    /** Represents the date time this diagram was created at.  */
    createdAt!: Date;
    /** Represents the date time this diagram was last updated at.  */
    lastUpdate!: Date;
    /** Represents the event type that are needed to created a process out of this diagram.  */
    events?: string[] | undefined;

    constructor(data?: IDiagram) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.status = data["status"];
            this.data = data["data"];
            this.createdBy = data["createdBy"];
            this.createdAt = data["createdAt"] ? new Date(data["createdAt"].toString()) : <any>undefined;
            this.lastUpdate = data["lastUpdate"] ? new Date(data["lastUpdate"].toString()) : <any>undefined;
            if (data["events"] && data["events"].constructor === Array) {
                this.events = [];
                for (let item of data["events"])
                    this.events.push(item);
            }
        }
    }

    static fromJS(data: any): Diagram {
        data = typeof data === 'object' ? data : {};
        let result = new Diagram();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["status"] = this.status;
        data["data"] = this.data;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        if (this.events && this.events.constructor === Array) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item);
        }
        return data; 
    }
}

/** Diagrams represents a complete workflow to be ran after conditions are met. */
export interface IDiagram {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the user defined name of the diagram.  */
    name: string;
    /** Defines wether the diagram should be active or not, may be "stopped" or "active".  */
    status: string;
    /** Represents the serializable definition of the diagram.  */
    data?: any | undefined;
    /** Represents the identifier of the passport of the creator's diagram.  */
    createdBy: string;
    /** Represents the date time this diagram was created at.  */
    createdAt: Date;
    /** Represents the date time this diagram was last updated at.  */
    lastUpdate: Date;
    /** Represents the event type that are needed to created a process out of this diagram.  */
    events?: string[] | undefined;
}

/** Logs represents text data to trace the execution of a process. */
export class Logs implements ILogs {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the identifier of the `process` that this logs was created for.  */
    processId?: string | undefined;
    /** Represents the identifier of the `node` that thig logs was created for.  */
    nodeId?: string | undefined;
    /** Represents the message of the `logs`.  */
    message!: string;
    /** Represents the creation date of the `logs`.  */
    createdAt!: Date;

    constructor(data?: ILogs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.processId = data["processId"];
            this.nodeId = data["nodeId"];
            this.message = data["message"];
            this.createdAt = data["createdAt"] ? new Date(data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Logs {
        data = typeof data === 'object' ? data : {};
        let result = new Logs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["processId"] = this.processId;
        data["nodeId"] = this.nodeId;
        data["message"] = this.message;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data; 
    }
}

/** Logs represents text data to trace the execution of a process. */
export interface ILogs {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the identifier of the `process` that this logs was created for.  */
    processId?: string | undefined;
    /** Represents the identifier of the `node` that thig logs was created for.  */
    nodeId?: string | undefined;
    /** Represents the message of the `logs`.  */
    message: string;
    /** Represents the creation date of the `logs`.  */
    createdAt: Date;
}

/** Modules represents a reusable block of workflow that can be used when building diagrams. */
export class Module implements IModule {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the user defined name of the module.  */
    name!: string;
    /** Defines wether the module should be active or not, may be "stopped" or "active".  */
    status!: string;
    /** Represents the serializable definition of the building blocks displayed on flow.  */
    data?: any | undefined;
    /** Represents the identifier of the passport of the creator's module.  */
    createdBy!: string;
    /** Represents the date time this module was created at.  */
    createdAt!: Date;
    /** Represents the date time this module was last updated at.  */
    lastUpdate!: Date;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.status = data["status"];
            this.data = data["data"];
            this.createdBy = data["createdBy"];
            this.createdAt = data["createdAt"] ? new Date(data["createdAt"].toString()) : <any>undefined;
            this.lastUpdate = data["lastUpdate"] ? new Date(data["lastUpdate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["status"] = this.status;
        data["data"] = this.data;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        return data; 
    }
}

/** Modules represents a reusable block of workflow that can be used when building diagrams. */
export interface IModule {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the user defined name of the module.  */
    name: string;
    /** Defines wether the module should be active or not, may be "stopped" or "active".  */
    status: string;
    /** Represents the serializable definition of the building blocks displayed on flow.  */
    data?: any | undefined;
    /** Represents the identifier of the passport of the creator's module.  */
    createdBy: string;
    /** Represents the date time this module was created at.  */
    createdAt: Date;
    /** Represents the date time this module was last updated at.  */
    lastUpdate: Date;
}

/** Processes represents an execution of a diagram, they are meant to be created exclusively by Flow engine. */
export class Process implements IProcess {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Not yet implemented.  */
    data?: any | undefined;
    /** Represents the execution status of the process, "created" | "stopped" | "paused" | "completed"  */
    status!: ProcessStatus;
    diagramId!: string;
    /** Defines wether this process has been creation through simulation for testing a diagram.  */
    isSimulated!: boolean;
    /** Represents the simulated data required to start this process.  */
    simulationData?: any | undefined;
    /** Not yet implemented.  */
    logs?: string[] | undefined;
    /** Represents nodes of the diagram that have already been processed.  */
    processed?: ProcessedNodeInstance[] | undefined;
    /** Represents nodes that still needs to be processed.  */
    waiting?: WaitingNodeInstance[] | undefined;
    /** Represents the node identifier that is waiting for a trigger to be processed  */
    pausedOn?: string | undefined;
    /** Represents the date time this process was created at.  */
    createdAt!: Date;
    /** Represents the date time this process was last updated at.  */
    lastUpdate!: Date;

    constructor(data?: IProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.data = data["data"];
            this.status = data["status"];
            this.diagramId = data["diagramId"];
            this.isSimulated = data["isSimulated"];
            this.simulationData = data["simulationData"];
            if (data["logs"] && data["logs"].constructor === Array) {
                this.logs = [];
                for (let item of data["logs"])
                    this.logs.push(item);
            }
            if (data["processed"] && data["processed"].constructor === Array) {
                this.processed = [];
                for (let item of data["processed"])
                    this.processed.push(ProcessedNodeInstance.fromJS(item));
            }
            if (data["waiting"] && data["waiting"].constructor === Array) {
                this.waiting = [];
                for (let item of data["waiting"])
                    this.waiting.push(WaitingNodeInstance.fromJS(item));
            }
            this.pausedOn = data["pausedOn"];
            this.createdAt = data["createdAt"] ? new Date(data["createdAt"].toString()) : <any>undefined;
            this.lastUpdate = data["lastUpdate"] ? new Date(data["lastUpdate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Process {
        data = typeof data === 'object' ? data : {};
        let result = new Process();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["data"] = this.data;
        data["status"] = this.status;
        data["diagramId"] = this.diagramId;
        data["isSimulated"] = this.isSimulated;
        data["simulationData"] = this.simulationData;
        if (this.logs && this.logs.constructor === Array) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item);
        }
        if (this.processed && this.processed.constructor === Array) {
            data["processed"] = [];
            for (let item of this.processed)
                data["processed"].push(item.toJSON());
        }
        if (this.waiting && this.waiting.constructor === Array) {
            data["waiting"] = [];
            for (let item of this.waiting)
                data["waiting"].push(item.toJSON());
        }
        data["pausedOn"] = this.pausedOn;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        return data; 
    }
}

/** Processes represents an execution of a diagram, they are meant to be created exclusively by Flow engine. */
export interface IProcess {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Not yet implemented.  */
    data?: any | undefined;
    /** Represents the execution status of the process, "created" | "stopped" | "paused" | "completed"  */
    status: ProcessStatus;
    diagramId: string;
    /** Defines wether this process has been creation through simulation for testing a diagram.  */
    isSimulated: boolean;
    /** Represents the simulated data required to start this process.  */
    simulationData?: any | undefined;
    /** Not yet implemented.  */
    logs?: string[] | undefined;
    /** Represents nodes of the diagram that have already been processed.  */
    processed?: ProcessedNodeInstance[] | undefined;
    /** Represents nodes that still needs to be processed.  */
    waiting?: WaitingNodeInstance[] | undefined;
    /** Represents the node identifier that is waiting for a trigger to be processed  */
    pausedOn?: string | undefined;
    /** Represents the date time this process was created at.  */
    createdAt: Date;
    /** Represents the date time this process was last updated at.  */
    lastUpdate: Date;
}

export enum ProcessStatus {
    Created = 0, 
    Stopped = 1, 
    Paused = 2, 
    Completed = 3, 
}

export class ProcessedNodeInstance implements IProcessedNodeInstance {
    id?: string | undefined;
    name?: string | undefined;
    forEachInfo!: number;
    reExecution!: number;
    date!: Date;

    constructor(data?: IProcessedNodeInstance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.forEachInfo = data["forEachInfo"];
            this.reExecution = data["reExecution"];
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProcessedNodeInstance {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedNodeInstance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["forEachInfo"] = this.forEachInfo;
        data["reExecution"] = this.reExecution;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IProcessedNodeInstance {
    id?: string | undefined;
    name?: string | undefined;
    forEachInfo: number;
    reExecution: number;
    date: Date;
}

export class WaitingNodeInstance implements IWaitingNodeInstance {
    component?: string | undefined;
    entity?: any | undefined;
    forEachInfo!: number;
    reExecution!: number;

    constructor(data?: IWaitingNodeInstance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.component = data["component"];
            this.entity = data["entity"];
            this.forEachInfo = data["forEachInfo"];
            this.reExecution = data["reExecution"];
        }
    }

    static fromJS(data: any): WaitingNodeInstance {
        data = typeof data === 'object' ? data : {};
        let result = new WaitingNodeInstance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["component"] = this.component;
        data["entity"] = this.entity;
        data["forEachInfo"] = this.forEachInfo;
        data["reExecution"] = this.reExecution;
        return data; 
    }
}

export interface IWaitingNodeInstance {
    component?: string | undefined;
    entity?: any | undefined;
    forEachInfo: number;
    reExecution: number;
}

/** UserTasks represents tasks to be completed by an operator, usually in the context of an `alarm`, also called a `SOP` (Standard Operating Procedure). UserTasks are mostly generated by flow to design a full procedure to be used for a specific kind of `alarm`. */
export class UserTask implements IUserTask {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents wether the task can be completed with multiple answers. (not implemented.) */
    multipleAnswersAuthorized!: boolean;
    /** Represents the answers that are proposed to the operator. */
    propositions!: string[];
    /** Represents the answers that the operator has chosen. */
    selectedAnswers?: string[] | undefined;
    /** Defines wether or not the operator can add additional free-text notes to this task. */
    withNotes!: boolean;
    /** Represents the notes of the operator. */
    notes?: string | undefined;
    /** Defines wether or not the operator can attach files to this user task. (not implemented.) */
    withFiles!: boolean;
    /** Defines wether or not the operator will receive this task as a full-screen popup. (not implemented.) */
    isPopup!: boolean;
    /** Represents the `passport` identifier of the entity that created this task. */
    originatorId?: string | undefined;
    /** Represents the status of the task. */
    status?: string | undefined;
    /** Represents the description of the task. */
    description!: string;
    /** Represents the identifier of the `passport` who shall complete this task.  */
    adresseeId?: string | undefined;
    /** Represents the `alarm` identifier of the alarm this task was created for.  */
    alarmId?: string | undefined;
    /** Represents the date time this task was created at.  */
    createdAt!: Date;
    /** Represents the date time this task was last updated at.  */
    lastUpdate!: Date;

    constructor(data?: IUserTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.propositions = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.multipleAnswersAuthorized = data["multipleAnswersAuthorized"];
            if (data["propositions"] && data["propositions"].constructor === Array) {
                this.propositions = [];
                for (let item of data["propositions"])
                    this.propositions.push(item);
            }
            if (data["selectedAnswers"] && data["selectedAnswers"].constructor === Array) {
                this.selectedAnswers = [];
                for (let item of data["selectedAnswers"])
                    this.selectedAnswers.push(item);
            }
            this.withNotes = data["withNotes"];
            this.notes = data["notes"];
            this.withFiles = data["withFiles"];
            this.isPopup = data["isPopup"];
            this.originatorId = data["originatorId"];
            this.status = data["status"];
            this.description = data["description"];
            this.adresseeId = data["adresseeId"];
            this.alarmId = data["alarmId"];
            this.createdAt = data["createdAt"] ? new Date(data["createdAt"].toString()) : <any>undefined;
            this.lastUpdate = data["lastUpdate"] ? new Date(data["lastUpdate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserTask {
        data = typeof data === 'object' ? data : {};
        let result = new UserTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["multipleAnswersAuthorized"] = this.multipleAnswersAuthorized;
        if (this.propositions && this.propositions.constructor === Array) {
            data["propositions"] = [];
            for (let item of this.propositions)
                data["propositions"].push(item);
        }
        if (this.selectedAnswers && this.selectedAnswers.constructor === Array) {
            data["selectedAnswers"] = [];
            for (let item of this.selectedAnswers)
                data["selectedAnswers"].push(item);
        }
        data["withNotes"] = this.withNotes;
        data["notes"] = this.notes;
        data["withFiles"] = this.withFiles;
        data["isPopup"] = this.isPopup;
        data["originatorId"] = this.originatorId;
        data["status"] = this.status;
        data["description"] = this.description;
        data["adresseeId"] = this.adresseeId;
        data["alarmId"] = this.alarmId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        return data; 
    }
}

/** UserTasks represents tasks to be completed by an operator, usually in the context of an `alarm`, also called a `SOP` (Standard Operating Procedure). UserTasks are mostly generated by flow to design a full procedure to be used for a specific kind of `alarm`. */
export interface IUserTask {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents wether the task can be completed with multiple answers. (not implemented.) */
    multipleAnswersAuthorized: boolean;
    /** Represents the answers that are proposed to the operator. */
    propositions: string[];
    /** Represents the answers that the operator has chosen. */
    selectedAnswers?: string[] | undefined;
    /** Defines wether or not the operator can add additional free-text notes to this task. */
    withNotes: boolean;
    /** Represents the notes of the operator. */
    notes?: string | undefined;
    /** Defines wether or not the operator can attach files to this user task. (not implemented.) */
    withFiles: boolean;
    /** Defines wether or not the operator will receive this task as a full-screen popup. (not implemented.) */
    isPopup: boolean;
    /** Represents the `passport` identifier of the entity that created this task. */
    originatorId?: string | undefined;
    /** Represents the status of the task. */
    status?: string | undefined;
    /** Represents the description of the task. */
    description: string;
    /** Represents the identifier of the `passport` who shall complete this task.  */
    adresseeId?: string | undefined;
    /** Represents the `alarm` identifier of the alarm this task was created for.  */
    alarmId?: string | undefined;
    /** Represents the date time this task was created at.  */
    createdAt: Date;
    /** Represents the date time this task was last updated at.  */
    lastUpdate: Date;
}

/** Licenses contains the capabilities of the platform and are provided by official Obvious Technologies representatives. */
export class ProductLicense implements IProductLicense {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the hardware identifier that this license is bound to.  */
    hardwareId?: string | undefined;
    /** Represents the details of the license as a text string.  */
    licenseText?: string | undefined;

    constructor(data?: IProductLicense) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.hardwareId = data["hardwareId"];
            this.licenseText = data["licenseText"];
        }
    }

    static fromJS(data: any): ProductLicense {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLicense();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["hardwareId"] = this.hardwareId;
        data["licenseText"] = this.licenseText;
        return data; 
    }
}

/** Licenses contains the capabilities of the platform and are provided by official Obvious Technologies representatives. */
export interface IProductLicense {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the hardware identifier that this license is bound to.  */
    hardwareId?: string | undefined;
    /** Represents the details of the license as a text string.  */
    licenseText?: string | undefined;
}

/** VariableMessageSign represents a physical variable message sign that can display a message. */
export class VariableMessageSign implements IVariableMessageSign {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the location of this variable message sign. */
    location?: Coordinate | undefined;
    /** Represents the identifier of the `Marker` that is generated upon creation of the alarm with `Location` filled. */
    markerId?: string | undefined;
    /** Represents the IP Address of the variable message sign device.  */
    ipAddress!: string;
    /** Represents the port of the variable message sign device.  */
    port!: number;
    /** Represents the internal id to choose the sign  */
    internalSignId?: string | undefined;
    /** Represents the memory address in the sign to use to display the message  */
    messageStorageAddress?: string | undefined;
    /** Represents the maximum amount of characters that can be displayed in one line on the sign.  */
    maxCharPerLine!: number;
    /** Represents the maximum amount of lines that can be displayed on the sign.  */
    maxLines!: number;
    /** Represents the current message that is displayed.  */
    currentMessage?: string | undefined;
    /** Represents the buffered messaged that will be displayed next.  */
    inputMessage?: string | undefined;

    constructor(data?: IVariableMessageSign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.location = data["location"] ? Coordinate.fromJS(data["location"]) : <any>undefined;
            this.markerId = data["markerId"];
            this.ipAddress = data["ipAddress"];
            this.port = data["port"];
            this.internalSignId = data["internalSignId"];
            this.messageStorageAddress = data["messageStorageAddress"];
            this.maxCharPerLine = data["maxCharPerLine"];
            this.maxLines = data["maxLines"];
            this.currentMessage = data["currentMessage"];
            this.inputMessage = data["inputMessage"];
        }
    }

    static fromJS(data: any): VariableMessageSign {
        data = typeof data === 'object' ? data : {};
        let result = new VariableMessageSign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["markerId"] = this.markerId;
        data["ipAddress"] = this.ipAddress;
        data["port"] = this.port;
        data["internalSignId"] = this.internalSignId;
        data["messageStorageAddress"] = this.messageStorageAddress;
        data["maxCharPerLine"] = this.maxCharPerLine;
        data["maxLines"] = this.maxLines;
        data["currentMessage"] = this.currentMessage;
        data["inputMessage"] = this.inputMessage;
        return data; 
    }
}

/** VariableMessageSign represents a physical variable message sign that can display a message. */
export interface IVariableMessageSign {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in */
    groups?: string[] | undefined;
    /** Represents the location of this variable message sign. */
    location?: Coordinate | undefined;
    /** Represents the identifier of the `Marker` that is generated upon creation of the alarm with `Location` filled. */
    markerId?: string | undefined;
    /** Represents the IP Address of the variable message sign device.  */
    ipAddress: string;
    /** Represents the port of the variable message sign device.  */
    port: number;
    /** Represents the internal id to choose the sign  */
    internalSignId?: string | undefined;
    /** Represents the memory address in the sign to use to display the message  */
    messageStorageAddress?: string | undefined;
    /** Represents the maximum amount of characters that can be displayed in one line on the sign.  */
    maxCharPerLine: number;
    /** Represents the maximum amount of lines that can be displayed on the sign.  */
    maxLines: number;
    /** Represents the current message that is displayed.  */
    currentMessage?: string | undefined;
    /** Represents the buffered messaged that will be displayed next.  */
    inputMessage?: string | undefined;
}

/** SipPhoneConfiguration represents the configuration required for a client to connect to the SIP server and call `SipPhoneContacts` */
export class SipPhoneConfiguration implements ISipPhoneConfiguration {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in.  */
    groups?: string[] | undefined;
    /** Represents the identifier of the associated `passport` of this sip phone configuration.  */
    passportId!: string;
    /** Represents the registrar server address.  */
    regDomain!: string;
    /** Represents the registration username.  */
    regUser!: string;
    /** Represents the registration password.  */
    regPass!: string;
    /** Defines the expiration timeout for registration.  */
    regExpire!: number;
    /** Represents the authentication id.  */
    regAuthId?: string | undefined;
    /** Represents the realm associated to the username and password.  */
    regRealm?: string | undefined;
    /** Represents the outbound proxy domain.  */
    proxyDomain?: string | undefined;
    /** Represents the outbound proxy username.  */
    proxyUser?: string | undefined;
    /** Represents the outbound proxy password.  */
    proxyPass?: string | undefined;
    /** Define if all requests should be forced into the outbound proxy.  */
    proxyForceForAllRequests!: number;
    /** Represents the string placed in the SIP INVITE message with "UserAgent" header.  */
    userAgent?: string | undefined;
    /** Represents the displayed name when calling other SIP enabled devices.  */
    callerId?: string | undefined;
    /** Defines wether echo cancellation is enabled.  */
    echoCancelationEnabled!: number;
    /** Defines wether noise reduction is enabled.  */
    noiseReductionEnabled!: number;
    /** Defines wether auto gain control is enabled.  */
    autoGainControlEnabled!: number;
    /** Allows to set local port number, which the client will use to send/receive SIP requests. */
    listenPort!: number;
    /** Represents the STUN server ip address. */
    stunServer?: string | undefined;

    constructor(data?: ISipPhoneConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.passportId = data["passportId"];
            this.regDomain = data["regDomain"];
            this.regUser = data["regUser"];
            this.regPass = data["regPass"];
            this.regExpire = data["regExpire"];
            this.regAuthId = data["regAuthId"];
            this.regRealm = data["regRealm"];
            this.proxyDomain = data["proxyDomain"];
            this.proxyUser = data["proxyUser"];
            this.proxyPass = data["proxyPass"];
            this.proxyForceForAllRequests = data["proxyForceForAllRequests"];
            this.userAgent = data["userAgent"];
            this.callerId = data["callerId"];
            this.echoCancelationEnabled = data["echoCancelationEnabled"];
            this.noiseReductionEnabled = data["noiseReductionEnabled"];
            this.autoGainControlEnabled = data["autoGainControlEnabled"];
            this.listenPort = data["listenPort"];
            this.stunServer = data["stunServer"];
        }
    }

    static fromJS(data: any): SipPhoneConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new SipPhoneConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["passportId"] = this.passportId;
        data["regDomain"] = this.regDomain;
        data["regUser"] = this.regUser;
        data["regPass"] = this.regPass;
        data["regExpire"] = this.regExpire;
        data["regAuthId"] = this.regAuthId;
        data["regRealm"] = this.regRealm;
        data["proxyDomain"] = this.proxyDomain;
        data["proxyUser"] = this.proxyUser;
        data["proxyPass"] = this.proxyPass;
        data["proxyForceForAllRequests"] = this.proxyForceForAllRequests;
        data["userAgent"] = this.userAgent;
        data["callerId"] = this.callerId;
        data["echoCancelationEnabled"] = this.echoCancelationEnabled;
        data["noiseReductionEnabled"] = this.noiseReductionEnabled;
        data["autoGainControlEnabled"] = this.autoGainControlEnabled;
        data["listenPort"] = this.listenPort;
        data["stunServer"] = this.stunServer;
        return data; 
    }
}

/** SipPhoneConfiguration represents the configuration required for a client to connect to the SIP server and call `SipPhoneContacts` */
export interface ISipPhoneConfiguration {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in.  */
    groups?: string[] | undefined;
    /** Represents the identifier of the associated `passport` of this sip phone configuration.  */
    passportId: string;
    /** Represents the registrar server address.  */
    regDomain: string;
    /** Represents the registration username.  */
    regUser: string;
    /** Represents the registration password.  */
    regPass: string;
    /** Defines the expiration timeout for registration.  */
    regExpire: number;
    /** Represents the authentication id.  */
    regAuthId?: string | undefined;
    /** Represents the realm associated to the username and password.  */
    regRealm?: string | undefined;
    /** Represents the outbound proxy domain.  */
    proxyDomain?: string | undefined;
    /** Represents the outbound proxy username.  */
    proxyUser?: string | undefined;
    /** Represents the outbound proxy password.  */
    proxyPass?: string | undefined;
    /** Define if all requests should be forced into the outbound proxy.  */
    proxyForceForAllRequests: number;
    /** Represents the string placed in the SIP INVITE message with "UserAgent" header.  */
    userAgent?: string | undefined;
    /** Represents the displayed name when calling other SIP enabled devices.  */
    callerId?: string | undefined;
    /** Defines wether echo cancellation is enabled.  */
    echoCancelationEnabled: number;
    /** Defines wether noise reduction is enabled.  */
    noiseReductionEnabled: number;
    /** Defines wether auto gain control is enabled.  */
    autoGainControlEnabled: number;
    /** Allows to set local port number, which the client will use to send/receive SIP requests. */
    listenPort: number;
    /** Represents the STUN server ip address. */
    stunServer?: string | undefined;
}

/** SipPhoneContacts represents callable contacts stored in the SIP server. */
export class SipPhoneContact implements ISipPhoneContact {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in.  */
    groups?: string[] | undefined;
    /** Represents the location of the SIP phone.  */
    location?: Coordinate | undefined;
    /** Represents the identifier of the `Marker` that is generated upon creation of the SIP phone contact with `Location` filled.  */
    markerId?: string | undefined;
    /** Represents the callable number of the SIP device.  */
    address?: string | undefined;
    /** Represents additional details to be displayed for this SIP device.  */
    details?: string | undefined;

    constructor(data?: ISipPhoneContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.location = data["location"] ? Coordinate.fromJS(data["location"]) : <any>undefined;
            this.markerId = data["markerId"];
            this.address = data["address"];
            this.details = data["details"];
        }
    }

    static fromJS(data: any): SipPhoneContact {
        data = typeof data === 'object' ? data : {};
        let result = new SipPhoneContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["markerId"] = this.markerId;
        data["address"] = this.address;
        data["details"] = this.details;
        return data; 
    }
}

/** SipPhoneContacts represents callable contacts stored in the SIP server. */
export interface ISipPhoneContact {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in.  */
    groups?: string[] | undefined;
    /** Represents the location of the SIP phone.  */
    location?: Coordinate | undefined;
    /** Represents the identifier of the `Marker` that is generated upon creation of the SIP phone contact with `Location` filled.  */
    markerId?: string | undefined;
    /** Represents the callable number of the SIP device.  */
    address?: string | undefined;
    /** Represents additional details to be displayed for this SIP device.  */
    details?: string | undefined;
}

/** Notifications are used to notify clients of a specific event, they can follow a notification type to be displayed differently by the clients. */
export class Notification implements INotification {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the creation date of this notification.  */
    creationDate!: Date;
    /** Represents the identifier of the `notificationType`.  */
    type?: string | undefined;
    /** Represents the title shown to clients for this notification.  */
    title?: string | undefined;
    /** Represents the content that should be displayed upon viewing details of this notification.  */
    content?: string | undefined;
    /** Represents the location that this notification wants to emphasize.  */
    location?: Coordinate | undefined;
    /** Represents the identifiers of the passports that should receive and view this notification.  */
    recipients?: string[] | undefined;

    constructor(data?: INotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.creationDate = data["creationDate"] ? new Date(data["creationDate"].toString()) : <any>undefined;
            this.type = data["type"];
            this.title = data["title"];
            this.content = data["content"];
            this.location = data["location"] ? Coordinate.fromJS(data["location"]) : <any>undefined;
            if (data["recipients"] && data["recipients"].constructor === Array) {
                this.recipients = [];
                for (let item of data["recipients"])
                    this.recipients.push(item);
            }
        }
    }

    static fromJS(data: any): Notification {
        data = typeof data === 'object' ? data : {};
        let result = new Notification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["title"] = this.title;
        data["content"] = this.content;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (this.recipients && this.recipients.constructor === Array) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        return data; 
    }
}

/** Notifications are used to notify clients of a specific event, they can follow a notification type to be displayed differently by the clients. */
export interface INotification {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the creation date of this notification.  */
    creationDate: Date;
    /** Represents the identifier of the `notificationType`.  */
    type?: string | undefined;
    /** Represents the title shown to clients for this notification.  */
    title?: string | undefined;
    /** Represents the content that should be displayed upon viewing details of this notification.  */
    content?: string | undefined;
    /** Represents the location that this notification wants to emphasize.  */
    location?: Coordinate | undefined;
    /** Represents the identifiers of the passports that should receive and view this notification.  */
    recipients?: string[] | undefined;
}

/** NotificationTypes are user defined types of notifications that can have associated image, sound, and color to be displayed by clients. */
export class NotificationType implements INotificationType {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this type of notification.  */
    name?: string | undefined;
    /** Defines the color that should be displayed upon reception of this type of notification.  */
    color?: string | undefined;
    /** Defines the sound that should be played upon reception of this type of notification.  */
    soundFile?: NotificationTypeFile | undefined;
    /** Defines the image that should be displayed upon reception of this type of notification.  */
    imageFile?: NotificationTypeFile | undefined;

    constructor(data?: INotificationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.color = data["color"];
            this.soundFile = data["soundFile"] ? NotificationTypeFile.fromJS(data["soundFile"]) : <any>undefined;
            this.imageFile = data["imageFile"] ? NotificationTypeFile.fromJS(data["imageFile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationType {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["color"] = this.color;
        data["soundFile"] = this.soundFile ? this.soundFile.toJSON() : <any>undefined;
        data["imageFile"] = this.imageFile ? this.imageFile.toJSON() : <any>undefined;
        return data; 
    }
}

/** NotificationTypes are user defined types of notifications that can have associated image, sound, and color to be displayed by clients. */
export interface INotificationType {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the name of this type of notification.  */
    name?: string | undefined;
    /** Defines the color that should be displayed upon reception of this type of notification.  */
    color?: string | undefined;
    /** Defines the sound that should be played upon reception of this type of notification.  */
    soundFile?: NotificationTypeFile | undefined;
    /** Defines the image that should be displayed upon reception of this type of notification.  */
    imageFile?: NotificationTypeFile | undefined;
}

/** File stored in database. */
export class NotificationTypeFile implements INotificationTypeFile {
    /** Represents the identifier of the stored file.  */
    id?: string | undefined;
    /** Represents the name of the stored file.  */
    name?: string | undefined;

    constructor(data?: INotificationTypeFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): NotificationTypeFile {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTypeFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

/** File stored in database. */
export interface INotificationTypeFile {
    /** Represents the identifier of the stored file.  */
    id?: string | undefined;
    /** Represents the name of the stored file.  */
    name?: string | undefined;
}

/** Connectors are external software package allowing to integrate sub-systems into Constellation. */
export class Connector implements IConnector {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the Name of the connector, needs to be unique.  */
    name?: string | undefined;
    /** Represents the identifier of the `template` that this connector was created from.  */
    templateId?: string | undefined;
    /** Represents the capabilities active for this connector, can not have more capabilities than the connector's template.  */
    capabilities?: string[] | undefined;
    /** Represents the identifier of the `node` that this connector is deployed in, the node will be automatically decided by Constellation upon creation of the connector.  */
    nodeId?: string | undefined;
    /** Represents the platform of the machine that this connector is deployed in, the platform will be automatically decided by Constellation upon creation of the connector.  */
    platform?: string | undefined;
    /** Represents the configuration parameters of this connector, this object is polymorphic and follow the definition of it's `template`  */
    parameters?: any | undefined;

    constructor(data?: IConnector) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.templateId = data["templateId"];
            if (data["capabilities"] && data["capabilities"].constructor === Array) {
                this.capabilities = [];
                for (let item of data["capabilities"])
                    this.capabilities.push(item);
            }
            this.nodeId = data["nodeId"];
            this.platform = data["platform"];
            this.parameters = data["parameters"];
        }
    }

    static fromJS(data: any): Connector {
        data = typeof data === 'object' ? data : {};
        let result = new Connector();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["templateId"] = this.templateId;
        if (this.capabilities && this.capabilities.constructor === Array) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item);
        }
        data["nodeId"] = this.nodeId;
        data["platform"] = this.platform;
        data["parameters"] = this.parameters;
        return data; 
    }
}

/** Connectors are external software package allowing to integrate sub-systems into Constellation. */
export interface IConnector {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the Name of the connector, needs to be unique.  */
    name?: string | undefined;
    /** Represents the identifier of the `template` that this connector was created from.  */
    templateId?: string | undefined;
    /** Represents the capabilities active for this connector, can not have more capabilities than the connector's template.  */
    capabilities?: string[] | undefined;
    /** Represents the identifier of the `node` that this connector is deployed in, the node will be automatically decided by Constellation upon creation of the connector.  */
    nodeId?: string | undefined;
    /** Represents the platform of the machine that this connector is deployed in, the platform will be automatically decided by Constellation upon creation of the connector.  */
    platform?: string | undefined;
    /** Represents the configuration parameters of this connector, this object is polymorphic and follow the definition of it's `template`  */
    parameters?: any | undefined;
}

/** Nodes are external machines used to host the differents connectors to integrate external sub-systems. The nodes are automatically generated in constellation upon installation of a new Node Manager. */
export class Node implements INode {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the Url from where the `node` is reachable from Constellation.  */
    url?: string | undefined;
    /** Represents the platform of the `node`, can be `linux` or `windows`.  */
    platform?: string | undefined;

    constructor(data?: INode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.url = data["url"];
            this.platform = data["platform"];
        }
    }

    static fromJS(data: any): Node {
        data = typeof data === 'object' ? data : {};
        let result = new Node();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["url"] = this.url;
        data["platform"] = this.platform;
        return data; 
    }
}

/** Nodes are external machines used to host the differents connectors to integrate external sub-systems. The nodes are automatically generated in constellation upon installation of a new Node Manager. */
export interface INode {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the Url from where the `node` is reachable from Constellation.  */
    url?: string | undefined;
    /** Represents the platform of the `node`, can be `linux` or `windows`.  */
    platform?: string | undefined;
}

/** API Management for Templates - Templates hold the connectors executables files and the configuration definitions to create a new connector and integrate an external sub-system. */
export class Template implements ITemplate {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the of the subsystem this template can integrate. */
    name?: string | undefined;
    /** Represents a small description of this template's connector. */
    description?: string | undefined;
    /** Represents all the ports used by the subsystem's to do automatic ports scan discovery. */
    softwarePorts?: number[] | undefined;
    /** Represents the parameters that can be accepted by the connector executable. */
    parameters?: any | undefined;
    /** Represents the capabilities this connector include. */
    capabilities?: string[] | undefined;
    /** Represents the categories this template fall into. */
    categories?: string[] | undefined;
    /** Represents the platform this connector can be ran on (`windows` or `linux`). */
    platform?: string | undefined;
    /** Defines the sub-system's publisher contact informations. */
    publisher?: Publisher | undefined;
    /** Internal Id of the .ccp file.  */
    fileId?: string | undefined;

    constructor(data?: ITemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(item);
            }
            this.name = data["name"];
            this.description = data["description"];
            if (data["softwarePorts"] && data["softwarePorts"].constructor === Array) {
                this.softwarePorts = [];
                for (let item of data["softwarePorts"])
                    this.softwarePorts.push(item);
            }
            this.parameters = data["parameters"];
            if (data["capabilities"] && data["capabilities"].constructor === Array) {
                this.capabilities = [];
                for (let item of data["capabilities"])
                    this.capabilities.push(item);
            }
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [];
                for (let item of data["categories"])
                    this.categories.push(item);
            }
            this.platform = data["platform"];
            this.publisher = data["publisher"] ? Publisher.fromJS(data["publisher"]) : <any>undefined;
            this.fileId = data["fileId"];
        }
    }

    static fromJS(data: any): Template {
        data = typeof data === 'object' ? data : {};
        let result = new Template();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["name"] = this.name;
        data["description"] = this.description;
        if (this.softwarePorts && this.softwarePorts.constructor === Array) {
            data["softwarePorts"] = [];
            for (let item of this.softwarePorts)
                data["softwarePorts"].push(item);
        }
        data["parameters"] = this.parameters;
        if (this.capabilities && this.capabilities.constructor === Array) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item);
        }
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        data["platform"] = this.platform;
        data["publisher"] = this.publisher ? this.publisher.toJSON() : <any>undefined;
        data["fileId"] = this.fileId;
        return data; 
    }
}

/** API Management for Templates - Templates hold the connectors executables files and the configuration definitions to create a new connector and integrate an external sub-system. */
export interface ITemplate {
    /** Unique identifier representing the Entity in database. */
    id?: string | undefined;
    /** Represents the groups that this entity is contained in. */
    groups?: string[] | undefined;
    /** Represents the of the subsystem this template can integrate. */
    name?: string | undefined;
    /** Represents a small description of this template's connector. */
    description?: string | undefined;
    /** Represents all the ports used by the subsystem's to do automatic ports scan discovery. */
    softwarePorts?: number[] | undefined;
    /** Represents the parameters that can be accepted by the connector executable. */
    parameters?: any | undefined;
    /** Represents the capabilities this connector include. */
    capabilities?: string[] | undefined;
    /** Represents the categories this template fall into. */
    categories?: string[] | undefined;
    /** Represents the platform this connector can be ran on (`windows` or `linux`). */
    platform?: string | undefined;
    /** Defines the sub-system's publisher contact informations. */
    publisher?: Publisher | undefined;
    /** Internal Id of the .ccp file.  */
    fileId?: string | undefined;
}

/** Defines the sub-system's publisher contact informations. */
export class Publisher implements IPublisher {
    /** Represents the name of the company creating the subsystem.  */
    name?: string | undefined;
    /** Represents the website of the subsystem's company.  */
    website?: string | undefined;
    /** Represents the contact email of the subsystem's company.  */
    email?: string | undefined;

    constructor(data?: IPublisher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.website = data["website"];
            this.email = data["email"];
        }
    }

    static fromJS(data: any): Publisher {
        data = typeof data === 'object' ? data : {};
        let result = new Publisher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["website"] = this.website;
        data["email"] = this.email;
        return data; 
    }
}

/** Defines the sub-system's publisher contact informations. */
export interface IPublisher {
    /** Represents the name of the company creating the subsystem.  */
    name?: string | undefined;
    /** Represents the website of the subsystem's company.  */
    website?: string | undefined;
    /** Represents the contact email of the subsystem's company.  */
    email?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if(result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}